import React, {useState, useEffect, useRef, useMemo} from 'react'; // Component, useCallback // const { useState, useEffect, useRef } = React; 
import { Auth } from 'aws-amplify'; //Amplify, { Auth, Hub }
// import * as JWT from 'jwt-decode';
import logo from '../logo.png';
// import { Collapse, Popover, Toast, Tooltip, Alert, Modal, Dropdown } from 'bootstrap'; // const { Collapse, Popover, Toast, Tooltip, Alert, Modal, Dropdown } = bootstrap
import SplitPane from 'react-split-pane'; // , { Pane }
// import Pane from 'react-split-pane/lib/Pane';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { Formik, Form, Field, FieldArray, ErrorMessage } from 'formik';
import * as Yup from 'yup';

import { Switch, Route, useHistory, useParams, useRouteMatch, useLocation } from 'react-router-dom';
import { withRouter } from 'react-router';
import toast from 'react-hot-toast';

// import variantFormatDefinition from '../resources/OutputDefinitionRareDiseaseGRCh38.json';
//! BH import variantFormatDefinition from '../resources/OutputDefinitionRareDiseaseGRCh38.json';

import UserPane from '../components/UserPane'
import VariantViewer from '../components/VariantViewer'
// import SnvViewer from '../components/SnvViewer'
import CnvViewer from '../components/CnvViewer'
import MTViewer from '../components/MTViewer'
import FusViewer from '../components/FusViewer'
import CaseInfoCard from '../components/CaseInfoCard'
import CaseTable from './CaseTable'
import SvViewer from '../components/SvViewer'
import {GetSignedURL, AnalysisTypeOptions, CaseStatusOptions, GetSampleRank, getAnalysisDate, tsvToArray} from '../HelperFunctions' // EditableCell
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable'; // Creatable, { makeCreatableSelect } 

import genes_to_ids from "../resources/GRCh38.p14_Genenames_to_IDs.json";
import EpilepsyGeneList from '../resources/epilepsyGeneList.json';
import OhioNBSGeneList from '../resources/ohioNBSGeneList.json';
import cfmGenes from '../resources/cfmGenes.json';
import nmGenes from '../resources/neuroGenes.json';
// import searchResult from '../searchres.csv';

// import pData from "../RD0386_P_CNV.jsonl"
// import mData from "../RD0386_M_CNV.jsonl"
// import fData from "../RD0386_F_CNV.jsonl"

import db_json from '../logo.png';
// import myData from '../logo.png';
// import db_json from '../RDdb.json'; 
// import myData from '../CD200129_ETL_JSONL.txt';
// import myData from '../epilepsy.txt';
//! var geneSearch = '"var_index","chromosome","position","stop_position","ref","alt","inherit_model","qual","filter","gene","entrez_id","loc_in_gene","dist_to_splice_site","dist_to_coding_region","effect","impact","mane_hgvs","hgvs","information","igm_clinical_exome_alt_sample_count","igm_clinical_exome_total_sample_count","igm_clinical_exome_alt_sample_fraction","gnomad_wg_faf95_popmax","gnomad_ex_faf95_popmax","gnomad_wg_ac","gnomad_ex_ac","gnomad_ex_nhomalt","gnomad_wg_nhomalt","intervar","dbsnp_id","mim_number","omim_phenotypes","orphanet_display_summary","clinvar_clnsig","clinvar_clndn","clinvar_clnrevstat_criteria","clinvar_id","clinvar_clnsigconf","clinvar_clnrevstat","cosmic_ids","cosmic_sites","mgi_id","hpo_id","hpo_label","dbnsfp_cadd_raw","dbnsfp_cadd_phred","samples","case_id"\n"2","6","11105147","11105147","C","A",,"941.29","","ERVFRD-1","405754","coding_sequence",,,"nonsynonymous SNV","MODERATE","NM_207582.3(ERVFRD-1):c.164G>T:p.Gly55Val;Lower Priority: NM_001135575.2>NM_001135575.2(SMIM13):c.76+10758C>A","NM_207582.3(ERVFRD-1):c.164G>T:p.Gly55Val",,"2.0","2022.0","9.891197E-4",,,,,,,,,"[610524]",,,,,,,,,,,"3045308.0",,,"0.906444","10.5","{cd200123_a416_m_01d=null, cd200123_a417_f_01d=null, cd200123_a415_p_01d=null, rd200123_a418_s_01d=null, cd200124_a420_m_01d=null, rd200124_a422_b_01d=null, cd200124_a421_f_01d=null, cd200124_a419_p_01d=null, cd200125_a424_m_01d=null, cd200125_a423_p_01d=null, cd200125_a425_f_01d=null, cd200126_a426_p_01d=null, cd200126_a428_f_01d=null, cd200126_a427_m_01d=null, cd200128_a433_m_01d=null, cd200128_a434_f_01d=null, cd200128_a432_p_01d=null, cd200129_a437_f_01d_s-2021-002816=null, rd200129_a438_x_01d_s-2021-011324=null, cd200129_a435_p_01d_s-2021-002804=null, cd200129_a436_m_01d_s-2020-008619=null, cd200133_a449_m_01d=null, cd200133_a448_p_01d=null, cd200133_a450_f_01d=null, cd200137_a456_m_01d=null, cd200137_a455_p_01d=null, cd200137_a457_f_01d=null, cd200140_a465_m_01d_s-2021-009630=null, rd200140_a464_p_01d_s-2021-009631=null, cd200140_a466_f_01d_s-2021-009628=null, rd160001_a004_s_01d=null, rd160001_a001_p_01d=null, rd160001_a003_f_01d=null, rd160001_a002_m_01d=null, rd170024_a083_m_01d=null, rd170024_a082_p_01d=null, rd170024_a084_f_01d=null, rd180061_a215_p_01d-rd180061_a215_p_02d=null, rd180061_a216_m_01d-rd180061_a216_m_02d=null, rd180061_a217_f_01d=null, rd190072_a258_s_01d=null, rd190072_a255_p_01d=null, rd190072_a257_f_01d=null, rd190072_a256_m_01d=null, rd190093_a312_p_01d_s-2021-011318={td=38, gt_raw=0/0, rd=38, ad=0, gq=99, pl=0,103,1374, dp=38, gt=ref}, rd190093_a313_m_01d_s-2021-011319={td=73, gt_raw=0|1, rd=47, ad=26, gq=99, pl=950,0,1895, dp=74, gt=het}, rd190093_a314_f_01d_s-2021-011320={td=43, gt_raw=0/0, rd=43, ad=0, gq=99, pl=0,112,1577, dp=43, gt=ref}, rd200110_a379_m_01d_s-2021-011322=null, rd200110_a378_p_01d_s-2021-011321=null, rd200110_a380_f_01d_s-2021-011323=null, rd200117_a398_p_01d=null, rd200117_a399_m_01d=null, rd200117_a400_f_01d=null, rd200120_a408_f_01d=null, rd200120_a406_p_01d=null, rd200120_a407_m_01d=null, rd200121_a410_m_01d=null, rd200121_a409_p_01d=null, rd200121_a411_f_01d=null, rd200122_a412_p_01d=null, rd200122_a414_f_01d=null, rd200122_a413_m_01d=null, rd200127_a430_m_01d=null, rd200127_a429_p_01d=null, rd200127_a431_f_01d=null, rd200131_a442_p_01d=null, rd200132_a445_p_01d=null, rd200132_a446_m_01d=null, rd200132_a447_f_01d=null}","RD190093"\n"3","6","11104879","11104879","G","A",,"448.29","","ERVFRD-1","405754","coding_sequence",,,"synonymous SNV","LOW","NM_207582.3(ERVFRD-1):c.432C>T:p.Val144Val;Lower Priority: NM_001135575.2>NM_001135575.2(SMIM13):c.76+10490G>A","NM_207582.3(ERVFRD-1):c.432C>T:p.Val144Val",,"3.0","2022.0","0.0014836795",,,,,,,,,"[610524]",,,,,,,,,,,"3045308.0",,,,,"{cd200123_a416_m_01d=null, cd200123_a417_f_01d=null, cd200123_a415_p_01d=null, rd200123_a418_s_01d=null, cd200124_a420_m_01d=null, rd200124_a422_b_01d=null, cd200124_a421_f_01d=null, cd200124_a419_p_01d=null, cd200125_a424_m_01d=null, cd200125_a423_p_01d=null, cd200125_a425_f_01d=null, cd200126_a426_p_01d=null, cd200126_a428_f_01d=null, cd200126_a427_m_01d=null, cd200128_a433_m_01d=null, cd200128_a434_f_01d=null, cd200128_a432_p_01d=null, cd200129_a437_f_01d_s-2021-002816=null, rd200129_a438_x_01d_s-2021-011324=null, cd200129_a435_p_01d_s-2021-002804=null, cd200129_a436_m_01d_s-2020-008619=null, cd200133_a449_m_01d=null, cd200133_a448_p_01d=null, cd200133_a450_f_01d=null, cd200137_a456_m_01d=null, cd200137_a455_p_01d=null, cd200137_a457_f_01d=null, cd200140_a465_m_01d_s-2021-009630=null, rd200140_a464_p_01d_s-2021-009631=null, cd200140_a466_f_01d_s-2021-009628=null, rd160001_a004_s_01d=null, rd160001_a001_p_01d=null, rd160001_a003_f_01d=null, rd160001_a002_m_01d=null, rd170024_a083_m_01d=null, rd170024_a082_p_01d=null, rd170024_a084_f_01d=null, rd180061_a215_p_01d-rd180061_a215_p_02d=null, rd180061_a216_m_01d-rd180061_a216_m_02d=null, rd180061_a217_f_01d=null, rd190072_a258_s_01d=null, rd190072_a255_p_01d=null, rd190072_a257_f_01d=null, rd190072_a256_m_01d=null, rd190093_a312_p_01d_s-2021-011318={td=37, gt_raw=0/0, rd=37, ad=0, gq=99, pl=0,99,1460, dp=37, gt=ref}, rd190093_a313_m_01d_s-2021-011319={td=55, gt_raw=0|1, rd=41, ad=14, gq=99, pl=457,0,1679, dp=58, gt=het}, rd190093_a314_f_01d_s-2021-011320={td=36, gt_raw=0/0, rd=36, ad=0, gq=99, pl=0,99,1485, dp=36, gt=ref}, rd200110_a379_m_01d_s-2021-011322=null, rd200110_a378_p_01d_s-2021-011321=null, rd200110_a380_f_01d_s-2021-011323=null, rd200117_a398_p_01d=null, rd200117_a399_m_01d=null, rd200117_a400_f_01d=null, rd200120_a408_f_01d=null, rd200120_a406_p_01d=null, rd200120_a407_m_01d=null, rd200121_a410_m_01d=null, rd200121_a409_p_01d=null, rd200121_a411_f_01d=null, rd200122_a412_p_01d=null, rd200122_a414_f_01d=null, rd200122_a413_m_01d=null, rd200127_a430_m_01d=null, rd200127_a429_p_01d=null, rd200127_a431_f_01d=null, rd200131_a442_p_01d=null, rd200132_a445_p_01d=null, rd200132_a446_m_01d=null, rd200132_a447_f_01d=null}","RD190093"\n"4","6","11104956","11104956","G","A",,"386.29","","ERVFRD-1","405754","coding_sequence",,,"synonymous SNV","LOW","NM_207582.3(ERVFRD-1):c.355C>T:p.Leu119Leu;Lower Priority: NM_001135575.2>NM_001135575.2(SMIM13):c.76+10567G>A","NM_207582.3(ERVFRD-1):c.355C>T:p.Leu119Leu",,"1.0","2022.0","4.945598E-4",,,,,,,,,"[610524]",,,,,,,,,,,"3045308.0",,,,,"{cd200123_a416_m_01d=null, cd200123_a417_f_01d=null, cd200123_a415_p_01d=null, rd200123_a418_s_01d=null, cd200124_a420_m_01d=null, rd200124_a422_b_01d=null, cd200124_a421_f_01d=null, cd200124_a419_p_01d=null, cd200125_a424_m_01d=null, cd200125_a423_p_01d=null, cd200125_a425_f_01d=null, cd200126_a426_p_01d=null, cd200126_a428_f_01d=null, cd200126_a427_m_01d=null, cd200128_a433_m_01d=null, cd200128_a434_f_01d=null, cd200128_a432_p_01d=null, cd200129_a437_f_01d_s-2021-002816=null, rd200129_a438_x_01d_s-2021-011324=null, cd200129_a435_p_01d_s-2021-002804=null, cd200129_a436_m_01d_s-2020-008619=null, cd200133_a449_m_01d=null, cd200133_a448_p_01d=null, cd200133_a450_f_01d=null, cd200137_a456_m_01d=null, cd200137_a455_p_01d=null, cd200137_a457_f_01d=null, cd200140_a465_m_01d_s-2021-009630=null, rd200140_a464_p_01d_s-2021-009631=null, cd200140_a466_f_01d_s-2021-009628=null, rd160001_a004_s_01d=null, rd160001_a001_p_01d=null, rd160001_a003_f_01d=null, rd160001_a002_m_01d=null, rd170024_a083_m_01d=null, rd170024_a082_p_01d=null, rd170024_a084_f_01d=null, rd180061_a215_p_01d-rd180061_a215_p_02d=null, rd180061_a216_m_01d-rd180061_a216_m_02d=null, rd180061_a217_f_01d=null, rd190072_a258_s_01d=null, rd190072_a255_p_01d=null, rd190072_a257_f_01d=null, rd190072_a256_m_01d=null, rd190093_a312_p_01d_s-2021-011318={td=37, gt_raw=0/0, rd=37, ad=0, gq=99, pl=0,99,1460, dp=37, gt=ref}, rd190093_a313_m_01d_s-2021-011319={td=63, gt_raw=0|1, rd=50, ad=13, gq=99, pl=395,0,2060, dp=63, gt=het}, rd190093_a314_f_01d_s-2021-011320={td=36, gt_raw=0/0, rd=36, ad=0, gq=99, pl=0,102,1530, dp=36, gt=ref}, rd200110_a379_m_01d_s-2021-011322=null, rd200110_a378_p_01d_s-2021-011321=null, rd200110_a380_f_01d_s-2021-011323=null, rd200117_a398_p_01d=null, rd200117_a399_m_01d=null, rd200117_a400_f_01d=null, rd200120_a408_f_01d=null, rd200120_a406_p_01d=null, rd200120_a407_m_01d=null, rd200121_a410_m_01d=null, rd200121_a409_p_01d=null, rd200121_a411_f_01d=null, rd200122_a412_p_01d=null, rd200122_a414_f_01d=null, rd200122_a413_m_01d=null, rd200127_a430_m_01d=null, rd200127_a429_p_01d=null, rd200127_a431_f_01d=null, rd200131_a442_p_01d=null, rd200132_a445_p_01d=null, rd200132_a446_m_01d=null, rd200132_a447_f_01d=null}","RD190093"';
//! {cd200123_a416_m_01d=null, cd200123_a417_f_01d=null, cd200123_a415_p_01d=null, rd200123_a418_s_01d=null, cd200124_a420_m_01d=null, rd200124_a422_b_01d=null, cd200124_a421_f_01d=null, cd200124_a419_p_01d=null, cd200125_a424_m_01d=null, cd200125_a423_p_01d=null, cd200125_a425_f_01d=null, cd200126_a426_p_01d=null, cd200126_a428_f_01d=null, cd200126_a427_m_01d=null, cd200128_a433_m_01d=null, cd200128_a434_f_01d=null, cd200128_a432_p_01d=null, cd200129_a437_f_01d_s-2021-002816={td=38, gt_raw=0/0, rd=38, ad=0, gq=99, pl=0,105,1575, dp=38, gt=ref}, rd200129_a438_x_01d_s-2021-011324={td=27, gt_raw=0/0, rd=27, ad=0, gq=69, pl=0,69,1035, dp=27, gt=ref}, cd200129_a435_p_01d_s-2021-002804={td=31, gt_raw=0/0, rd=31, ad=0, gq=90, pl=0,90,1350, dp=31, gt=ref}, cd200129_a436_m_01d_s-2020-008619={td=18, gt_raw=0/1, rd=6, ad=12, gq=99, pl=371,0,171, dp=18, gt=het}, cd200133_a449_m_01d=null, cd200133_a448_p_01d=null, cd200133_a450_f_01d=null, cd200137_a456_m_01d=null, cd200137_a455_p_01d=null, cd200137_a457_f_01d=null}

// ToDo: check Roboto font 
// TODO: ERVFRD-1, after search it need to clean the results
// TODO: make sure to check for other URI in CNV and SV as well (e.g. Mother, Father, etc.) 

var request;
// const DEVMODE = (process.env.NODE_ENV==='development'); // const DEVMODE = false;
const ENDPOINT_BASE = process.env.REACT_APP_API_URI;
const MRPHENE_ENDPOINT_BASE = process.env.REACT_APP_MRPHENE_API_URI;

//! ---------------------------------------------   ----------------------------------
//! --------------------------------------------- Fix the db, affected is false for all, check t o make sur eno other formik is like that! ----------------------------------
//! ---------------------------------------------   ----------------------------------


//? --------------------------------------------- helper functions ----------------------------------


// ? readTextFile is only needed for local testing
var JSONLText='';
const readTextFile = (file) => {
  JSONLText='';
  let rawFile = new XMLHttpRequest();
  rawFile.open("GET", file, false);
  rawFile.onreadystatechange = function ()
  {
    if(rawFile.readyState === 4)
    {
      if(rawFile.status === 200 || rawFile.status === 0)
      {
        JSONLText=rawFile.responseText;
      }
    }
  }
  rawFile.send(null);
}

export const parse_JSONL = (input_text) => {
  // let lines = input_text.split(/\n/);
  // let wrapped = "[" + lines.join(",") + "]";
  // let obj = JSON.parse(wrapped);

  let myArray = [];
  //* remove the first /n if there is one and then process each line
  input_text.replace(/\n+$/,"").split('\n').forEach((value) => {
    try{
      if (value.length > 0){
        myArray.push(JSON.parse(value));
      }
    }
    catch(e){
      console.error('Error: excluded data =',value, e);
    }
  });
  return myArray;
}


const csvToArrayToJson = (text) => {
  // CSV to Array
  let p = '', row = [''], ret = [row], i = 0, r = 0, s = !0, l;
  for (l of text) {
    if ('"' === l) {
      if (s && l === p) row[i] += l;
      s = !s;
    }
    else if (',' === l && s) l = row[++i] = '';
    else if ('\n' === l && s) {
      if ('\r' === p) row[i] = row[i].slice(0, -1);
      row = ret[++r] = [l = '']; i = 0;
    }
    else row[i] += l;
    p = l;
  }
  // return ret;

  // Array to JSON
  let result = [];
  let headers = ret[0];
  for(i=1;i<ret.length;i++){
    let obj = {};
    for(let j=0;j<headers.length;j++){
      obj[headers[j].toUpperCase()] = ret[i][j]; //! had to change it to upper case -----
    }
    result.push(obj);
  }
  // TODO: need to convert these to JSON Object to be able to use variant table

  Object.keys(result).forEach( recordId => {
    if (!!result[recordId].SAMPLES) {
      // let text = '"var_index","chromosome","position","stop_position","ref","alt","inherit_model","qual","filter","gene","entrez_id","loc_in_gene","dist_to_splice_site","dist_to_coding_region","effect","impact","mane_hgvs","hgvs","information","igm_clinical_exome_alt_sample_count","igm_clinical_exome_total_sample_count","igm_clinical_exome_alt_sample_fraction","gnomad_wg_faf95_popmax","gnomad_ex_faf95_popmax","gnomad_wg_ac","gnomad_ex_ac","gnomad_ex_nhomalt","gnomad_wg_nhomalt","intervar","dbsnp_id","mim_number","omim_phenotypes","orphanet_display_summary","clinvar_clnsig","clinvar_clndn","clinvar_clnrevstat_criteria","clinvar_id","clinvar_clnsigconf","clinvar_clnrevstat","cosmic_ids","cosmic_sites","mgi_id","hpo_id","hpo_label","dbnsfp_cadd_raw","dbnsfp_cadd_phred","samples","case_id"\n"2","6","11105147","11105147","C","A",,"941.29","","ERVFRD-1","405754","coding_sequence",,,"nonsynonymous SNV","MODERATE","NM_207582.3(ERVFRD-1):c.164G>T:p.Gly55Val;Lower Priority: NM_001135575.2>NM_001135575.2(SMIM13):c.76+10758C>A","NM_207582.3(ERVFRD-1):c.164G>T:p.Gly55Val",,"2.0","2022.0","9.891197E-4",,,,,,,,,"[610524]",,,,,,,,,,,"3045308.0",,,"0.906444","10.5","{cd200123_a416_m_01d=null, cd200123_a417_f_01d=null, cd200123_a415_p_01d=null, rd200123_a418_s_01d=null, cd200124_a420_m_01d=null, rd200124_a422_b_01d=null, cd200124_a421_f_01d=null, cd200124_a419_p_01d=null, cd200125_a424_m_01d=null, cd200125_a423_p_01d=null, cd200125_a425_f_01d=null, cd200126_a426_p_01d=null, cd200126_a428_f_01d=null, cd200126_a427_m_01d=null, cd200128_a433_m_01d=null, cd200128_a434_f_01d=null, cd200128_a432_p_01d=null, cd200129_a437_f_01d_s-2021-002816=null, rd200129_a438_x_01d_s-2021-011324=null, cd200129_a435_p_01d_s-2021-002804=null, cd200129_a436_m_01d_s-2020-008619=null, cd200133_a449_m_01d=null, cd200133_a448_p_01d=null, cd200133_a450_f_01d=null, cd200137_a456_m_01d=null, cd200137_a455_p_01d=null, cd200137_a457_f_01d=null, cd200140_a465_m_01d_s-2021-009630=null, rd200140_a464_p_01d_s-2021-009631=null, cd200140_a466_f_01d_s-2021-009628=null, rd160001_a004_s_01d=null, rd160001_a001_p_01d=null, rd160001_a003_f_01d=null, rd160001_a002_m_01d=null, rd170024_a083_m_01d=null, rd170024_a082_p_01d=null, rd170024_a084_f_01d=null, rd180061_a215_p_01d-rd180061_a215_p_02d=null, rd180061_a216_m_01d-rd180061_a216_m_02d=null, rd180061_a217_f_01d=null, rd190072_a258_s_01d=null, rd190072_a255_p_01d=null, rd190072_a257_f_01d=null, rd190072_a256_m_01d=null, rd190093_a312_p_01d_s-2021-011318={td=38, gt_raw=0/0, rd=38, ad=0, gq=99, pl=0,103,1374, dp=38, gt=ref}, rd190093_a313_m_01d_s-2021-011319={td=73, gt_raw=0|1, rd=47, ad=26, gq=99, pl=950,0,1895, dp=74, gt=het}, rd190093_a314_f_01d_s-2021-011320={td=43, gt_raw=0/0, rd=43, ad=0, gq=99, pl=0,112,1577, dp=43, gt=ref}, rd200110_a379_m_01d_s-2021-011322=null, rd200110_a378_p_01d_s-2021-011321=null, rd200110_a380_f_01d_s-2021-011323=null, rd200117_a398_p_01d=null, rd200117_a399_m_01d=null, rd200117_a400_f_01d=null, rd200120_a408_f_01d=null, rd200120_a406_p_01d=null, rd200120_a407_m_01d=null, rd200121_a410_m_01d=null, rd200121_a409_p_01d=null, rd200121_a411_f_01d=null, rd200122_a412_p_01d=null, rd200122_a414_f_01d=null, rd200122_a413_m_01d=null, rd200127_a430_m_01d=null, rd200127_a429_p_01d=null, rd200127_a431_f_01d=null, rd200131_a442_p_01d=null, rd200132_a445_p_01d=null, rd200132_a446_m_01d=null, rd200132_a447_f_01d=null}","RD190093"\n"3","6","11104879","11104879","G","A",,"448.29","","ERVFRD-1","405754","coding_sequence",,,"synonymous SNV","LOW","NM_207582.3(ERVFRD-1):c.432C>T:p.Val144Val;Lower Priority: NM_001135575.2>NM_001135575.2(SMIM13):c.76+10490G>A","NM_207582.3(ERVFRD-1):c.432C>T:p.Val144Val",,"3.0","2022.0","0.0014836795",,,,,,,,,"[610524]",,,,,,,,,,,"3045308.0",,,,,"{cd200123_a416_m_01d=null, cd200123_a417_f_01d=null, cd200123_a415_p_01d=null, rd200123_a418_s_01d=null, cd200124_a420_m_01d=null, rd200124_a422_b_01d=null, cd200124_a421_f_01d=null, cd200124_a419_p_01d=null, cd200125_a424_m_01d=null, cd200125_a423_p_01d=null, cd200125_a425_f_01d=null, cd200126_a426_p_01d=null, cd200126_a428_f_01d=null, cd200126_a427_m_01d=null, cd200128_a433_m_01d=null, cd200128_a434_f_01d=null, cd200128_a432_p_01d=null, cd200129_a437_f_01d_s-2021-002816=null, rd200129_a438_x_01d_s-2021-011324=null, cd200129_a435_p_01d_s-2021-002804=null, cd200129_a436_m_01d_s-2020-008619=null, cd200133_a449_m_01d=null, cd200133_a448_p_01d=null, cd200133_a450_f_01d=null, cd200137_a456_m_01d=null, cd200137_a455_p_01d=null, cd200137_a457_f_01d=null, cd200140_a465_m_01d_s-2021-009630=null, rd200140_a464_p_01d_s-2021-009631=null, cd200140_a466_f_01d_s-2021-009628=null, rd160001_a004_s_01d=null, rd160001_a001_p_01d=null, rd160001_a003_f_01d=null, rd160001_a002_m_01d=null, rd170024_a083_m_01d=null, rd170024_a082_p_01d=null, rd170024_a084_f_01d=null, rd180061_a215_p_01d-rd180061_a215_p_02d=null, rd180061_a216_m_01d-rd180061_a216_m_02d=null, rd180061_a217_f_01d=null, rd190072_a258_s_01d=null, rd190072_a255_p_01d=null, rd190072_a257_f_01d=null, rd190072_a256_m_01d=null, rd190093_a312_p_01d_s-2021-011318={td=37, gt_raw=0/0, rd=37, ad=0, gq=99, pl=0,99,1460, dp=37, gt=ref}, rd190093_a313_m_01d_s-2021-011319={td=55, gt_raw=0|1, rd=41, ad=14, gq=99, pl=457,0,1679, dp=58, gt=het}, rd190093_a314_f_01d_s-2021-011320={td=36, gt_raw=0/0, rd=36, ad=0, gq=99, pl=0,99,1485, dp=36, gt=ref}, rd200110_a379_m_01d_s-2021-011322=null, rd200110_a378_p_01d_s-2021-011321=null, rd200110_a380_f_01d_s-2021-011323=null, rd200117_a398_p_01d=null, rd200117_a399_m_01d=null, rd200117_a400_f_01d=null, rd200120_a408_f_01d=null, rd200120_a406_p_01d=null, rd200120_a407_m_01d=null, rd200121_a410_m_01d=null, rd200121_a409_p_01d=null, rd200121_a411_f_01d=null, rd200122_a412_p_01d=null, rd200122_a414_f_01d=null, rd200122_a413_m_01d=null, rd200127_a430_m_01d=null, rd200127_a429_p_01d=null, rd200127_a431_f_01d=null, rd200131_a442_p_01d=null, rd200132_a445_p_01d=null, rd200132_a446_m_01d=null, rd200132_a447_f_01d=null}","RD190093"\n"4","6","11104956","11104956","G","A",,"386.29","","ERVFRD-1","405754","coding_sequence",,,"synonymous SNV","LOW","NM_207582.3(ERVFRD-1):c.355C>T:p.Leu119Leu;Lower Priority: NM_001135575.2>NM_001135575.2(SMIM13):c.76+10567G>A","NM_207582.3(ERVFRD-1):c.355C>T:p.Leu119Leu",,"1.0","2022.0","4.945598E-4",,,,,,,,,"[610524]",,,,,,,,,,,"3045308.0",,,,,"{cd200123_a416_m_01d=null, cd200123_a417_f_01d=null, cd200123_a415_p_01d=null, rd200123_a418_s_01d=null, cd200124_a420_m_01d=null, rd200124_a422_b_01d=null, cd200124_a421_f_01d=null, cd200124_a419_p_01d=null, cd200125_a424_m_01d=null, cd200125_a423_p_01d=null, cd200125_a425_f_01d=null, cd200126_a426_p_01d=null, cd200126_a428_f_01d=null, cd200126_a427_m_01d=null, cd200128_a433_m_01d=null, cd200128_a434_f_01d=null, cd200128_a432_p_01d=null, cd200129_a437_f_01d_s-2021-002816=null, rd200129_a438_x_01d_s-2021-011324=null, cd200129_a435_p_01d_s-2021-002804=null, cd200129_a436_m_01d_s-2020-008619=null, cd200133_a449_m_01d=null, cd200133_a448_p_01d=null, cd200133_a450_f_01d=null, cd200137_a456_m_01d=null, cd200137_a455_p_01d=null, cd200137_a457_f_01d=null, cd200140_a465_m_01d_s-2021-009630=null, rd200140_a464_p_01d_s-2021-009631=null, cd200140_a466_f_01d_s-2021-009628=null, rd160001_a004_s_01d=null, rd160001_a001_p_01d=null, rd160001_a003_f_01d=null, rd160001_a002_m_01d=null, rd170024_a083_m_01d=null, rd170024_a082_p_01d=null, rd170024_a084_f_01d=null, rd180061_a215_p_01d-rd180061_a215_p_02d=null, rd180061_a216_m_01d-rd180061_a216_m_02d=null, rd180061_a217_f_01d=null, rd190072_a258_s_01d=null, rd190072_a255_p_01d=null, rd190072_a257_f_01d=null, rd190072_a256_m_01d=null, rd190093_a312_p_01d_s-2021-011318={td=37, gt_raw=0/0, rd=37, ad=0, gq=99, pl=0,99,1460, dp=37, gt=ref}, rd190093_a313_m_01d_s-2021-011319={td=63, gt_raw=0|1, rd=50, ad=13, gq=99, pl=395,0,2060, dp=63, gt=het}, rd190093_a314_f_01d_s-2021-011320={td=36, gt_raw=0/0, rd=36, ad=0, gq=99, pl=0,102,1530, dp=36, gt=ref}, rd200110_a379_m_01d_s-2021-011322=null, rd200110_a378_p_01d_s-2021-011321=null, rd200110_a380_f_01d_s-2021-011323=null, rd200117_a398_p_01d=null, rd200117_a399_m_01d=null, rd200117_a400_f_01d=null, rd200120_a408_f_01d=null, rd200120_a406_p_01d=null, rd200120_a407_m_01d=null, rd200121_a410_m_01d=null, rd200121_a409_p_01d=null, rd200121_a411_f_01d=null, rd200122_a412_p_01d=null, rd200122_a414_f_01d=null, rd200122_a413_m_01d=null, rd200127_a430_m_01d=null, rd200127_a429_p_01d=null, rd200127_a431_f_01d=null, rd200131_a442_p_01d=null, rd200132_a445_p_01d=null, rd200132_a446_m_01d=null, rd200132_a447_f_01d=null}","RD190093"';
      // let text = "{cd200123_a416_m_01d=null, cd200123_a417_f_01d=null, cd200123_a415_p_01d=null, rd200123_a418_s_01d=null, cd200124_a420_m_01d=null, rd200124_a422_b_01d=null, cd200124_a421_f_01d=null, cd200124_a419_p_01d=null, cd200125_a424_m_01d=null, cd200125_a423_p_01d=null, cd200125_a425_f_01d=null, cd200126_a426_p_01d=null, cd200126_a428_f_01d=null, cd200126_a427_m_01d=null, cd200128_a433_m_01d={td=61, gt_raw=0/1, rd=30, ad=31, gq=99, pl=912,0,927, dp=61, gt=het}, cd200128_a434_f_01d={td=32, gt_raw=0/0, rd=32, ad=0, gq=90, pl=0,90,1202, dp=32, gt=ref}, cd200128_a432_p_01d={td=37, gt_raw=0/0, rd=37, ad=0, gq=99, pl=0,102,1283, dp=37, gt=ref}, cd200129_a437_f_01d_s-2021-002816=null, rd200129_a438_x_01d_s-2021-011324=null, cd200129_a435_p_01d_s-2021-002804=null, cd200129_a436_m_01d_s-2020-008619=null, cd200133_a449_m_01d=null, cd200133_a448_p_01d=null, cd200133_a450_f_01d=null, cd200137_a456_m_01d=null, cd200137_a455_p_01d=null, cd200137_a457_f_01d=null}"
      // let text = "{cd200123_a416_m_01d=null, cd200128_a433_m_01d={td=61, gt_raw=0/1, rd=30, ad=31, gq=99, pl=912,0,927, dp=61, gt=het}, cd200129_a437_f_01d_s-2021-002816=null}"
      // let correctJson = text.replace(/(['"])?([a-z0-9A-Z_]+)(['"])?:/g, '"$2": ');
      let correctJson = result[recordId].SAMPLES.toLowerCase();

      result[recordId].SAMPLES = {};
      // console.log(correctJson);

      correctJson = correctJson
        // .replace(/(['"])?([a-z0-9A-Z_,]+)(['"])?=([a-z0-9A-Z_]+)[,}]/g, '"$2":"$4" ')
        
        // .replace(/=([0-9]\/[0-9]),/g,'="$1",')
        // .replace(/=([a-z0-9A-Z_, ]+)=/g,'="$1"=')
        
        // .replace(/=((([a-z0-9A-Z_]+,){2,})[a-z0-9A-Z_]+), /g,'="$1", ')
        // .replace(/=([a-z0-9A-Z_, ]+),([a-z0-9A-Z_, ]+)=/g,'="$1", $2=')
        // .replace(/=( ([0-9]+,)+\/[0-9]),/g,'="$1",')
        
        .replace(/=([a-z0-9A-Z._,/]+)((, )|})/g,'="$1"$2')
        // Replace ":" with "@colon@" if it's between double-quotes
        .replace(/=/g, ':')

        // Replace ":" with "@colon@" if it's between double-quotes
        .replace(/:\s*"([^"]*)"/g, function(match, p1) {
          return ': "' + p1.replace(/:/g, '@colon@') + '"';
        })

        // Replace ":" with "@colon@" if it's between single-quotes
        .replace(/:\s*'([^']*)'/g, function(match, p1) {
          return ': "' + p1.replace(/:/g, '@colon@') + '"';
        })

        // Add double-quotes around any tokens before the remaining ":"
        .replace(/(['"])?([a-z0-9A-Z_-]+)(['"])?\s*:/g, '"$2": ')
        // .replace(/(['"])?([a-z0-9A-Z_]+)(['"])?:/g, '"$2": ')
        // .replace(/(['"])?([a-z0-9A-Z_]+)(['"])?:/g, '"$2": ')
        // .replace(/:([a-z0-9A-Z_]+)/g, ':"$1" ')

        // Turn "@colon@" back into ":"
        .replace(/@colon@/g, ':')
      ;

      // console.log(correctJson);
      // console.log(Object.values(JSON.parse(correctJson)).filter(t => t!="null"));
      // console.log(Object.keys(JSON.parse(correctJson)).filter(t => JSON.parse(correctJson)[t]!="null"));
      try {
        correctJson = JSON.parse(correctJson);
        // console.log(correctJson);
        Object.keys(correctJson).filter(t => correctJson[t]!=="null").forEach( sampleId => {
          let entries = Object.entries(correctJson[sampleId]);
          let capsEntries = entries.map((entry) => [entry[0].toUpperCase(), entry[1]]);
          // let capsEntries = entries.map((entry) => [entry[0].toUpperCase() + entry[0].slice(1), entry[1]]);
          let capsCorrectSample = Object.fromEntries(capsEntries);
          // console.log(capsCorrectSample);

          result[recordId].SAMPLES[sampleId.toUpperCase()]=capsCorrectSample;
        });
      }
      catch {
        toast.error("Error in parsing SAMPLES of " + result[recordId].CASE_ID);
      }
    }
  });
  // console.log(result);
  return result; //JavaScript object
  // return JSON.stringify(result); //JSON
}


export const downloadIndividualNote = (signedURL) => {   // , userName
  return new Promise(function (resolve, reject) {
    fetch(signedURL, {
      method: 'GET',
      mode: 'cors'
    })
    .then(response => {     
      if (!response.ok) { // if (status >= 200 && status < 300) {
        reject("HTTP error " + response.status);
      }
      const responseText = response.text();
      resolve(responseText);
      // if(!!userName){
      //   resolve([userName,responseText]);
      // } else{
      //   resolve(responseText);
      // }
    })
    .catch(e => {
      reject("Failed to fetch the data.", e); //! fix the error message!
    });
  });
}



//? --------------------------------------------- ProjectSpecificApp ----------------------------------


const ProjectSpecificApp = (props) => {

  let history = useHistory();
  let routeMatch = useRouteMatch(); // { path, url }
  const markedActiveCaseRef = useRef();
  const [devOptions, setDevOptions] = useState(false);  //! dev options

  const [dbSortedByCaseId, setDbSortedByCaseId] = useState(props.project!=="paradigm");
  const [projectDb, setProjectDb] = useState({});
  const [projectFilterSet, setProjectFilterSet] = useState(2);
  // const [projectSetPMFPrefix, setProjectSetPMFPrefix] = useState(true);
  const [openCases, setOpenCases] = useState([]);
  const [activeCaseIndexInOpenCases, setActiveCaseIndexInOpenCases] = useState(null);
  const [activeCaseId, setActiveCaseId] = useState('');
  const [activeCaseInfo, setActiveCaseInfo] = useState({});   // * it is like: {ID: 6, PROTOCOL: 'CD', CASE_ID: 'CD200129', CASE_STATUS: 0, N_SAMPLES: 4, …} see the end of doc for more info
  ////!!!!!  const [paradigmData, steParadigmData] = useState(null);

  const [isLoadingNotes, setIsLoadingNotes] = useState(false);
  const [loadMyNotes, steLoadMyNotes] = useState(true);
  const [loadExistingNotes, setLoadExistingNotes] = useState(false);
  const [isNoteScopeAllAnalysis, setIsNoteScopeAllAnalysis] = useState(false);
  const [reloadCaseData, setReloadCaseData] = useState(false);
  const [loadMrPheneSubjectData, setLoadMrPheneSubjectData] = useState(true);
  const [activeAnalysis, setActiveAnalysis] = useState('');

  const [viewAnalysis, setViewAnalysis] = useState(false);
  const [initialSortBy, setInitialSortBy] = useState([]);
  const [isLoadingCaseList, setIsLoadingCaseList] = useState(false);
  const [isLoadingCaseData, setIsLoadingCaseData] = useState(false);
  const [caseLoadingMessage, setCaseLoadingMessage] = useState('');
  const [caseLoadingProgress, setCaseLoadingProgress] = useState(0);
  
  // const [isClinical, setIsClinical] = useState(false);
  // const [isResearch, setIsResearch] = useState(false);

  const [searchBoxValue, setSearchBoxValue] = useState('');
  const [searchTermUsed, setSearchTermUsed] = useState('');
  const [isLoadingSearchResult, setIsLoadingSearchResult] = useState(false);
  const [isSearchResultReady, setIsSearchResultReady] = useState(false);
  const [searchResultToShowAsTable, setSearchResultToShowAsTable] = useState({});
  const [showSearchPanel, setShowSearchPanel] = useState(false);
  const [searchErrorMessage, setSearchErrorMessage] = useState('');
  const [clinVarPlotSrc, setClinVarPlotSrc] = useState('');

  const [pehnoSectionHeight, setPehnoSectionHeight] = useState(2);

  const [tempSearchResults, setTempSearchResults] = useState(null);
  const [searchHistory, setSearchHistory] = useState([]);
  const [selectedSearchType, setSelectedSearchType] = useState('');
  const searchTypes = [ 'ClinVar Plots', 'Genes', 'Variants' ];

  function parseQueryString(queryString) {
    // Strip the leading ? and tokenize
    const tokens = queryString.substring(1).split("&");

    const paramMap = {};
    tokens.forEach(token => {
      const keyValueArray = token.split("=");
      paramMap[keyValueArray[0]] = keyValueArray[1];
    });

    return paramMap;
  }

  const [shouldBlockNavigation, setShouldBlockNavigation] = useState(false);

  //  ! fix this , ---- -    tempSearchResults- -----------------------------
  useEffect(() => {
    // ! check later!:
    // (async () => { await processsXMLHttpRequestResultx()})();
 
    if(!!tempSearchResults){
      // let newSearchHistory=[...searchHistory, tempSearchResults]
      // // console.log('searchHistory');
      // // console.log(searchHistory);
      // // console.log('newSearchHistory');
      // // console.log(newSearchHistory);
      // setSearchHistory(newSearchHistory);

      // ! partially duplicated code , fix this!
      setIsLoadingSearchResult(false);
      setSearchErrorMessage('');
      // let prevSearchHistory = [...searchHistory]
      // prevSearchHistory.push({name:new Date().toLocaleString() + '', type:selectedSearchType, query:searchBoxValue, numberOfResults:searchResultJson.length, results:searchResultJson});
      // setSearchHistory(prevSearchHistory);

      // let resultColumns= prepareColumns(tempSearchResults[0], false); //! make the filter column unEditable
      // let hiddenCols = [];
      // if(!!resultColumns){
      //   Object.values(resultColumns).forEach(column => {
      //     if( (column.accessor==='FILTER') || 
      //         (column.accessor!=='CASE_ID' && 
      //         column.accessor!=='CHROMOSOME' && 
      //         !analysisDefaultVisibleColumns.includes(column.accessor) &&
      //         !column.accessor.endsWith('_GT')) 
      //       ){ // these columns should be hidden
      //       hiddenCols.push(column.accessor);
      //     }
      //   });
      // }

      let newObj = {
        name: new Date().toLocaleString([], {year: 'numeric', month: 'numeric', day: 'numeric', hour: '2-digit', minute:'2-digit', hour12: true}) + '',
        type: selectedSearchType,
        query: searchTermUsed,
        numberOfResults: tempSearchResults.length,
        data: tempSearchResults,
        // columns: resultColumns,
        // hiddenColumnsIds: hiddenCols
      }
      setSearchResultToShowAsTable(newObj);
      // let newSearchHistory = [...searchHistory, newObj]
      setSearchHistory([...searchHistory, newObj]);
      // setSearchResultToShowAsTable(prevSearchHistory[prevSearchHistory.length-1]);
      setIsSearchResultReady(true);
      showSearchResult();

    }
  }, [tempSearchResults])




  // ? with useCallback
  // const setErrorLog = useCallback( (message='Error...', error) => {
  //   setIsLoadingCaseData(false);
  //   setIsLoadingSearchResult(false);
  //   setCaseLoadingMessage(message + ' ('+ (!!error && error.toString()) +')');
  //   setSearchErrorMessage(message + ' ('+ (!!error && error.toString()) +')');
  //   setCaseLoadingProgress(0);
  //   console.log(message);
  //   console.error(error);
  //   showAlert(message, 1, false);
  // });


  const [ errorLog, setErrorLog] = useState([]);
  useEffect(() => {
    let [message, error] = errorLog;
    if (!!message  || !!error ){
      setIsLoadingCaseData(false);
      setIsLoadingSearchResult(false);
      setCaseLoadingMessage(message + ' ('+ (!!error && error.toString()) +')');
      setSearchErrorMessage(message + ' ('+ (!!error && error.toString()) +')');
      setCaseLoadingProgress(0);
      console.log(message);
      console.log(error);
      toast.error(message, {duration:6000}); // ! change to infinity and a dismiss button
      // showAlert(message, 1, false);
    }
  }, [errorLog])

  const [caseTableSaveMessage, setCaseTableSaveMessage] = useState('');
  useEffect(() => {
    let timer;
    if(caseTableSaveMessage!=='' && caseTableSaveMessage!==null && caseTableSaveMessage!==undefined){
      timer = setTimeout(() => {setCaseTableSaveMessage('')}, 4000);
    }
    return () => {
      clearTimeout(timer);
    };
  }, [caseTableSaveMessage])


  function loadVaNexDb(requestSortedByCaseId){

    if(requestSortedByCaseId===undefined || requestSortedByCaseId===null){
      requestSortedByCaseId=props.project!=="paradigm";
    }

    setIsLoadingCaseList(true);
    setDbSortedByCaseId(requestSortedByCaseId); 

    // if(DEVMODE){
    //   console.log("in dev mode!");
    //   if(requestSortedByCaseId){
    //     db_json.sort(function(a, b) {
    //       const nameA = a.CASE_ID.toUpperCase(); // ignore upper and lowercase
    //       const nameB = b.CASE_ID.toUpperCase(); // ignore upper and lowercase
    //       if (nameA < nameB) {
    //         return -1;
    //       }
    //       if (nameA > nameB) {
    //         return 1;
    //       }
    //       // names must be equal
    //       return 0;
    //     })
    //   }
    //   setProjectDb(db_json);
    //   setIsLoadingCaseList(false);
    //   return 1;
    // }

    // ! can also load it buy getting a signed_url using: fetch(ENDPOINT_BASE+`get_signed_url?bucket=nch-igm-vanex&key=rare_disease%2FRDdb.json`, {
    // console.log('load VaNex database');
    Auth.currentSession().then(data => {
      let id_token = data.getIdToken().getJwtToken();
      // console.log(data.idToken.payload.email); // ! why not using data.idToken.payload.email?!!
      let fetchUrl = `${ENDPOINT_BASE}load_db?project=${props.project}&user_name=${props.userEmailAddress}`;
      if(requestSortedByCaseId) fetchUrl += '&sort=CASE_ID';

      fetch(fetchUrl, {
        method: 'GET',
        mode: 'cors',
        headers: {
          'Authorization': id_token                
        }
      })
      .then(result => result.json())
      .then(result_json => {
        setIsLoadingCaseList(false);
        // if(requestSortedByCaseId){
        //   setProjectDb(result_json.sort(function(a, b) {
        //     const nameA = a.CASE_ID.toUpperCase(); // ignore upper and lowercase
        //     const nameB = b.CASE_ID.toUpperCase(); // ignore upper and lowercase
        //     if (nameA < nameB) {
        //       return -1;
        //     }
        //     if (nameA > nameB) {
        //       return 1;
        //     }
        //     // names must be equal
        //     return 0;
        //   }));
        // }
        // else
          setProjectDb(result_json)

        return 1;
      }).catch(e => {
        setIsLoadingCaseList(false);
        setErrorLog(["Failed to load the data.", e]);
        return 0;
      });
    });
  }

  //? --------------------------------------------- useEffect ----------------------------------

 
  // useEffect(() => {
  //   // showSearchResult(); this.setState({isLoadingSearchResult: true});
  //   // console.log(props.match.params.caseId);

  //   if(props.history.location.search){
  //     handleSearchViaLocation(props.history.location.search);
  //   }
  //   // else if(props.match.params !== undefined){
  //   //   if (props.match.params.caseId !== undefined) {
  //   //     showActiveCaseCardInfo(props.match.params.caseId);
  //   //   }
  //   // }
    
  //   props.history.listen((location, action) => {
  //     // console.log(`The current URL is ${location.pathname}${location.search}${location.hash}`);
  //     // console.log(`The last navigation action was ${action}`);
  //     handleSearchViaLocation(location.search);
  //   });
  //   // retrieveQueryResultFromS3('https://nch-igm-vanex.s3.us-east-2.amazonaws.com/tmp_outputs/fe8ffd4d-063f-4309-9037-e52b1ec9248e.csv?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=ASIATYENYDZEFTGMEOG7%2F20210528%2Fus-east-2%2Fs3%2Faws4_request&X-Amz-Date=20210528T202024Z&X-Amz-Expires=3600&X-Amz-SignedHeaders=host&X-Amz-Security-Token=IQoJb3JpZ2luX2VjELz%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEaCXVzLWVhc3QtMiJHMEUCIQCDXh1wDJHIKbuSJqd27a%2FwGZ7WOODQVTFt%2BcTYi8BaKAIgaLMt5rcXt37tDHORH5IzHFRpEl%2B2KEckDZmXLbWdbRMq3QEIZRAAGgwyNTc5OTUzMTY4MDgiDF0jY32IZc1Kn6ON3Sq6Ad1PsNfN2yNBAMTcyww3puF2mfEpP8DCXS8ivkR9juN3P0ePMmiw4RSDOvsm4MWOSRK3zA415W7Qtz%2BAKPo4uL7YS4cC22Onn5RipuFxRoLtnZObK6laTY0UiFwDeZIDVE8frNzFoa%2BOlqJbchbjSoOPoOhGllEOnzspM0B3WcO%2FqO4KLcBEW3FN4T7tHqVk193AaGO%2BAVO4kc%2FOoxi5tvQB0Fknkdwio%2BN9h2u6kkU3X2wr5V2SjnoSQjCDocWFBjrgAa6e%2BJFhVlB6I4BvNtWbsFT6tEDanhnQsIEbBI99gKz%2BeuFfzR3xkYGeNYGIF9rjt6Wrn1vW7MA7PIQ6vl8B7UxNQzZPJuIn6LOoclwJD85eHgOB41fazG%2FvJdbmscfNaan9hL%2BCbusVhr7GYBRrr%2FV6Im4ED8Nn9zKoFxhEqXceWvTuQTbHgTb%2B9fq8qcfAgG2BLxUEqDt4jn78jv%2F1rUh3pUnFyzzeKQzxl8xxO7AzfsbxqbrpMIMX9HoYkfsrGIDdt438fYakZGFQuyI0SaQGD14TgGlJTclar%2FLUtDuS&X-Amz-Signature=4793d43801cd93df17ba8b00816268beb946922b97c1b4618005a0bc3f56493b'); // eve
  //   // retrieveQueryResultFromS3('https://nch-igm-vanex.s3.us-east-2.amazonaws.com/tmp_outputs/986557be-6b3e-4091-9eb5-e17df09e9f20.csv?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=ASIATYENYDZEKF4BN4GJ%2F20210528%2Fus-east-2%2Fs3%2Faws4_request&X-Amz-Date=20210528T200757Z&X-Amz-Expires=3600&X-Amz-SignedHeaders=host&X-Amz-Security-Token=IQoJb3JpZ2luX2VjELz%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEaCXVzLWVhc3QtMiJIMEYCIQDpqOqggjdSA7jHEH4bKALg4CMSOCwHm1wavMTSKt70mAIhAL3tBtwCKQc68EoBD%2B0HWW4V9GzcmfYHk4G%2BmBQDByXtKt0BCGUQABoMMjU3OTk1MzE2ODA4IgyDS2HR9YFla1dEBsMqugGS4gPoJl7%2B1tHKg8KMSXZJJ6wZkThMJe6BqjBu1wOgiNHMGFVe3YqZ3T0ImAdw3Pw6RuFt%2BaTVZe3St8y8VzfIhR29PqKfAMvu8xSA4HqifiWXIuNfS8WPx6IviHQRmRDXCy2stAUVRnFmnYO52ffqYLmsemjcWMWc8OgYQXCK055deTvUsySJSKEjItAkqeNtC7jWg1V0G93MpIp4%2F2b1vUWLCRqRRNvrJmXcij4kTSEcSeIElIGAfVAwmJvFhQY63wGyQJeOPlQ1B9bWkIOAcxG8goG46KlVdN%2F5cH%2FNB6lMSeemF6s7CG6e8eQa7S%2FZDjpddLI%2BitUaUhEjMg556TFTvHqIitlnLiikI9B1gfNlXiUbtgYHY864M%2B8pImeHdIinsodwdR3uHxuX9rdcp5HrON%2BZr2wN5LeHihbq9WSOb%2BnBTTN8hS40Y0h8Yr3ngvVU%2F8di7x9rimziL9Ro6Avp901J2GqlVOMHvy9F%2F6HfnFd4YLwD6OcSwt%2FLvfwJ%2B4gr1rCbysXyLxxDEhmrWjSmu360caZl4o8PmOCEd5LD&X-Amz-Signature=df4b57396a7ef5085b5ed53afe3e62e90beaa53d58cfc6ac62736f63c4604fec');  //sms
  // }, [props.history]);
  

  
  const [accessDenied, setAccessDenied] = useState(false);
  let vaNexLcation = useLocation();
  useEffect(() => {

    console.log('isPowerUser:', props.isPowerUser, " - isAdmin:", props.isAdmin);

    if (props.project === "fus"){
      Auth.currentSession().then(data => {
        console.log(("yay!"));
        loadVaNexDb();
      })
      .catch(e => {
        console.log('Error:' + e)
        Auth.federatedSignIn({provider: 'AzureAD', customState: `?url=/fus`});
      })
    } else {
      Auth.currentSession().then(data => {
        // console.log('Auth user_groups', data.idToken.payload["custom:user_groups"])
        if( data.idToken.payload["custom:user_groups"].includes("GGRAzCognitoIGMVanex")
          ||data.idToken.payload["custom:user_groups"].includes("GGHAzCognitoIGMVanex")
          ||data.idToken.payload["custom:user_groups"].includes("GGRAzCognitoIGMVanexPowerUsers")
          ||data.idToken.payload["custom:user_groups"].includes("GGHAzCognitoIGMVanexPowerUsers")
          ||data.idToken.payload["custom:user_groups"].includes("GGRAzCognitoIGMVanexAdmins")
          ||data.idToken.payload["custom:user_groups"].includes("GGHAzCognitoIGMVanexAdmins")
        ){
          loadVaNexDb();
        } else {
          Auth.signOut();
        }
      })
      .catch(e => {
        console.log('Error:' + e)
        // Auth.federatedSignIn({provider: 'AzureAD', customState: `?url=/`});
      })
    }
    
    // loadVaNexDb();
    // setProjectSetPMFPrefix(true);

    if(!!vaNexLcation.search) handleSearchViaLocation(vaNexLcation.search);

    history.listen((location, action) => {
      handleSearchViaLocation(location.search);
      // console.log(`The current URL is ${location.pathname}${location.search}${location.hash}`);
      // console.log(`The last navigation action was ${action}`);
    });

    if(props.project !== "epilepsy" &&  props.userEmailAddress?.toLowerCase === "allison.thompson2@nationwidechildrens.org")
      setAccessDenied(true)
  }, []);

  useEffect(() => {
    var vanexTitle = 'VaNex'
    if(activeCaseId!==null && activeCaseId!==undefined && activeCaseId!=='') {
      vanexTitle = `${activeCaseId} - VaNex`;
      if(viewAnalysis && activeAnalysis!==null && activeAnalysis!==undefined && activeAnalysis!=='' && !!activeAnalysis['ANALYSIS_NAME']) 
        vanexTitle = `${activeCaseId} (${activeAnalysis['ANALYSIS_NAME']}) - VaNex`;
    } else if(props.projectTitle!==null && props.projectTitle!==undefined && props.projectTitle!==''){
      vanexTitle = `${props.projectTitle} - VaNex`;
    }

    document.title = vanexTitle;
  });

  //? --------------------------------------------- handle search ----------------------------------


  function handleSearchViaLocation(searchObtainedFromLocation){
    
    const queryParams = parseQueryString(searchObtainedFromLocation);
    if ("term" in queryParams) {
      let searchTerm = decodeURIComponent(queryParams["term"]).trim();
      if (searchTerm !==''){
        setSearchBoxValue(searchTerm);
        setSearchTermUsed(searchTerm);
        switch(decodeURIComponent(queryParams["type"])){
          case 'genes':
            setSelectedSearchType('Genes');
            searchRdDbGeneOrVariant(searchTerm, 'gene');
            break;
          case 'variants':
            setSelectedSearchType('Variants');
            searchRdDbGeneOrVariant(searchTerm, 'variant');
            break;
          default:
            setSelectedSearchType('ClinVar Plots');
            getClinVarPlot(searchTerm);
            break;
        }
      }
    }
  }


  function getClinVarPlot(geneName){
    showSearchResult();
    setIsLoadingSearchResult(true);

    // 'nch-igm-vanex-client/ClinVarPlots/GRCH38-Varhouse/'+gene_name+'/'+gene_name+'.ALL.png')
    //! const url_to_fetch = ENDPOINT_BASE+`get_signed_url?bucket=nch-igm-vanex-client&key=ClinVarPlots/GRCH38-Varhouse/${geneName.toUpperCase()}/${geneName.toUpperCase()}.ALL.png`;
    // const url_to_fetch = `${ENDPOINT_BASE}get_signed_url?bucket=nch-igm-vanex-client&key=ClinVarPlots%2FGRCH38-Varhouse%2F${geneName.toUpperCase()}%2F${geneName.toUpperCase()}.ALL.png`;
    GetSignedURL('nch-igm-vanex-client',`ClinVarPlots%2FGRCH38-Varhouse%2F${geneName.toUpperCase()}%2F${geneName.toUpperCase()}.ALL.png`) 
    .then(result_json => {
      // console.log(result_json);
      // if(result_json!=null){
        setIsLoadingSearchResult(false);
        setClinVarPlotSrc(result_json);
        setSearchErrorMessage('');
        setIsSearchResultReady(true);
      // }
      // else {
      //   setSearchError(`No information found for '${geneName}'.`);
      // }
      showSearchResult();
    }).catch(e => {
      setErrorLog(["Failed to fetch data.", e]);
      setSearchError(`No information found for '${geneName}'.`);
      //! setIsLoadingSearchResult(false); //! fix the error message when file is not found!
      // setClinVarPlotSrc('');
      // setIsSearchResultReady(true);
    });
  }

  function searchRdDbGeneOrVariant(geneNameOrVariant, type='gene'){
    showSearchResult();
    // TODOs: fix error messages and setStates!
    setIsLoadingSearchResult(true);

    Auth.currentSession().then(data => {
      let id_token = data.getIdToken().getJwtToken();
      const url_to_fetch = `${ENDPOINT_BASE}search_db?${type}=${geneNameOrVariant.toUpperCase()}`;
      console.log('fetching: ',url_to_fetch);
      fetch(url_to_fetch, {
        method: 'GET',
        mode: 'cors',
        headers: {
          'Authorization': id_token
        }
      })
      .then(result => {return((result.ok) ? result.json() : null)})
      .then(result_json => {
        if(result_json!=null){
          if(result_json.time_over==='true'){
            setSearchError(`Time out error. No information found for '${geneNameOrVariant}'.`);
          }
          else if(result_json.status==='SUCCEEDED'){
            // console.log('result', result_json);  // ! maybe have it on?
            if(result_json.signed_url!==''){
              retrieveQueryResultFromS3(result_json.signed_url);
            }
            else {
              setSearchError(`Query succeeded but no file is found on S3. No information found for '${geneNameOrVariant}'.`);
            }
          }
          else {
            setSearchError(`Query failed. No ${type} information found for '${geneNameOrVariant}'.`);
          }
        }
        else {
          setSearchError(`No information ${type} found for '${geneNameOrVariant}'.`);
        }
        showSearchResult();
      }).catch(e => setErrorLog(["Failed to fetch data.", e]));
    });
  }

  
  function retrieveQueryResultFromS3(signed_url){
    showSearchResult();
    // updateCaseLoadingProgressBar(`Requesting data for ...`,1);
    console.log('fetch variants: '+signed_url);
    if (request) {
      request.abort();
    }
    let xhReq = new XMLHttpRequest();
    request = xhReq;

    //TODOs: add progressbar? // update progress bar
    // xhReq.addEventListener("progress", (oEvent) => {
    //   // progress on transfers from the server to the client (downloads)
    //   if (oEvent.lengthComputable) {
    //     let percentComplete = Math.round(oEvent.loaded / oEvent.total * 95);
    //     updateCaseLoadingProgressBar(`Downloading data for ${caseID}... (${(oEvent.loaded/1000000).toFixed(1)} MB of ${(oEvent.total/1000000).toFixed(1)} MB)`, percentComplete);
    //   } else {
    //     updateCaseLoadingProgressBar(`Downloading data for ${caseID} (unknown size)`, 50);
    //     console.log('Unable to compute progress information since the total size is unknown');
    //   }
    // });

    // get a callback when the server responds
    xhReq.addEventListener("load", (oEvent) => {
      // console.log(xhReq.responseText);
      // console.log(csvToArrayToJson(xhReq.responseText.replace(/\n+$/,"")));
      // setTempSearchResults(csvToArrayToJson(xhReq.responseText.replace(/\n+$/,"")));
      let searchResultJson = csvToArrayToJson(xhReq.responseText.replace(/\n+$/,""));
      if(searchResultJson.length > 0){
        // console.log(searchResultJson);
        searchResultJson = flattenCaseData(searchResultJson);
        setTempSearchResults(searchResultJson);
      }
      else{
        setSearchError(`No records found.`);
      }

    });

    // TODO: handle error in these:
    xhReq.addEventListener("error", () => {  setErrorLog(['An error occurred while transferring the file','']);  });
    xhReq.addEventListener("abort", () => { setErrorLog(['Transfer has been canceled by the user', '']);   });
    // xhReq.addEventListener("loadend",() => { setErrorLog(['Transfer finished (succeeded or not?!)'], '');   });
    // xhReq.addEventListener("loadstart",() => { console.error('Transfer started!');   });

    xhReq.open('GET', signed_url);
    // send the request
    xhReq.send();
  }


  //? --------------------------------------------- search form ----------------------------------

  function handleSearchForm(e){
    let urlToPush = '';
    e.preventDefault();
    if( searchBoxValue.trim() !==''){

      //? clear potential previous search status and get ready for a new search
      setIsLoadingSearchResult(false);
      setIsSearchResultReady(false);
      setSearchResultToShowAsTable({});
      setShowSearchPanel(true);
      setSearchErrorMessage('');
      setClinVarPlotSrc('');
      // setAlertMessage('');

      switch(selectedSearchType ){
        case 'Genes':
          urlToPush = `/${props.projectBaseURL}/search?type=genes&term=${searchBoxValue}`;
          break;
        case 'Variants':
          urlToPush = `/${props.projectBaseURL}/search?type=variants&term=${searchBoxValue}`;
          break;
        default: //?  'ClinVar Plots'
          urlToPush = `/${props.projectBaseURL}/search?type=clinvarplots&term=${searchBoxValue}`;
          break;
      }
      history.push(urlToPush);
    }
    else{
      toast.error('Enter a gene name!');
    }
  }

  //? --------------------------------------------- Sort OMIM ----------------------------------
  function sortOmimPhenotypes(rawPhenotypes) {
    if (!rawPhenotypes || (!Array.isArray(rawPhenotypes) && typeof rawPhenotypes !== 'string')) {
      return null;
    }
  
    const phenotypeEntries = Array.isArray(rawPhenotypes)
      ? rawPhenotypes.map(s => s.trim()).filter(s => s.length > 0)
      : rawPhenotypes.split(';').map(s => s.trim()).filter(s => s.length > 0);
  
    const trueDisorders = [];
    const susceptibilityTraits = [];
    const quantitativeTraits = [];
    const provisionalTraits = [];
  
    phenotypeEntries.forEach(entry => {
      if (entry.startsWith('[')) {
        quantitativeTraits.push(entry);
      } else if (entry.startsWith('{')) {
        susceptibilityTraits.push(entry);
      } else if (entry.startsWith('?')) {
        provisionalTraits.push(entry);
      } else {
        trueDisorders.push(entry);
      }
    });
  
    const sortedPhenotypes = [
      ...trueDisorders.sort((a, b) => a.localeCompare(b)),
      ...provisionalTraits.sort((a, b) => a.localeCompare(b)),
      ...susceptibilityTraits.sort((a, b) => a.localeCompare(b)),
      ...quantitativeTraits.sort((a, b) => a.localeCompare(b))
    ];
  
    return sortedPhenotypes.join('; ');
  }

  function filterOMIMPhenotypes(phenotypes) {
    if (!phenotypes) return [];
  
    // Normalize: if not an array, wrap it
    if (!Array.isArray(phenotypes)) {
      phenotypes = [phenotypes];
    }
  
    return phenotypes
      .flatMap(entry => entry.split(';'))
      .map(p => p.trim())
      .filter(p => p.length > 0)
      .sort((a, b) => {
        const getPriority = (p) => {
          if (p.startsWith('?')) return 1;
          if (p.startsWith('{')) return 2;
          if (p.startsWith('[')) return 3;
          return 0;
        };
  
        const priorityDiff = getPriority(a) - getPriority(b);
        return priorityDiff !== 0 ? priorityDiff : a.localeCompare(b);
      });
  }
  
  
  //? --------------------------------------------- Db / Cases ----------------------------------

  function getCurrentUserFirstName(){
    let name = "User"
    if (!!props.userName)
      name = props.userName.split(' ')[0]
    return name
  }

  function switchToAnalysis(caseID, analysisObj) { // , analysisID, analysisName , loadMyNotes, loadExistingNotes, reloadCaseData
    // let caseID = inputCaseId.toUpperCase(); // let caseId = props.currentCaseInformation.CASE_ID.toUpperCase();
    
    const caseAnalysisId = `${caseID}::${analysisObj.ANALYSIS_ID}`;
    const caseAnalysisName = `${caseID}::${analysisObj.ANALYSIS_NAME}`;
    const userName = props.userName.replaceAll(' ','_');                        // * did not use .toUpperCase();

    const allowedCases = ["JLE008","JLE058","JLE085","JLE098","JLE106"]
    if(props.userEmailAddress.toLowerCase === "allison.thompson2@nationwidechildrens.org"){
      if(props.project !== "epilepsy"){
        setAccessDenied(true)
        return(<></>)
      } else{
        if (!allowedCases.includes(caseID)){
          setAccessDenied(true)
          return(<></>)
        }
      }
    }

    // let tmpVariantData = [];
    // let userNotes;
    // let reviewRecords;
    // let denovoAssessments;
    // let mrPheneData;
    // const gzipedJsonFile = (!!analysisObj.JSON_URI ? true : false);
    // let bucket = 'nch-igm-vanex';
    // let uriToLoad = `${props.project}/cases/CASE_ID=${caseID}/${analysisObj.ANALYSIS_ID}.json`;
    // if(gzipedJsonFile){
    //   bucket =analysisObj.JSON_URI.match(/s3:\/\/([^/]*)\//,'')[1]
    //   uriToLoad= analysisObj.JSON_URI.replace(/s3:\/\/[^/]*\//,'')
    // }

    // // console.log(props.currentAnalysisInfo.SAMPLES.sort( (elA,elB) => (GetSampleRank(elB.SAMPLE_TYPE, false) - GetSampleRank(elA.SAMPLE_TYPE, false)) ) );
    analysisObj.SAMPLES.sort( (elA,elB) => (GetSampleRank(elB.SAMPLE_TYPE, false, analysisObj.ANALYSIS_TYPE) - GetSampleRank(elA.SAMPLE_TYPE, false, analysisObj.ANALYSIS_TYPE)) );
    setActiveAnalysis(analysisObj);

    

    // if(analysisObj.ANALYSIS_TYPE === 'RNASeq'){
    //   toast.error('Cannot Load :(');
    //   return;
    // }

    // if(analysisObj.ANALYSIS_TYPE === 'CNV' || analysisObj.ANALYSIS_TYPE === 'SV'){
    // if(  analysisObj.ANALYSIS_TYPE === 'SV'){
    //   history.push(`/${props.projectBaseURL}/${caseID}/analysis/${analysisObj.ANALYSIS_ID}`);
    //   return;
    // }

    //* warn user if the session is expired 
    // ! maybe there is a better way to check for this
    Auth.currentAuthenticatedUser().then( )
    .catch(e => {
      toast.error(`You cannot save notes since you are either not logged in or your session has expired! (${props.userName})`, {duration:8000});
    });

    let currentCaseIndex = openCases.findIndex(t => t[0] === caseAnalysisId);
    if (currentCaseIndex >= 0 && !reloadCaseData){
      // toast('case already loaded!');
      setActiveCaseIndexInOpenCases(currentCaseIndex);
      if(!!openCases[currentCaseIndex][1]){ 
        // updateCaseLoadingProgressBar(`Processing data for ${caseAnalysisName}...`, 50);
        // setTimeout(() => {showAnalysisPanel(caseID, analysisObj.ANALYSIS_ID)}, 10); //! TBD; did fix this by using mainUseEffectsIsDone in the VariantViewer component!
        showAnalysisPanel(caseID, analysisObj.ANALYSIS_ID)
      }
      else {
        setErrorLog([`No data for ${caseAnalysisId} found in openCases`, '']);
      }
      return 1;
    }

    updateCaseLoadingProgressBar(`Requesting data for ${caseAnalysisName}...`,1);
    // console.log('analysisObj',analysisObj)
    // if(analysisObj.ANALYSIS_TYPE === 'CNV' || analysisObj.ANALYSIS_TYPE === 'SV'){
    if(  analysisObj.ANALYSIS_TYPE === 'MT_Variants'){
      loadMTdata(caseID, analysisObj, userName, currentCaseIndex)
    }
    else if(  analysisObj.ANALYSIS_TYPE === 'FUS'){
      loadFUSdata(caseID, analysisObj, userName, currentCaseIndex)
    }
    else if(  (analysisObj.ANALYSIS_TYPE === 'CNV') | (analysisObj.ANALYSIS_TYPE === 'CNV_Somatic') ){
      loadCNVdata(caseID, analysisObj, userName, currentCaseIndex)
    }
    else if( (analysisObj.ANALYSIS_TYPE === 'SV') | (analysisObj.ANALYSIS_TYPE === 'PacBioSV')){
      loadSVdata(caseID, analysisObj, userName, currentCaseIndex)
    }
    else{
      loadSNVdata(caseID, analysisObj, userName, currentCaseIndex)
    }
  }


  // TODO: do we need to use max or mean?!!!!! 
  function findMaxOverlaps(segmentInfo, cnvCalls) {
    let maxSegmentData = {};
    let foundSegments
    let maxOLPercent = 0;
    let maxSimilarity = 0;
    let avgPercent = 0;
    let percent = 0;
    let overlaps = 0;
    let maxLength =0;
    let similarity = 0;
    // if (segmentInfo.CHROMOSOME ==="1"){console.log("segmentInfo",segmentInfo)}
    if (!!segmentInfo.CNV_TYPE){
      foundSegments= cnvCalls.filter(mCall => (mCall.CHROMOSOME===segmentInfo.CHROMOSOME && mCall.LOC_START<=segmentInfo.LOC_END && mCall.LOC_END>=segmentInfo.LOC_START && mCall.CNV_TYPE===segmentInfo.CNV_TYPE) )
    }
    else {
      foundSegments= cnvCalls.filter(mCall => (mCall.CHROMOSOME===segmentInfo.CHROMOSOME && mCall.LOC_START<=segmentInfo.LOC_END && mCall.LOC_END>=segmentInfo.LOC_START && mCall.TYPE===segmentInfo.TYPE) )
    }
    
    if (!!segmentInfo.TYPE && !!foundSegments && foundSegments.length > 0 && segmentInfo.TYPE ==="BND"){
      maxSimilarity = 100
      maxOLPercent = 100
      avgPercent = 100
      maxSegmentData = foundSegments[0];
    }
    else if (!!foundSegments && foundSegments.length > 0){
      // Overlap is how much of proband length is within the other samples length
      // similarity is how much the two samples lengths compare to the total length of both samples
      let percentages = foundSegments.map( segData => {
        overlaps = Math.min(segmentInfo.LOC_END, segData.LOC_END) - Math.max(segmentInfo.LOC_START, segData.LOC_START);
        maxLength = Math.max(segmentInfo.LOC_END, segData.LOC_END) - Math.min(segmentInfo.LOC_START, segData.LOC_START);
        percent = Math.round(100*(overlaps / (segmentInfo.LOC_END - segmentInfo.LOC_START)));
        // similarity = Math.round(100*(overlaps / (segData.LOC_END - segData.LOC_START)));
        similarity = Math.max(1,Math.round(100*(overlaps / maxLength)));
        if(similarity>maxSimilarity){
          maxSimilarity=similarity;
          maxOLPercent = percent;
          maxSegmentData = segData;
        }
        return(percent);
      });
      // if (segmentInfo.CHROMOSOME ==="1"){console.log(foundSegments,percent,similarity,maxSimilarity,maxOLPercent)}
      avgPercent = percentages.reduce((a, b) => a + b) / percentages.length;
      // maxPercent = Math.max(...percentages);
      
    }
    // console.log("foundSegments",maxSegmentData)
    return([maxOLPercent, maxSegmentData, avgPercent, maxSimilarity]);
  }


  function determineInheritance(probandGeno, otherSample_GTs, motherSampleId, fatherSampleId){
    // console.log(probandGeno, otherSample_GTs[`${fatherSampleId}_GT`], otherSample_GTs[`${motherSampleId}_GT`], !!fatherSampleId)
    let OvrlapCutoff = 60
    if (probandGeno === 'ref'){
      return "Uninherited"
    } 
    if (!!!motherSampleId && !!!fatherSampleId){
      return "Unknown"
    }
    //`${fatherSampleId}_GT`
    if (!!fatherSampleId && otherSample_GTs[`${fatherSampleId}_SIM`] >= OvrlapCutoff){
      if (!!motherSampleId && otherSample_GTs[`${motherSampleId}_SIM`] >= OvrlapCutoff){
        return "Biparental"
      }
      else {
        return "Paternal"
      }
    }
    if (!!motherSampleId && otherSample_GTs[`${motherSampleId}_SIM`] >= OvrlapCutoff){
      return "Maternal"
    }
    else {
      return "De Novo"
    }
  }

  function loadFUSdata(caseID, analysisObj, userName, currentCaseIndex){
    const caseAnalysisId = `${caseID}::${analysisObj.ANALYSIS_ID}`;
    const caseAnalysisName = `${caseID}::${analysisObj.ANALYSIS_NAME}`;
    // let userName = props.userName.replaceAll(' ','_');                        // * did not use .toUpperCase();
    let tmpVariantData = [];
    let userNotes;

    let bucket = analysisObj.JSON_URI.match(/s3:\/\/([^/]*)\//,'')[1] ; // or use analysisObj.JSON_URI
    let uriToLoad = analysisObj.JSON_URI.replace(/s3:\/\/[^/]*\//,'');  // or use analysisObj.JSON_URI
    let basePathForAllNotes = `fus_case_notes/CASE_ID=${caseID}/ANALYSIS_ID=${analysisObj.ANALYSIS_ID}/&folder=true`;
    if (isNoteScopeAllAnalysis) basePathForAllNotes = `fus_case_notes/CASE_ID=${caseID}/&folder=true`;

    console.log('uriToLoad', uriToLoad)
    new Promise(function (resolve, reject) {
      resolve(
        GetSignedURL(bucket, uriToLoad, false)
        .then(response => {
          console.log('vvvresponse', response)
          return(downloadMTData(response, ` MT data for ${caseAnalysisName}` ));
        })
        .catch(e => {
          console.error(`Failed xxxx.`, e);
        })
      );
    })
    .then( caseTextData => {
      tmpVariantData = caseTextData;
      console.log("tmpVariantData xxxx ", tmpVariantData);
      // // * sort data by POSITION
      // tmpVariantData = tmpVariantData.sort((a, b) => {
      //     return(a.POS - b.POS); 
      // });

      if(loadMyNotes){
        updateCaseLoadingProgressBar(`Loading notes for ${caseAnalysisName}...`, 90);
        return(
          // GetSignedURL('nch-igm-vanex',`mt_case_notes/CASE_ID=${caseID}/USERNAME=${userName}/${userName}.json`)
          GetSignedURL('nch-igm-vanex',`fus_case_notes/CASE_ID=${caseID}/ANALYSIS_ID=${analysisObj.ANALYSIS_ID}/USERNAME=${userName}/${userName}.json`)
          .then(response => downloadIndividualNote(response))
          .catch( e => { toast(`${getCurrentUserFirstName()}'s notes not found.\n(${e.toString()})`, {duration:6000}); return("") })
          // .catch( e => toast.error(`Notes not found (${e.toString()})`, {duration:6000}))
        );
      }
      else{
        return("");
      }


    })
    
    .then( userNotesResponse => {
      userNotes = parse_JSONL(userNotesResponse).map( myNote => {
        return(
          {
            ...myNote,
            VANEX_TAGS: (myNote['VANEX_TAGS']===true ? 1 : (myNote['VANEX_TAGS']===false ? 0 : myNote['VANEX_TAGS']))
          }
        );
      });
    //   updateCaseLoadingProgressBar(`Loading reviews for ${caseAnalysisName}...`, 92);
    })
    .then( () => {

      let missingVariants;
      if(!!userNotes && userNotes.length > 0){
        missingVariants = 0;
        //! // * Warn user if there is a note for a variant which is not in this dataset
        // Object.keys(userNotes).forEach( nId => {
        //   if(Object.values(tmpVariantData).filter( t => t['CHROMOSOME']===userNotes[nId]['CHROMOSOME']
        //     &&  t['LOC_START']===userNotes[nId]['LOC_START']
        //     &&  t['LOC_END']===userNotes[nId]['LOC_END']
        //     &&  t['SEG_MEAN']===userNotes[nId]['SEG_MEAN'] ).length < 1) {
        //       missingVariants+=1;
        //       console.log(userNotes[nId]); // ! keep this in console??????
        //   }
        // });
      }

      // const sampleNames = new Set();
      // Object.keys(tmpVariantData).forEach( varIndex => {
      //   Object.keys(tmpVariantData[varIndex].SAMPLES).forEach( sampleName => {
      //     sampleNames.add(sampleName);
      //   })
      // });
      // console.log(sampleNames);

      // tmpVariantData.forEach((variant, varIndex) => {
      Object.keys(tmpVariantData).forEach( varIndex => {
        tmpVariantData[varIndex]['ROW_INDEX'] = varIndex;
        tmpVariantData[varIndex]['OrderedFusion'] = tmpVariantData[varIndex]['OrderedFusion']?.replaceAll(">>","::");
        tmpVariantData[varIndex]['CHROMOSOME'] = tmpVariantData[varIndex]['Chr1'];
        tmpVariantData[varIndex]['POSITION'] = tmpVariantData[varIndex]['Break1'];
        tmpVariantData[varIndex]['CHROMOSOME1'] = tmpVariantData[varIndex]['Chr1'];
        tmpVariantData[varIndex]['BREAK1'] = tmpVariantData[varIndex]['Break1'];
        tmpVariantData[varIndex]['STRAND1'] = tmpVariantData[varIndex]['Strand1'];
        tmpVariantData[varIndex]['CHROMOSOME2'] = tmpVariantData[varIndex]['Chr2'];
        tmpVariantData[varIndex]['BREAK2'] = tmpVariantData[varIndex]['Break2'];
        tmpVariantData[varIndex]['STRAND2'] = tmpVariantData[varIndex]['Strand2'];
        tmpVariantData[varIndex]['GENE'] = tmpVariantData[varIndex]['Gene1'];
        tmpVariantData[varIndex]['GENE1'] = tmpVariantData[varIndex]['Gene1'];
        tmpVariantData[varIndex]['GENE2'] = tmpVariantData[varIndex]['Gene2'];

        delete tmpVariantData[varIndex]['Chr1'];
        delete tmpVariantData[varIndex]['Break1'];
        delete tmpVariantData[varIndex]['Strand1'];
        delete tmpVariantData[varIndex]['Chr2'];
        delete tmpVariantData[varIndex]['Break2'];
        delete tmpVariantData[varIndex]['Strand2'];
        delete tmpVariantData[varIndex]['Gene1'];
        delete tmpVariantData[varIndex]['Gene2'];

        tmpVariantData[varIndex]['ENTREZ_ID1'] = (!!tmpVariantData[varIndex]['GENE1'] && tmpVariantData[varIndex]['GENE1']!=="." ? genes_to_ids.ENTREZ_ID[tmpVariantData[varIndex]['GENE1']] : null);
        tmpVariantData[varIndex]['ENTREZ_ID2'] = (!!tmpVariantData[varIndex]['GENE2'] && tmpVariantData[varIndex]['GENE2']!=="." ? genes_to_ids.ENTREZ_ID[tmpVariantData[varIndex]['GENE2']] : null);
        // tmpVariantData[varIndex]['ENTREZ_ID'] = (!!tmpVariantData[varIndex]['Locus'] && tmpVariantData[varIndex]['Locus']!=="." ? genes_to_ids.ENTREZ_ID[tmpVariantData[varIndex]['Locus']] : null);
        tmpVariantData[varIndex]['MISSENSE'] = "false";
        // if (tmpVariantData[varIndex]['AaChange'][0] !== tmpVariantData[varIndex]['AaChange'].slice(-1)) tmpVariantData[varIndex]['MISSENSE'] = "true";
        // console.log(tmpVariantData[varIndex]['AaChange'], tmpVariantData[varIndex]['AaChange'][0], tmpVariantData[varIndex]['AaChange'].slice(-1), tmpVariantData[varIndex]['AaChange'][0] !== tmpVariantData[varIndex]['AaChange'].slice(-1))
        // tmpVariantData[varIndex]['MR_PHENE_PHENOTYPE_TERMS'] = null;

        // if(!!mrPheneData){
        //   let entrezId = tmpVariantData[varIndex]['ENTREZ_ID'];
        //   let inMrPheneRecord = mrPheneData['genes'][entrezId];
        //   if (inMrPheneRecord!==null && inMrPheneRecord !==undefined){
        //     let terms=Object.keys(mrPheneData['terms']).filter(t=> {
        //       if(mrPheneData['terms'][t].genes!==null && mrPheneData['terms'][t].genes!==undefined)
        //         return(mrPheneData['terms'][t].genes.includes(entrezId));
        //       else
        //         return false;
        //     }).map(k => `${mrPheneData['terms'][k].label} (${k})`)
        //     // let terms=Object.keys(mrPheneData['terms']).filter(t=> mrPheneData['terms'][t].genes.includes(entrezId))
        //     // let terms=Object.values(mrPheneData['terms']).filter(t=> t.genes.includes(entrezId)).map(k => `${k.label} (${k.type})`)
        //     tmpVariantData[varIndex]['MR_PHENE_PHENOTYPE_TERMS'] = `[${terms.length}] ${terms.join(', ')}`;
        //     // debugger;
        //   }
        // }

        tmpVariantData[varIndex]['VANEX_TAGS'] = 0;
        tmpVariantData[varIndex]['VANEX_NOTES'] = {CURRENT_USER_NOTE:'', UPDATED_AT:'', ALL_USERS_NOTES:[]}; //, DENOVO_ASSESSMENT:-1
        tmpVariantData[varIndex]['VANEX_REVIEWS'] = {REVIEW_VALUE:null, DENOVO_ASSESSMENT:null, UPDATED_AT:null};
        //! // * add user notes for this variant
        if(!!userNotes){
          let foundNotes = Object.values(userNotes)
            .filter( t => t['CHROMOSOME1']===tmpVariantData[varIndex]['CHROMOSOME1']
                      &&  t['BREAK1']===tmpVariantData[varIndex]['BREAK1']
                      &&  t['CHROMOSOME2']===tmpVariantData[varIndex]['CHROMOSOME2']
                      &&  t['BREAK2']===tmpVariantData[varIndex]['BREAK2'] );
          if(Object.keys(foundNotes).length > 0){
            tmpVariantData[varIndex]['VANEX_TAGS'] =  (foundNotes[0]['VANEX_TAGS']===true ? 1 : foundNotes[0]['VANEX_TAGS']===false ? 0 : foundNotes[0]['VANEX_TAGS']);
            tmpVariantData[varIndex]['VANEX_NOTES'] = {CURRENT_USER_NOTE:foundNotes[0]['VANEX_NOTES'], UPDATED_AT:foundNotes[0]['UPDATED_AT'] || '', ALL_USERS_NOTES:[]}; //, DENOVO_ASSESSMENT:-1
          }
        } 
      });

      // console.log("tmpVariantData MT", tmpVariantData);
      //TODO: get column names from db for mother and father
      

      if(missingVariants!==undefined)
        if(missingVariants>0)
          toast.error(`Cannot find coresponding variants for ${missingVariants} notes`, {duration:6000});
        else
          toast.success(`${getCurrentUserFirstName()}'s notes loaded successfully!`);

      let newCase = [caseAnalysisId, tmpVariantData, []]; // ? maybe add date as the last element?        , new Date()

      if(currentCaseIndex >= 0 && reloadCaseData){
        setActiveCaseIndexInOpenCases(currentCaseIndex);
        setOpenCases(prevOpenCases => prevOpenCases.map(indvCase => (indvCase[0] === caseAnalysisId ? newCase : indvCase)))
      } else {
        setActiveCaseIndexInOpenCases(openCases.length);
        setOpenCases([...openCases, newCase]);
      }
      
      if(loadExistingNotes){      
        // GetSignedURL('nch-igm-vanex',`mt_case_notes/CASE_ID=${caseID}/&folder=true`) 
        GetSignedURL('nch-igm-vanex', basePathForAllNotes) 
        .then(response => downloadAllExistingNotes(response, caseAnalysisId, analysisObj))
        .catch( e => {setIsLoadingNotes(false); toast.error(`Error in retrieving notes: ${e.toString()}`, {duration:8000}); })
        // .catch( e => {setIsLoadingNotes(false); setErrorLog([`Error in retrieving notes: ${e}`, ''])});
      }
      showAnalysisPanel(caseID, analysisObj.ANALYSIS_ID);
    })
    .catch( e => setErrorLog([`No data for ${caseAnalysisId} found. (${e})`, '']));
  }
    
   
  function loadMTdata(caseID, analysisObj, userName, currentCaseIndex){
    // console.log('analysisObj: ', analysisObj);

    const caseAnalysisId = `${caseID}::${analysisObj.ANALYSIS_ID}`;
    const caseAnalysisName = `${caseID}::${analysisObj.ANALYSIS_NAME}`;
    // let userName = props.userName.replaceAll(' ','_');                        // * did not use .toUpperCase();
    let tmpVariantData = [];
    let userNotes;
    // let reviewRecords;
    // let denovoAssessments;
    // let mrPheneData;

    let bucket = analysisObj.PARQUET_URI.match(/s3:\/\/([^/]*)\//,'')[1] ; // or use analysisObj.JSON_URI
    let uriToLoad = analysisObj.PARQUET_URI.replace(/s3:\/\/[^/]*\//,'');  // or use analysisObj.JSON_URI
    let basePathForAllNotes = `mt_case_notes/CASE_ID=${caseID}/ANALYSIS_ID=${analysisObj.ANALYSIS_ID}/&folder=true`;
    if (isNoteScopeAllAnalysis) basePathForAllNotes = `mt_case_notes/CASE_ID=${caseID}/&folder=true`;

    new Promise(function (resolve, reject) {
      // if(DEVMODE){
      //   console.log("loading data in dev mode!");
      //   bucket = "nch-igm-research-rare-disease" //!analysisObj.JSON_URI.match(/s3:\/\/([^/]*)\//,'')[1] ;// 'nch-igm-vanex';
      //   uriToLoad = "s3://nch-igm-research-rare-disease/2023/RD0420/Churchill/2023-10-18/mitochondrial-vc/RD0420.mitochondrial_vc.json.gz".replace(/s3:\/\/[^/]*\//,'')
      // } 
      resolve(
        GetSignedURL(bucket, uriToLoad, true)
        .then(response => {
          return(downloadMTData(response, ` MT data for ${caseAnalysisName}` ));
        })
      );
    })
    .then( caseTextData => {
      tmpVariantData = caseTextData;
      // console.log("tmpVariantData MT ", tmpVariantData);
      // * sort data by POSITION
      tmpVariantData = tmpVariantData.sort((a, b) => {
          return(a.POS - b.POS); 
      });

      if(loadMyNotes){
        updateCaseLoadingProgressBar(`Loading notes for ${caseAnalysisName}...`, 90);
        return(
          // GetSignedURL('nch-igm-vanex',`mt_case_notes/CASE_ID=${caseID}/USERNAME=${userName}/${userName}.json`)
          GetSignedURL('nch-igm-vanex',`mt_case_notes/CASE_ID=${caseID}/ANALYSIS_ID=${analysisObj.ANALYSIS_ID}/USERNAME=${userName}/${userName}.json`)
          .then(response => downloadIndividualNote(response))
          .catch( e => { toast(`${getCurrentUserFirstName()}'s notes not found.\n(${e.toString()})`, {duration:6000}); return("") })
          // .catch( e => toast.error(`Notes not found (${e.toString()})`, {duration:6000}))
        );
      }
      else{
        return("");
      }


    })
    .then( userNotesResponse => {
      userNotes = parse_JSONL(userNotesResponse).map( myNote => {
        return(
          {
            ...myNote,
            VANEX_TAGS: (myNote['VANEX_TAGS']===true ? 1 : (myNote['VANEX_TAGS']===false ? 0 : myNote['VANEX_TAGS']))
          }
        );
      });
    //   updateCaseLoadingProgressBar(`Loading reviews for ${caseAnalysisName}...`, 92);
    })
    .then( () => {

      let missingVariants;
      if(!!userNotes && userNotes.length > 0){
        missingVariants = 0;
        //! // * Warn user if there is a note for a variant which is not in this dataset
        // Object.keys(userNotes).forEach( nId => {
        //   if(Object.values(tmpVariantData).filter( t => t['CHROMOSOME']===userNotes[nId]['CHROMOSOME']
        //     &&  t['LOC_START']===userNotes[nId]['LOC_START']
        //     &&  t['LOC_END']===userNotes[nId]['LOC_END']
        //     &&  t['SEG_MEAN']===userNotes[nId]['SEG_MEAN'] ).length < 1) {
        //       missingVariants+=1;
        //       console.log(userNotes[nId]); // ! keep this in console??????
        //   }
        // });
      }

      // const sampleNames = new Set();
      // Object.keys(tmpVariantData).forEach( varIndex => {
      //   Object.keys(tmpVariantData[varIndex].SAMPLES).forEach( sampleName => {
      //     sampleNames.add(sampleName);
      //   })
      // });
      // console.log(sampleNames);

      // tmpVariantData.forEach((variant, varIndex) => {
      Object.keys(tmpVariantData).forEach( varIndex => {
        tmpVariantData[varIndex]['ROW_INDEX'] = varIndex;
        tmpVariantData[varIndex]['CHROMOSOME'] = tmpVariantData[varIndex]['CHROM'];
        tmpVariantData[varIndex]['POSITION'] = tmpVariantData[varIndex]['POS'];
        tmpVariantData[varIndex]['GENE'] = tmpVariantData[varIndex]['Locus'];
        tmpVariantData[varIndex]['ENTREZ_ID'] = (!!tmpVariantData[varIndex]['Locus'] && tmpVariantData[varIndex]['Locus']!=="." ? genes_to_ids.ENTREZ_ID[tmpVariantData[varIndex]['Locus']] : null);
        tmpVariantData[varIndex]['MISSENSE'] = "false";
        if (tmpVariantData[varIndex]['AaChange'][0] !== tmpVariantData[varIndex]['AaChange'].slice(-1)) tmpVariantData[varIndex]['MISSENSE'] = "true";
        // console.log(tmpVariantData[varIndex]['AaChange'], tmpVariantData[varIndex]['AaChange'][0], tmpVariantData[varIndex]['AaChange'].slice(-1), tmpVariantData[varIndex]['AaChange'][0] !== tmpVariantData[varIndex]['AaChange'].slice(-1))
        // tmpVariantData[varIndex]['MR_PHENE_PHENOTYPE_TERMS'] = null;

        // if(!!mrPheneData){
        //   let entrezId = tmpVariantData[varIndex]['ENTREZ_ID'];
        //   let inMrPheneRecord = mrPheneData['genes'][entrezId];
        //   if (inMrPheneRecord!==null && inMrPheneRecord !==undefined){
        //     let terms=Object.keys(mrPheneData['terms']).filter(t=> {
        //       if(mrPheneData['terms'][t].genes!==null && mrPheneData['terms'][t].genes!==undefined)
        //         return(mrPheneData['terms'][t].genes.includes(entrezId));
        //       else
        //         return false;
        //     }).map(k => `${mrPheneData['terms'][k].label} (${k})`)
        //     // let terms=Object.keys(mrPheneData['terms']).filter(t=> mrPheneData['terms'][t].genes.includes(entrezId))
        //     // let terms=Object.values(mrPheneData['terms']).filter(t=> t.genes.includes(entrezId)).map(k => `${k.label} (${k.type})`)
        //     tmpVariantData[varIndex]['MR_PHENE_PHENOTYPE_TERMS'] = `[${terms.length}] ${terms.join(', ')}`;
        //     // debugger;
        //   }
        // }

        tmpVariantData[varIndex]['VANEX_TAGS'] = 0;
        tmpVariantData[varIndex]['VANEX_NOTES'] = {CURRENT_USER_NOTE:'', UPDATED_AT:'', ALL_USERS_NOTES:[]}; //, DENOVO_ASSESSMENT:-1
        tmpVariantData[varIndex]['VANEX_REVIEWS'] = {REVIEW_VALUE:null, DENOVO_ASSESSMENT:null, UPDATED_AT:null};
        // * add user notes for this variant
        if(!!userNotes){
          let foundNotes = Object.values(userNotes)
            .filter( t => t['CHROMOSOME']===tmpVariantData[varIndex]['CHROMOSOME']
                      &&  t['POSITION']===tmpVariantData[varIndex]['POSITION']
                      &&  t['REF']===tmpVariantData[varIndex]['REF']
                      &&  t['ALT']===tmpVariantData[varIndex]['ALT'] );
          if(Object.keys(foundNotes).length > 0){
            tmpVariantData[varIndex]['VANEX_TAGS'] =  (foundNotes[0]['VANEX_TAGS']===true ? 1 : foundNotes[0]['VANEX_TAGS']===false ? 0 : foundNotes[0]['VANEX_TAGS']);
            tmpVariantData[varIndex]['VANEX_NOTES'] = {CURRENT_USER_NOTE:foundNotes[0]['VANEX_NOTES'], UPDATED_AT:foundNotes[0]['UPDATED_AT'] || '', ALL_USERS_NOTES:[]}; //, DENOVO_ASSESSMENT:-1
          }
        }
        // * add review for this variant
        // if(!!reviewRecords){
        //   let foundReviews = Object.values(reviewRecords)
        //     .filter( t => t['CHROMOSOME']===tmpVariantData[varIndex]['CHROMOSOME']
        //               &&  t['LOC_START']===tmpVariantData[varIndex]['LOC_START']
        //               &&  t['LOC_END']===tmpVariantData[varIndex]['LOC_END']  );
        //   if(Object.keys(foundReviews).length > 0){
        //     tmpVariantData[varIndex]['VANEX_REVIEWS'] = {...tmpVariantData[varIndex]['VANEX_REVIEWS'], REVIEW_VALUE:foundReviews[0]['REVIEW_VALUE'], UPDATED_AT:(foundReviews[0]['UPDATED_AT'] || null)};
        //     // console.log(tmpVariantData[varIndex]['VANEX_REVIEWS']);
        //   }
        // }
        // * add denovo assessments for this variant
        // if(!!denovoAssessments){
        //   let foundAssessments = Object.values(denovoAssessments)
        //     .filter( t => t['CHROMOSOME']===tmpVariantData[varIndex]['CHROMOSOME']
        //               &&  t['LOC_START']===tmpVariantData[varIndex]['LOC_START']
        //               &&  t['LOC_END']===tmpVariantData[varIndex]['LOC_END']  );
        //   if(Object.keys(foundAssessments).length > 0){
        //     tmpVariantData[varIndex]['VANEX_REVIEWS'] = {...tmpVariantData[varIndex]['VANEX_REVIEWS'], DENOVO_ASSESSMENT:foundAssessments[0]['DENOVO_ASSESSMENT']};
        //     // console.log(tmpVariantData[varIndex]['VANEX_REVIEWS']);
        //   }
        // }

        // sampleNames.forEach( sampleName => {
        //   if(!!tmpVariantData[varIndex].SAMPLES && !tmpVariantData[varIndex]['SAMPLES'][sampleName]){
        //     tmpVariantData[varIndex]['SAMPLES'][sampleName]={"TD":null,"GT_RAW":null,"RD":null,"AD":null,"GQ":null,"PL":null,"DP":null,"GT":null}//{"TD":"","GT_RAW":"","RD":"","AD":"","GQ":"","PL":"","DP":"","GT":""}
        //   }
        // })

        // if (!!tmpVariantData[varIndex].SAMPLES){
        //   Object.keys(tmpVariantData[varIndex].SAMPLES).forEach( sampleName => {
        //     Object.keys(tmpVariantData[varIndex].SAMPLES[sampleName]).forEach((property) => {
        //       tmpVariantData[varIndex][sampleName + '_' + property] = tmpVariantData[varIndex].SAMPLES[sampleName][property];
        //       // if (property==='GT'){
        //       //   tmpVariantData[varIndex][sampleName + '_' + property] = tmpVariantData[varIndex].SAMPLES[sampleName][property];
        //       //   // tmpVariantData[varIndex][getSampleType(sampleName,true) + '_' + sampleName + '_' + property] = tmpVariantData[varIndex].SAMPLES[sampleName][property];
        //       //   // tmpVariantData[varIndex][getSampleType(sampleName,true) + '_' + property] = tmpVariantData[varIndex].SAMPLES[sampleName][property];
        //       // }
        //     });
        //     // if(props.projectBaseURL==='ep'){
        //     if(tmpVariantData[varIndex].SAMPLES[sampleName]['_Alt_Percent']===undefined || tmpVariantData[varIndex].SAMPLES[sampleName]['_Alt_Percent']===null){
        //       tmpVariantData[varIndex][sampleName + '_Alt_Percent'] = Math.round(100*100*Number(tmpVariantData[varIndex].SAMPLES[sampleName]['AD'])/Number(tmpVariantData[varIndex].SAMPLES[sampleName]['DP']))/100 || null;
        //     }
        //   });
        // }
      });

      // console.log("tmpVariantData MT", tmpVariantData);
      //TODO: get column names from db for mother and father
      

      if(missingVariants!==undefined)
        if(missingVariants>0)
          toast.error(`Cannot find coresponding variants for ${missingVariants} notes`, {duration:6000});
        else
          toast.success(`${getCurrentUserFirstName()}'s notes loaded successfully!`);

      let newCase = [caseAnalysisId, tmpVariantData, []]; // ? maybe add date as the last element?        , new Date()

      if(currentCaseIndex >= 0 && reloadCaseData){
        setActiveCaseIndexInOpenCases(currentCaseIndex);
        setOpenCases(prevOpenCases => prevOpenCases.map(indvCase => (indvCase[0] === caseAnalysisId ? newCase : indvCase)))
      } else {
        setActiveCaseIndexInOpenCases(openCases.length);
        setOpenCases([...openCases, newCase]);
      }
      
      if(loadExistingNotes){      
        // GetSignedURL('nch-igm-vanex',`mt_case_notes/CASE_ID=${caseID}/&folder=true`) 
        GetSignedURL('nch-igm-vanex', basePathForAllNotes) 
        .then(response => downloadAllExistingNotes(response, caseAnalysisId, analysisObj))
        .catch( e => {setIsLoadingNotes(false); toast.error(`Error in retrieving notes: ${e.toString()}`, {duration:8000}); })
        // .catch( e => {setIsLoadingNotes(false); setErrorLog([`Error in retrieving notes: ${e}`, ''])});
      }
      showAnalysisPanel(caseID, analysisObj.ANALYSIS_ID);
    })
    .catch( e => setErrorLog([`No data for ${caseAnalysisId} found. (${e})`, '']));
  }

  function loadSVdata(caseID, analysisObj, userName, currentCaseIndex){
    const caseAnalysisId = `${caseID}::${analysisObj.ANALYSIS_ID}`;
    const caseAnalysisName = `${caseID}::${analysisObj.ANALYSIS_NAME}`;
    // console.log(caseAnalysisId,caseAnalysisName)
    // let userName = props.userName.replaceAll(' ','_');                        // * did not use .toUpperCase();
    let tmpVariantData = [];
    let userNotes;
    let mrPheneData;
    let reviewRecords;
    
    // let probandSampleId;
    // let prbSample = analysisObj.SAMPLES.find(smp => smp.SAMPLE_TYPE.toLowerCase()==="proband");
    // if(!!prbSample && !!prbSample['SAMPLE_ID'])
    //   probandSampleId=prbSample['SAMPLE_ID'];
    // let bucket = 'nch-igm-vanex';
    // let uriToLoad = `${props.project}/sv_cases/CASE_ID=${caseID}/${analysisObj.ANALYSIS_ID}/${probandSampleId}/&folder=true`;
    // console.log('WORKING: uritoload',uriToLoad)

    let basePathForAllNotes = `sv_case_notes/CASE_ID=${caseID}/ANALYSIS_ID=${analysisObj.ANALYSIS_ID}/&folder=true`;
    if (isNoteScopeAllAnalysis) basePathForAllNotes = `sv_case_notes/CASE_ID=${caseID}/&folder=true`;

    new Promise(function (resolve, reject) {

        updateCaseLoadingProgressBar(`Requesting SV data for ${caseAnalysisName}...`,5);
        let allSampleData;
        let probandSampleId;
        let motherSampleId;
        let fatherSampleId;
        let allSamplePromises = [];
        let prbSample = analysisObj.SAMPLES.find(smp => smp.SAMPLE_TYPE.toLowerCase()==="proband");
        if(!!prbSample && !!prbSample['SAMPLE_ID'])
          probandSampleId=prbSample['SAMPLE_ID'];
        else
          reject("Proband's sample not found!");
        let motherSample = analysisObj.SAMPLES.find(smp => smp.SAMPLE_TYPE.toLowerCase()==="mother");
        if(!!motherSample && !!motherSample['SAMPLE_ID'])
          motherSampleId=motherSample['SAMPLE_ID'];
        let fatherSample = analysisObj.SAMPLES.find(smp => smp.SAMPLE_TYPE.toLowerCase()==="father");
        if(!!fatherSample && !!fatherSample['SAMPLE_ID'])
          fatherSampleId=fatherSample['SAMPLE_ID'];

        analysisObj.SAMPLES.forEach( (sampleInfo, smpIndex) =>{
          let bucket = 'nch-igm-vanex';
          let uriToLoad = `${props.project}/sv_cases/CASE_ID=${caseID}/${analysisObj.ANALYSIS_ID}/${sampleInfo.SAMPLE_ID}/&folder=true`


          allSamplePromises.push(
            new Promise(function (resolve, reject) {
              resolve(
                GetSignedURL(bucket ,uriToLoad, true)
                .then(response => (downloadCnvData(response, caseAnalysisName )) )
                .then(response => {
                  let prgBarValue = Math.round(80*smpIndex/analysisObj.SAMPLES.length);
                  updateCaseLoadingProgressBar(`Loading SV data for ${sampleInfo.SAMPLE_ID}...`, prgBarValue);
                  return({sampleid:sampleInfo.SAMPLE_ID, data:response}) 
                })
              );
            })
          );
        });

        Promise.all(allSamplePromises)
        .then(results => {
          // console.log(results)
          results.forEach( smp => { allSampleData = {...allSampleData, [smp.sampleid]:parse_JSONL(smp.data)}});
          // console.log('allSampleData',allSampleData);
          updateCaseLoadingProgressBar(`Calculating Inheritance for ${caseAnalysisName}...`, 82);
          if(!!allSampleData && !!allSampleData[probandSampleId])
            resolve(allSampleData[probandSampleId].map( segData => {
              let otherSampleIds = Object.keys(allSampleData).filter(k => k!==probandSampleId);
              let otherSample_GTs = {};
              otherSampleIds.forEach(smpID => { 
                let overlapData = {};
                // console.log('allSampleData[smpID]',allSampleData[smpID][0])
                overlapData = findMaxOverlaps(segData, allSampleData[smpID]);
                otherSample_GTs = {
                  ...otherSample_GTs, 
                  [`${smpID}_GT`]:overlapData[0],
                  [`${smpID}_OL`]:overlapData[1],
                  [`${smpID}_SIM`]:overlapData[3]
                } 
                otherSample_GTs[`${smpID}_OL`]['CALLERS'] = (!!otherSample_GTs[`${smpID}_OL`]['CALLERS']?otherSample_GTs[`${smpID}_OL`]['CALLERS']:'UNKNOWN')
              } );
              let inheritance = "UNKNOWN"
              let probandGeno = "0/0"
              // probandGeno = (segData.GT==="0/0"? "het" : (segData.GT === "1/1" ? "hom" : segData.GT))
              inheritance = determineInheritance(probandGeno, otherSample_GTs, motherSampleId, fatherSampleId)
              return({
                ...segData, 
                [`${probandSampleId}_GT`]:100,
                ...otherSample_GTs,
                'CHR2': segData.MANTA_CHROMOSOME_2 || segData.GRIDSS_CHROMOSOME_2 || segData.CHR2,
                'POS2': segData.MANTA_POSITION_2 || segData.GRIDSS_POSITION_2 || segData.POS2,
                'INHERITANCE':inheritance,
                // 'CALLERS': (!!segData.CALLERS ? segData.CALLERS  :"PACBIO,MANTA,GRIDSS"),
                // 'START_IN_REPEAT': (!!segData.START_IN_REPEAT ? segData.START_IN_REPEAT  :["NA"]),
                // 'END_IN_REPEAT': (!!segData.END_IN_REPEAT ? segData.END_IN_REPEAT  :["NA"]),
                // 'TYPE': segData.SVTYPE,
                // 'SEG_SIZE': Math.abs(segData.SEG_SIZE),
                'MAX_RECURRENT_OVERLAP': segData.CALLERS === "PACBIO"? segData.MAX_RECURRENT_OVERLAP:(segData?.GRIDSS_MAX_RECURRENT_OVERLAP||segData?.MANTA_MAX_RECURRENT_OVERLAP) ?Math.max(segData.GRIDSS_MAX_RECURRENT_OVERLAP,segData.MANTA_MAX_RECURRENT_OVERLAP):0,
                'CHR_NUM':(segData.CHROMOSOME==="X" ? 23 : (segData.CHROMOSOME==="Y" ? 24 : parseInt(segData.CHROMOSOME)))//,
                });
              })
            );
          else
            reject("no data found!")
        })
        .catch( e => setErrorLog([`No data for ${caseAnalysisId} found. \n [${e}]`, '']));
    })
    .then( mergedSvData => {
      // console.log('mergedSvData',mergedSvData)
      tmpVariantData = mergedSvData;
      // * sort data by CHROMOSOME and POSITION 
      tmpVariantData = tmpVariantData.sort((a, b) => {
        if (a.CHROMOSOME === b.CHROMOSOME){ 
          return(a.LOC_START - b.LOC_START);
        } else { 
          if(isNaN(a.CHROMOSOME) && isNaN(b.CHROMOSOME)){
            return(a.CHROMOSOME==='X' ? -1 : 1);
          } else if(isNaN(a.CHROMOSOME) || isNaN(b.CHROMOSOME)){
            return(isNaN(a.CHROMOSOME) ? 1 : -1);
          } else {
            return(Number(a.CHROMOSOME) - Number(b.CHROMOSOME));
          }
        }
      });
      
      Object.keys(tmpVariantData).forEach(tmpIndex => {
        const rawEntrez = tmpVariantData[tmpIndex]['ENTREZ_IDS'];
      
        let entrezIds = [];
      
        if (Array.isArray(rawEntrez)) {
          entrezIds = rawEntrez.map(id => String(id).trim());
        } else if (typeof rawEntrez === 'string') {
          entrezIds = rawEntrez.split(',').map(id => id.trim());
        } else if (rawEntrez !== null && rawEntrez !== undefined) {
          entrezIds = [String(rawEntrez).trim()];
        }
      
        const cfmMatches = entrezIds
          .map(id => cfmGenes[id])
          .filter(v => v !== undefined && v !== null);
      
        const nmMatches = entrezIds
          .map(id => nmGenes[id])
          .filter(v => v !== undefined && v !== null);
      
        tmpVariantData[tmpIndex]['CFM_GENE_LIST'] =
          cfmMatches.length ? cfmMatches.join(',') : null;
      
        tmpVariantData[tmpIndex]['NM_GENE_LIST'] =
          nmMatches.length ? nmMatches.join(',') : null;
      });
      
      if(loadMyNotes){
        updateCaseLoadingProgressBar(`Loading notes for ${caseAnalysisName}...`, 90);
        return(
          // GetSignedURL('nch-igm-vanex',`case_notes/CASE_ID=${caseID}/USERNAME=${userName}/${userName}.json`)
          GetSignedURL('nch-igm-vanex',`sv_case_notes/CASE_ID=${caseID}/ANALYSIS_ID=${analysisObj.ANALYSIS_ID}/USERNAME=${userName}/${userName}.json`)
          .then(response => downloadIndividualNote(response))
          .catch( e => { toast(`${getCurrentUserFirstName()}'s notes not found.\n(${e.toString()})`, {duration:6000}); return("") })
          // .catch( e => toast.error(`Notes not found (${e.toString()})`, {duration:6000}))
        );
      }
      else{
        return("");
      }
    })
    .then( userNotesResponse => {
      userNotes = parse_JSONL(userNotesResponse).map( myNote => {
        return(
          {
            ...myNote,
            VANEX_TAGS: (myNote['VANEX_TAGS']===true ? 1 : (myNote['VANEX_TAGS']===false ? 0 : myNote['VANEX_TAGS']))
          }
        );
      });
      updateCaseLoadingProgressBar(`Loading reviews for ${caseAnalysisName}...`, 92);
      return(
        // * this is a gzip file request!
        GetSignedURL('nch-igm-vanex',`sv_case_notes/CASE_ID=${caseID}/ANALYSIS_ID=${analysisObj.ANALYSIS_ID}/USERNAME=REVIEWS/${caseID}_${analysisObj.ANALYSIS_ID}_REVIEWS.json.gz`, true)
        .then(response => downloadReviewRecordsOrDenovoAssessments(response, "review records"))
        .catch( e => console.error(`Error in retrieving review records: ${e}`))
      );
    })
    .then( reviewsResponse => {
      reviewRecords = reviewsResponse;
      
      return null;

    })
    .then( (mrPheneSubjectDataResponse) => {
      mrPheneData = mrPheneSubjectDataResponse;
      // console.log(mrPheneData);
      // setActiveCaseInfo({...activeCaseInfo, MRPHENE_SUBJECT_ID: activeCaseInfo['MRPHENE_SUBJECT_ID'], MRPHENE_SUBJECT_DATA:mrPheneSubjectDataResponse})

      updateCaseLoadingProgressBar(`Processing data for ${caseAnalysisName}...`, 98);
      return new Promise(resolve => {
        setTimeout(() => resolve('resolved'), 10);
      });
      
    })
    .then( () => {
      Object.keys(tmpVariantData).forEach( varIndex => {
        tmpVariantData[varIndex]['ROW_INDEX'] = varIndex;
        tmpVariantData[varIndex]['VANEX_TAGS'] = 0;
        tmpVariantData[varIndex]['VANEX_NOTES'] = {CURRENT_USER_NOTE:'', UPDATED_AT:'', ALL_USERS_NOTES:[]}; //, DENOVO_ASSESSMENT:-1
        tmpVariantData[varIndex]['VANEX_REVIEWS'] = {REVIEW_VALUE:null, DENOVO_ASSESSMENT:null, UPDATED_AT:null};

        const rawPhenotypes = tmpVariantData[varIndex]['OMIM_PHENOTYPES'];

        const filtered = filterOMIMPhenotypes(rawPhenotypes);
        tmpVariantData[varIndex]['OMIM_PHENOTYPES'] = filtered;
        const rawNearbyPhenotypes = tmpVariantData[varIndex]['NEARBY_OMIM_PHENOTYPES'];

        const nearbyFiltered = filterOMIMPhenotypes(rawNearbyPhenotypes);
        tmpVariantData[varIndex]['NEARBY_OMIM_PHENOTYPES'] = nearbyFiltered;

        const locStart = parseInt(tmpVariantData[varIndex]['LOC_START'], 10);
        const locStop = parseInt(tmpVariantData[varIndex]['LOC_END'], 10);

        const starts_MMS = (tmpVariantData[varIndex]['ALL_MMS_START'] || '')
          .split(';')
          .map(s => parseInt(s, 10))
          .filter(n => !isNaN(n));
      
        const stops_MMS = (tmpVariantData[varIndex]['ALL_MMS_STOP'] || '')
          .split(';')
          .map(s => parseInt(s, 10))
          .filter(n => !isNaN(n));
      
        const overlapPercentages = [];
      
        for (let i = 0; i < Math.min(starts_MMS.length, stops_MMS.length); i++) {
          const mmsStart = starts_MMS[i];
          const mmsStop = stops_MMS[i];
          const mmsLength = mmsStop - mmsStart;
      
          const overlapStart = Math.max(locStart, mmsStart);
          const overlapStop = Math.min(locStop, mmsStop);
      
          let overlapLength = 0;
          if (overlapStart < overlapStop) {
            overlapLength = overlapStop - overlapStart;
          }
      
          const percentage = mmsLength > 0 ? (overlapLength / mmsLength) : -1;
          overlapPercentages.push(percentage.toFixed(3));
        }
      
        tmpVariantData[varIndex]['MMS_OVERLAP_PERCENTAGES'] = overlapPercentages;
        const numericOverlaps = overlapPercentages.map(Number).filter(n => !isNaN(n));

        if (numericOverlaps.length > 0) {
          const maxOverlap = Math.max(...numericOverlaps);
          tmpVariantData[varIndex]['MAX_MMS_OVERLAP_PERCENTAGE'] = Math.round(maxOverlap * 100);
          // tmpVariantData[varIndex]['MAX_MMS_OVERLAP_PERCENTAGE'] = maxOverlap;
        } else {
          // Leave it undefined or explicitly set to null
          tmpVariantData[varIndex]['MAX_MMS_OVERLAP_PERCENTAGE'] = null;
        }


        // * add user notes for this variant
        if(!!userNotes){
          let foundNotes = Object.values(userNotes)
            .filter( t => t['CHROMOSOME']===tmpVariantData[varIndex]['CHROMOSOME']
                      &&  t['LOC_START']===tmpVariantData[varIndex]['LOC_START']
                      &&  t['LOC_END']===tmpVariantData[varIndex]['LOC_END'] );
          if(Object.keys(foundNotes).length > 0){
            tmpVariantData[varIndex]['VANEX_TAGS'] =  (foundNotes[0]['VANEX_TAGS']===true ? 1 : foundNotes[0]['VANEX_TAGS']===false ? 0 : foundNotes[0]['VANEX_TAGS']);
            tmpVariantData[varIndex]['VANEX_NOTES'] = {CURRENT_USER_NOTE:foundNotes[0]['VANEX_NOTES'], UPDATED_AT:foundNotes[0]['UPDATED_AT'] || '', ALL_USERS_NOTES:[]}; //, DENOVO_ASSESSMENT:-1
          }
        }
        // * add review for this variant
        if(!!reviewRecords){
          let foundReviews = Object.values(reviewRecords)
          .filter( t => t['CHROMOSOME']===tmpVariantData[varIndex]['CHROMOSOME']
            &&  t['LOC_START']===tmpVariantData[varIndex]['LOC_START']
            &&  t['LOC_END']===tmpVariantData[varIndex]['LOC_END'] );
          if(Object.keys(foundReviews).length > 0){
            tmpVariantData[varIndex]['VANEX_REVIEWS'] = {...tmpVariantData[varIndex]['VANEX_REVIEWS'], REVIEW_VALUE:foundReviews[0]['REVIEW_VALUE'], UPDATED_AT:(foundReviews[0]['UPDATED_AT'] || null)};
            // console.log(tmpVariantData[varIndex]['VANEX_REVIEWS']);
          }
        }
      });

      //TODO: get column names from db for mother and father
      console.log(tmpVariantData);

      let newCase = [caseAnalysisId, tmpVariantData, []]; // ? maybe add date as the last element?        , new Date()
      if(currentCaseIndex >= 0 && reloadCaseData){
        setActiveCaseIndexInOpenCases(currentCaseIndex);
        setOpenCases(prevOpenCases => prevOpenCases.map(indvCase => (indvCase[0] === caseAnalysisId ? newCase : indvCase)))
      } else {
        setActiveCaseIndexInOpenCases(openCases.length);
        setOpenCases([...openCases, newCase]);
      }
      
      if(loadExistingNotes){      
        // GetSignedURL('nch-igm-vanex',`case_notes/CASE_ID=${caseID}/&folder=true`) 
        console.log("basePathForAllNotes", basePathForAllNotes)
        GetSignedURL('nch-igm-vanex', basePathForAllNotes) 
        .then(response => { 
          console.log("response", response)
          downloadAllExistingSVNotes(response, caseAnalysisId, analysisObj)})
        // .then(response => downloadAllExistingNotes(response, caseAnalysisId, analysisObj))
        .catch( e => {setIsLoadingNotes(false); toast.error(`Error in retrieving notes: ${e.toString()}`, {duration:8000}); })
        // .catch( e => {setIsLoadingNotes(false); setErrorLog([`Error in retrieving notes: ${e}`, ''])});
      }
      showAnalysisPanel(caseID, analysisObj.ANALYSIS_ID);
    })
    .catch( e => setErrorLog([`No data for ${caseAnalysisId} found. (${e})`, '']));
  }

  function loadCNVdata(caseID, analysisObj, userName, currentCaseIndex){
    // console.log('analysisObj: ', analysisObj);
    // console.log('caseID',caseID)

    const caseAnalysisId = `${caseID}::${analysisObj.ANALYSIS_ID}`;
    // console.log('caseAnalysisID',caseAnalysisId)
    const caseAnalysisName = `${caseID}::${analysisObj.ANALYSIS_NAME}`;
    // console.log('caseAnalysisName',caseAnalysisName)
    // let userName = props.userName.replaceAll(' ','_');                        // * did not use .toUpperCase();
    let tmpVariantData = [];
    let userNotes;
    let geneDosage;
    let regionDosage;
    // let reviewRecords;
    // let denovoAssessments;
    let mrPheneData;
    let basePathForAllNotes = `cnv_case_notes/CASE_ID=${caseID}/ANALYSIS_ID=${analysisObj.ANALYSIS_ID}/&folder=true`;
    if (isNoteScopeAllAnalysis) basePathForAllNotes = `cnv_case_notes/CASE_ID=${caseID}/&folder=true`;

    new Promise(function (resolve, reject) {
      // if(DEVMODE){
      //   let probandData;
      //   let motherData;
      //   let fatherData;
      //   console.log("loading data in dev mode!");
      //   let tmpMergedCnvData;
      //   readTextFile(pData);
      //   probandData = parse_JSONL(JSONLText);
      //   readTextFile(mData);
      //   motherData = parse_JSONL(JSONLText);
      //   readTextFile(fData);
      //   fatherData = parse_JSONL(JSONLText);
      //   let probandSampleId;
      //   let prbSample = analysisObj.SAMPLES.find(smp => smp.SAMPLE_TYPE.toLowerCase()==="proband");
      //   if(!!prbSample && !!prbSample['SAMPLE_ID']) probandSampleId=prbSample['SAMPLE_ID'];

      //   if( !! probandData && !!motherData && !!fatherData){
      //     // TODO: this can be optimized by filtering all segments in each chromosome and then looking at calls, instead of filtering the large set for each call
      //     tmpMergedCnvData = probandData.map( segData => {
      //       let mPercent = findMaxOverlaps(segData, motherData)[0];
      //       let fPercent = findMaxOverlaps(segData, fatherData)[0];

      //       return({
      //         ...segData, 
      //         [`${probandSampleId}_GT`]:100,
      //         "RD0386_M_S-2022-025806_GT":mPercent,
      //         "RD0386_F_S-2022-025805_GT":fPercent //,
      //       //   [`${probandSampleId}_Alt_Percent`]:100,
      //       //   "RD0386_M_S-2022-025806_Alt_Percent":mPercent,
      //       //   "RD0386_F_S-2022-025805_Alt_Percent":fPercent
      //       })
      //     });
      //   }
      //   resolve(tmpMergedCnvData);


      // } else {

        updateCaseLoadingProgressBar(`Requesting CNV data for ${caseAnalysisName}...`,5);
        let allSampleData;
        let probandSampleId;
        let allSamplePromises = [];
        let prbSample = analysisObj.SAMPLES.find(smp => smp.SAMPLE_TYPE.toLowerCase()==="proband");
        if(!!prbSample && !!prbSample['SAMPLE_ID'])
          probandSampleId=prbSample['SAMPLE_ID'];
        else
          reject("Proband's sample not found!");

        // let otherSampleIds = analysisObj.SAMPLES.filter(smp => smp.SAMPLE_TYPE.toLowerCase()!=="proband").map(smp => smp.SAMPLE_ID)
        // analysisObj.SAMPLES.filter(smp => smp.SAMPLE_TYPE.toLowerCase()==="proband").forEach(sampleInfo =>{

        // const gzipedJsonFileBasePath = (!!analysisObj.JSON_URI ? true : false);
        analysisObj.SAMPLES.forEach( (sampleInfo, smpIndex) =>{
          let bucket = 'nch-igm-vanex';
          let uriToLoad = `${props.project}/cnv_cases/CASE_ID=${caseID}/${analysisObj.ANALYSIS_ID}/${sampleInfo.SAMPLE_ID}/&folder=true`
          // if(gzipedJsonFileBasePath){
          //   bucket =analysisObj.JSON_URI.match(/s3:\/\/([^/]*)\//,'')[1];
          //   uriToLoad= analysisObj.JSON_URI.replace(/s3:\/\/[^/]*\//,'');
          //   uriToLoad= `${uriToLoad}/${sampleInfo.SAMPLE_ID}/&folder=true`;
          // }
          // console.log("uriToLoad",uriToLoad)

          allSamplePromises.push(
            new Promise(function (resolve, reject) {
              resolve(
                GetSignedURL(bucket ,uriToLoad, true)
                .then(response => (downloadCnvData(response, caseAnalysisName )) )
                .then(response => {
                  let prgBarValue = Math.round(80*smpIndex/analysisObj.SAMPLES.length);
                  updateCaseLoadingProgressBar(`Loading CNV data for ${sampleInfo.SAMPLE_ID}...`, prgBarValue);
                  return({sampleid:sampleInfo.SAMPLE_ID, data:response}) 
                })
                // .then(response => (downloadCaseData(response, caseAnalysisName )) )
              );
            })
          );
        });

        Promise.all(allSamplePromises)
          .then(results => {
            const allSampleData = {};  // scoped locally, guaranteed to be defined
          
            results.forEach(smp => {
              const parsed = parse_JSONL(smp.data);
              // console.log(`${smp.sampleid}: ${parsed.length} segments`);
              allSampleData[smp.sampleid] = parsed;
            });

            if (analysisObj.ANALYSIS_TYPE === 'CNV_Somatic') {
              // console.log('CNV_SOMATIC')
              const segmentKey = seg =>
                `${seg.CHROMOSOME}:${seg.LOC_START}:${seg.LOC_END}`;
              // Collect all segments across samples
              const allSegments = Object.values(allSampleData).flat();

              // Deduplicate by coordinate
              const uniqueSegmentsMap = new Map();

              allSegments.forEach(seg => {
                const key = segmentKey(seg);
                if (!uniqueSegmentsMap.has(key)) {
                  uniqueSegmentsMap.set(key, seg);
                }
              });

              const uniqueSegments = Array.from(uniqueSegmentsMap.values());
              const combinedSegments = uniqueSegments.map(segData => {

                let sampleMetrics = {};
                let maxSegMean = segData.SEG_MEAN; // start with current segment
                Object.entries(allSampleData).forEach(([sampleId, otherData]) => {
                  const overlapData = findMaxOverlaps(segData, otherData);
                  
                  sampleMetrics = {
                    ...sampleMetrics,
                    [`${sampleId}_GT`]: overlapData[0],
                    [`${sampleId}_OL`]: overlapData[1],
                    [`${sampleId}_SIM`]: overlapData[3]
                  };
                  // Assuming overlapData returns the matched segment
                  const overlappingSeg = overlapData[4]; // adjust index if needed

                  if (overlappingSeg && overlappingSeg.SEG_MEAN !== undefined) {
                    if (Math.abs(overlappingSeg.SEG_MEAN) > Math.abs(maxSegMean)) {
                      maxSegMean = overlappingSeg.SEG_MEAN;
                    }
                  }
                });
                
                return {
                  ...segData,
                  ...sampleMetrics,
                  CHR_NUM:
                    segData.CHROMOSOME === "X" ? 23 :
                    segData.CHROMOSOME === "Y" ? 24 :
                    parseInt(segData.CHROMOSOME),
                  ABS_SEG_MEAN: Math.abs(maxSegMean)
                };
              });
              // const combinedSegments = Object.entries(allSampleData).flatMap(([sampleId, segList]) =>
              //   segList.map(segData => {
              //     let otherSample_GTs = {};
              //     Object.entries(allSampleData).forEach(([otherId, otherData]) => {
              //       const overlapData = findMaxOverlaps(segData, otherData);
              //       otherSample_GTs = {
              //         ...otherSample_GTs,
              //         [`${otherId}_GT`]: overlapData[0],
              //         [`${otherId}_OL`]: overlapData[1],
              //         [`${otherId}_SIM`]: overlapData[3]
              //       };
              //     });
              //     return {
              //       ...segData,
              //       [`${sampleId}_GT`]: 100,
              //       ...otherSample_GTs,
              //       'CHR_NUM': segData.CHROMOSOME === "X" ? 23 : (segData.CHROMOSOME === "Y" ? 24 : parseInt(segData.CHROMOSOME)),
              //       'ABS_SEG_MEAN': Math.abs(segData.SEG_MEAN),
              //       'SOURCE_SAMPLE_ID': sampleId  // optional but helpful
              //     };
              //   })
              // );
              // console.log("Final total segments returned:", combinedSegments.length);
              resolve(combinedSegments);
            }
        
          else if (!!allSampleData && !!allSampleData[probandSampleId]) {
            console.log('CNV')
            resolve(allSampleData[probandSampleId].map(segData => {
              let otherSampleIds = Object.keys(allSampleData).filter(k => k !== probandSampleId);
              let otherSample_GTs = {};
              otherSampleIds.forEach(smpID => {
                const overlapData = findMaxOverlaps(segData, allSampleData[smpID]);
                otherSample_GTs = {
                  ...otherSample_GTs,
                  [`${smpID}_GT`]: overlapData[0],
                  [`${smpID}_OL`]: overlapData[1],
                  [`${smpID}_SIM`]: overlapData[3]
                };
              });
              return {
                ...segData,
                [`${probandSampleId}_GT`]: 100,
                ...otherSample_GTs,
                'CHR_NUM': segData.CHROMOSOME === "X" ? 23 : (segData.CHROMOSOME === "Y" ? 24 : parseInt(segData.CHROMOSOME)),
                'ABS_SEG_MEAN': Math.abs(segData.SEG_MEAN)
              };
            }));
          }
        
          else {
            reject("no data found!");
          }
        })
        .catch(e => setErrorLog([`No data for ${caseAnalysisId} found.\n[${e}]`, '']));
        
      // } // * END OF if/else block
    })
    .then( mergedCnvData => {
      tmpVariantData = mergedCnvData;
      // console.log("tmpVariantData", tmpVariantData)
      // !! do not need to sort now
      // // * sort data by CHROMOSOME and POSITION
      // // tmpVariantData = tmpVariantData.sort((a, b) => (a.CHROMOSOME.localeCompare(b.CHROMOSOME) || a.POSITION - b.POSITION) ); 
      // tmpVariantData = tmpVariantData.sort((a, b) => {
      //   if (a.CHROMOSOME === b.CHROMOSOME){ 
      //     return(a.POSITION - b.POSITION);
      //   } else { 
      //     if(isNaN(a.CHROMOSOME) && isNaN(b.CHROMOSOME)){
      //       return(a.CHROMOSOME==='X' ? -1 : 1);
      //     } else if(isNaN(a.CHROMOSOME) || isNaN(b.CHROMOSOME)){
      //       return(isNaN(a.CHROMOSOME) ? 1 : -1);
      //     } else {
      //       return(Number(a.CHROMOSOME) - Number(b.CHROMOSOME));
      //     }
      //   }
      // });
      updateCaseLoadingProgressBar(`Loading CNV dosage Sensitivity for ${caseAnalysisName}...`, 90);
      return(
        GetSignedURL('nch-igm-vanex',`CNV_resources/ClinGen_Dosage/ClinGen_gene_curation_list_GRCh38.tsv`)
        .then(response => downloadIndividualNote(response))
        .catch(e => console.error(`Error in retrieving CNV Gene Dosage Info: ${e}`))
      );
    })
    .then( geneDosageResponse => {
      geneDosage = tsvToArray(geneDosageResponse);
      // console.log('geneDosage',geneDosage);

      geneDosage = geneDosage.map(item => {
        let tempInfo = item["GENOMIC LOCATION"].split(":");

        item["CHROMOSOME"] = tempInfo[0].replace("chr","");
        item["LOC_START"] = tempInfo[1].split("-")[0]
        item["LOC_END"] = tempInfo[1].split("-")[1]
        return(item)
      });
      // console.log("geneDOsage",geneDosage)

      return(
        GetSignedURL('nch-igm-vanex',`CNV_resources/ClinGen_Dosage/ClinGen_region_curation_list_GRCh38.tsv`)
        .then(response => downloadIndividualNote(response))
        .catch(e => console.error(`Error in retrieving CNV Gene Dosage Info: ${e}`))
      );
    })
    .then( regionDosageResponse => {
      regionDosage = tsvToArray(regionDosageResponse);
      // console.log('regionDosage',regionDosage);
      regionDosage = regionDosage.map(item => {
        if (item["GENOMIC LOCATION"]!=="tbd"){
          // console.log(item["GENOMIC LOCATION"])
          let tempInfo = item["GENOMIC LOCATION"].split(":");
          
          item["CHROMOSOME"] = tempInfo[0].replace("chr","");
          item["LOC_START"] = tempInfo[1].split("-")[0]
          item["LOC_END"] = tempInfo[1].split("-")[1]
          return(item);
        }
        else{
          return("");
        }
      });

      Object.keys(tmpVariantData).forEach(tmpIndex => {
        const rawEntrez = tmpVariantData[tmpIndex]['ENTREZ_IDS'];
      
        let entrezIds = [];
      
        if (Array.isArray(rawEntrez)) {
          entrezIds = rawEntrez.map(id => String(id).trim());
        } else if (typeof rawEntrez === 'string') {
          entrezIds = rawEntrez.split(',').map(id => id.trim());
        } else if (rawEntrez !== null && rawEntrez !== undefined) {
          entrezIds = [String(rawEntrez).trim()];
        }
      
        const cfmMatches = entrezIds
          .map(id => cfmGenes[id])
          .filter(v => v !== undefined && v !== null);
      
        const nmMatches = entrezIds
          .map(id => nmGenes[id])
          .filter(v => v !== undefined && v !== null);
      
        tmpVariantData[tmpIndex]['CFM_GENE_LIST'] =
          cfmMatches.length ? cfmMatches.join(',') : null;
      
        tmpVariantData[tmpIndex]['NM_GENE_LIST'] =
          nmMatches.length ? nmMatches.join(',') : null;
      });
      
    
      if(loadMyNotes){
        updateCaseLoadingProgressBar(`Loading notes for ${caseAnalysisName}...`, 92);
        return(
          // GetSignedURL('nch-igm-vanex',`cnv_case_notes/CASE_ID=${caseID}/USERNAME=${userName}/${userName}.json`)
          GetSignedURL('nch-igm-vanex',`cnv_case_notes/CASE_ID=${caseID}/ANALYSIS_ID=${analysisObj.ANALYSIS_ID}/USERNAME=${userName}/${userName}.json`)
          .then(response => downloadIndividualNote(response))
          .catch( e => { toast(`${getCurrentUserFirstName()}'s notes not found.\n(${e.toString()})`, {duration:6000}); return("") })
          // .catch( e => toast.error(`Notes not found (${e.toString()})`, {duration:6000}))
        );
      }
      else{
        return("");
      }
    })
    .then( userNotesResponse => {
      userNotes = parse_JSONL(userNotesResponse).map( myNote => {
        return(
          {
            ...myNote,
            VANEX_TAGS: (myNote['VANEX_TAGS']===true ? 1 : (myNote['VANEX_TAGS']===false ? 0 : myNote['VANEX_TAGS']))
          }
        );
      });

    // !!! do not have any reviews yet for CNV
    //   updateCaseLoadingProgressBar(`Loading reviews for ${caseAnalysisName}...`, 92);
    //   return(
    //     // * this is a gzip file request!
    //     GetSignedURL('nch-igm-vanex',`cnv_case_notes/CASE_ID=${caseID}/ANALYSIS_ID=${analysisObj.ANALYSIS_ID}/USERNAME=REVIEWS/${caseID}_${analysisObj.ANALYSIS_ID}_REVIEWS.json.gz`, true)
    //     .then(response => downloadReviewRecordsOrDenovoAssessments(response, "review records"))
    //     .catch( e => console.error(`Error in retrieving review records: ${e}`))
    //   );
    // })
    // .then( reviewsResponse => {
    //   reviewRecords = reviewsResponse;
  
    // !!! do not have any de novo assments yet for CNV
    //   updateCaseLoadingProgressBar(`Loading De Novo Assessments for ${caseAnalysisName}...`, 94);
    //   return(
    //     // * this is a gzip file request!
    //     GetSignedURL('nch-igm-vanex',`denovo_assessments/${caseID}.json.gz`, true)
    //     .then(response => downloadReviewRecordsOrDenovoAssessments(response, "de novo assessments"))
    //     .catch( e => console.error(`Error in retrieving de novo assessments: ${e}`))
    //   );
    // })
    // .then( denovoAssessmentsResponse => {
    //   denovoAssessments = denovoAssessmentsResponse;
    //   // console.log('denovoAssessmentsResponse:'); // ! comment it out 
    //   // console.log(denovoAssessments); // ! comment it out 

      if(loadMrPheneSubjectData && !!activeCaseInfo && activeCaseInfo['MRPHENE_SUBJECT_ID']!==null && activeCaseInfo['MRPHENE_SUBJECT_ID']!==undefined ){
        updateCaseLoadingProgressBar(`Loading Mr Phene data for ${caseAnalysisName}...`, 96);
        
        return new Promise(function (resolve, reject) {
          Auth.currentSession().then(data => {
            let endpoint = `${MRPHENE_ENDPOINT_BASE}subject/${activeCaseInfo['MRPHENE_SUBJECT_ID']}`
            // let endpoint = `${MRPHENE_ENDPOINT_BASE}gene_list/${activeItemId}`
            // console.log(endpoint);
            var id_token = data.getIdToken().getJwtToken();
            fetch(endpoint, {
              mode: 'cors',
              headers: {
                'Authorization': id_token                
              }
            })
            .then(result => result.json())
            .then(result => {
              // console.log(result);
              if(!!result && !!result.genes && Object.values(result.genes).length >0){
                resolve(result);
              }
              else
                throw Error(`Found no genes in the Mr. Phene profile.`);
            }).catch(e => {
              reject("Failed to load subject id list. " + String(e));
            })
          });
        });
      }
      
      return null;

    })
    .then( (mrPheneSubjectDataResponse) => {
      mrPheneData = mrPheneSubjectDataResponse;
      console.log(mrPheneData);
      // setActiveCaseInfo({...activeCaseInfo, MRPHENE_SUBJECT_ID: activeCaseInfo['MRPHENE_SUBJECT_ID'], MRPHENE_SUBJECT_DATA:mrPheneSubjectDataResponse})

      updateCaseLoadingProgressBar(`Processing data for ${caseAnalysisName}...`, 98);
      return new Promise(resolve => {
        setTimeout(() => resolve('resolved'), 10);
      });
      
    })
    .then( () => {
      

      let missingVariants;
      if(!!userNotes && userNotes.length > 0){
        missingVariants = 0;
        // * Warn user if there is a note for a variant which is not in this dataset
        Object.keys(userNotes).forEach( nId => {
          if(Object.values(tmpVariantData).filter( t => t['CHROMOSOME']===userNotes[nId]['CHROMOSOME']
            &&  t['LOC_START']===userNotes[nId]['LOC_START']
            &&  t['LOC_END']===userNotes[nId]['LOC_END']
            &&  t['SEG_MEAN']===userNotes[nId]['SEG_MEAN'] ).length < 1) {
              missingVariants+=1;
              console.log(userNotes[nId]); // ! keep this in console??????
          }
        });
      }

      // const sampleNames = new Set();
      // Object.keys(tmpVariantData).forEach( varIndex => {
      //   Object.keys(tmpVariantData[varIndex].SAMPLES).forEach( sampleName => {
      //     sampleNames.add(sampleName);
      //   })
      // });
      // console.log(sampleNames);

      // tmpVariantData.forEach((variant, varIndex) => {
      Object.keys(tmpVariantData).forEach( varIndex => {
        const rawPhenotypes = tmpVariantData[varIndex]['OMIM_PHENOTYPES'];

        const filtered = filterOMIMPhenotypes(rawPhenotypes);
        tmpVariantData[varIndex]['OMIM_PHENOTYPES'] = filtered;
        const rawNearbyPhenotypes = tmpVariantData[varIndex]['NEARBY_OMIM_PHENOTYPES'];

        const nearbyFiltered = filterOMIMPhenotypes(rawNearbyPhenotypes);
        tmpVariantData[varIndex]['NEARBY_OMIM_PHENOTYPES'] = nearbyFiltered;

        const locStart = parseInt(tmpVariantData[varIndex]['LOC_START'], 10);
        const locStop = parseInt(tmpVariantData[varIndex]['LOC_END'], 10);

        const starts_MMS = (tmpVariantData[varIndex]['ALL_MMS_START'] || '')
          .split(';')
          .map(s => parseInt(s, 10))
          .filter(n => !isNaN(n));
      
        const stops_MMS = (tmpVariantData[varIndex]['ALL_MMS_STOP'] || '')
          .split(';')
          .map(s => parseInt(s, 10))
          .filter(n => !isNaN(n));
      
        const overlapPercentages = [];
      
        for (let i = 0; i < Math.min(starts_MMS.length, stops_MMS.length); i++) {
          const mmsStart = starts_MMS[i];
          const mmsStop = stops_MMS[i];
          const mmsLength = mmsStop - mmsStart;
      
          const overlapStart = Math.max(locStart, mmsStart);
          const overlapStop = Math.min(locStop, mmsStop);
      
          let overlapLength = 0;
          if (overlapStart < overlapStop) {
            overlapLength = overlapStop - overlapStart;
          }
      
          const percentage = mmsLength > 0 ? (overlapLength / mmsLength) : -1;
          overlapPercentages.push(percentage.toFixed(3));
        }
      
        tmpVariantData[varIndex]['MMS_OVERLAP_PERCENTAGES'] = overlapPercentages;
        const numericOverlaps = overlapPercentages.map(Number).filter(n => !isNaN(n));

        if (numericOverlaps.length > 0) {
          const maxOverlap = Math.max(...numericOverlaps);
          tmpVariantData[varIndex]['MAX_MMS_OVERLAP_PERCENTAGE'] = Math.round(maxOverlap * 100);
          // tmpVariantData[varIndex]['MAX_MMS_OVERLAP_PERCENTAGE'] = maxOverlap;
        } else {
          // Leave it undefined or explicitly set to null
          tmpVariantData[varIndex]['MAX_MMS_OVERLAP_PERCENTAGE'] = null;
        }


        
      
        tmpVariantData[varIndex]['ROW_INDEX'] = varIndex;
        tmpVariantData[varIndex]['MR_PHENE_PHENOTYPE_TERMS'] = null;

        if(!!mrPheneData){
          let entrezId = tmpVariantData[varIndex]['ENTREZ_ID'];
          let inMrPheneRecord = mrPheneData['genes'][entrezId];
          if (inMrPheneRecord!==null && inMrPheneRecord !==undefined){
            let terms=Object.keys(mrPheneData['terms']).filter(t=> {
              if(mrPheneData['terms'][t].genes!==null && mrPheneData['terms'][t].genes!==undefined)
                return(mrPheneData['terms'][t].genes.includes(entrezId));
              else
                return false;
            }).map(k => `${mrPheneData['terms'][k].label} (${k})`)
            // let terms=Object.keys(mrPheneData['terms']).filter(t=> mrPheneData['terms'][t].genes.includes(entrezId))
            // let terms=Object.values(mrPheneData['terms']).filter(t=> t.genes.includes(entrezId)).map(k => `${k.label} (${k.type})`)
            tmpVariantData[varIndex]['MR_PHENE_PHENOTYPE_TERMS'] = `[${terms.length}] ${terms.join(', ')}`;
            // debugger;
          }
        }

        tmpVariantData[varIndex]['VANEX_TAGS'] = 0;
        tmpVariantData[varIndex]['VANEX_NOTES'] = {CURRENT_USER_NOTE:'', UPDATED_AT:'', ALL_USERS_NOTES:[]}; //, DENOVO_ASSESSMENT:-1
        tmpVariantData[varIndex]['VANEX_REVIEWS'] = {REVIEW_VALUE:null, DENOVO_ASSESSMENT:null, UPDATED_AT:null};
        // * add user notes for this variant
        if(!!userNotes){
          let foundNotes = Object.values(userNotes)
            .filter( t => t['CHROMOSOME']===tmpVariantData[varIndex]['CHROMOSOME']
                      &&  t['LOC_START']===tmpVariantData[varIndex]['LOC_START']
                      &&  t['LOC_END']===tmpVariantData[varIndex]['LOC_END']
                      &&  t['SEG_MEAN']===tmpVariantData[varIndex]['SEG_MEAN'] );
          if(Object.keys(foundNotes).length > 0){
            tmpVariantData[varIndex]['VANEX_TAGS'] =  (foundNotes[0]['VANEX_TAGS']===true ? 1 : foundNotes[0]['VANEX_TAGS']===false ? 0 : foundNotes[0]['VANEX_TAGS']);
            tmpVariantData[varIndex]['VANEX_NOTES'] = {CURRENT_USER_NOTE:foundNotes[0]['VANEX_NOTES'], UPDATED_AT:foundNotes[0]['UPDATED_AT'] || '', ALL_USERS_NOTES:[]}; //, DENOVO_ASSESSMENT:-1
          }
        }
        tmpVariantData[varIndex]['REGION_DOSAGE'] =  [];
        if(!!regionDosage){
          let foundRegionDosage = Object.values(regionDosage)
            .filter( t => t['CHROMOSOME']===tmpVariantData[varIndex]['CHROMOSOME']
                      &&  t['LOC_START']<=tmpVariantData[varIndex]['LOC_END']
                      &&  t['LOC_END']>=tmpVariantData[varIndex]['LOC_START']);
          if(Object.keys(foundRegionDosage).length > 0){
            // console.log("matchGene",varIndex);
            tmpVariantData[varIndex]['REGION_DOSAGE'] =  (foundRegionDosage);
          }
        }
        tmpVariantData[varIndex]['GENE_DOSAGE'] =  [];
        if(!!geneDosage){
          // console.log(tmpVariantData[varIndex]['GENE_SYMBOLS'])
          let foundGeneDosage = Object.values(geneDosage)
          .filter( t => t['CHROMOSOME']===tmpVariantData[varIndex]['CHROMOSOME']
                    &&  t['LOC_START']<=tmpVariantData[varIndex]['LOC_END']
                    &&  t['LOC_END']>=tmpVariantData[varIndex]['LOC_START']);
          if(Object.keys(foundGeneDosage).length > 0){
            // console.log("matchRegion",varIndex);
            tmpVariantData[varIndex]['GENE_DOSAGE'] =  (foundGeneDosage);
          }
        }
        
        // * add review for this variant
        // if(!!reviewRecords){
        //   let foundReviews = Object.values(reviewRecords)
        //     .filter( t => t['CHROMOSOME']===tmpVariantData[varIndex]['CHROMOSOME']
        //               &&  t['LOC_START']===tmpVariantData[varIndex]['LOC_START']
        //               &&  t['LOC_END']===tmpVariantData[varIndex]['LOC_END']  );
        //   if(Object.keys(foundReviews).length > 0){
        //     tmpVariantData[varIndex]['VANEX_REVIEWS'] = {...tmpVariantData[varIndex]['VANEX_REVIEWS'], REVIEW_VALUE:foundReviews[0]['REVIEW_VALUE'], UPDATED_AT:(foundReviews[0]['UPDATED_AT'] || null)};
        //     // console.log(tmpVariantData[varIndex]['VANEX_REVIEWS']);
        //   }
        // }
        // * add denovo assessments for this variant
        // if(!!denovoAssessments){
        //   let foundAssessments = Object.values(denovoAssessments)
        //     .filter( t => t['CHROMOSOME']===tmpVariantData[varIndex]['CHROMOSOME']
        //               &&  t['LOC_START']===tmpVariantData[varIndex]['LOC_START']
        //               &&  t['LOC_END']===tmpVariantData[varIndex]['LOC_END']  );
        //   if(Object.keys(foundAssessments).length > 0){
        //     tmpVariantData[varIndex]['VANEX_REVIEWS'] = {...tmpVariantData[varIndex]['VANEX_REVIEWS'], DENOVO_ASSESSMENT:foundAssessments[0]['DENOVO_ASSESSMENT']};
        //     // console.log(tmpVariantData[varIndex]['VANEX_REVIEWS']);
        //   }
        // }

        // sampleNames.forEach( sampleName => {
        //   if(!!tmpVariantData[varIndex].SAMPLES && !tmpVariantData[varIndex]['SAMPLES'][sampleName]){
        //     tmpVariantData[varIndex]['SAMPLES'][sampleName]={"TD":null,"GT_RAW":null,"RD":null,"AD":null,"GQ":null,"PL":null,"DP":null,"GT":null}//{"TD":"","GT_RAW":"","RD":"","AD":"","GQ":"","PL":"","DP":"","GT":""}
        //   }
        // })

        // if (!!tmpVariantData[varIndex].SAMPLES){
        //   Object.keys(tmpVariantData[varIndex].SAMPLES).forEach( sampleName => {
        //     Object.keys(tmpVariantData[varIndex].SAMPLES[sampleName]).forEach((property) => {
        //       tmpVariantData[varIndex][sampleName + '_' + property] = tmpVariantData[varIndex].SAMPLES[sampleName][property];
        //       // if (property==='GT'){
        //       //   tmpVariantData[varIndex][sampleName + '_' + property] = tmpVariantData[varIndex].SAMPLES[sampleName][property];
        //       //   // tmpVariantData[varIndex][getSampleType(sampleName,true) + '_' + sampleName + '_' + property] = tmpVariantData[varIndex].SAMPLES[sampleName][property];
        //       //   // tmpVariantData[varIndex][getSampleType(sampleName,true) + '_' + property] = tmpVariantData[varIndex].SAMPLES[sampleName][property];
        //       // }
        //     });
        //     // if(props.projectBaseURL==='ep'){
        //     if(tmpVariantData[varIndex].SAMPLES[sampleName]['_Alt_Percent']===undefined || tmpVariantData[varIndex].SAMPLES[sampleName]['_Alt_Percent']===null){
        //       tmpVariantData[varIndex][sampleName + '_Alt_Percent'] = Math.round(100*100*Number(tmpVariantData[varIndex].SAMPLES[sampleName]['AD'])/Number(tmpVariantData[varIndex].SAMPLES[sampleName]['DP']))/100 || null;
        //     }
        //   });
        // }
      });

      console.log('tmpVariantData: ', tmpVariantData);
      //TODO: get column names from db for mother and father
      

      if(missingVariants!==undefined)
        if(missingVariants>0)
          toast.error(`Cannot find coresponding variants for ${missingVariants} notes`, {duration:6000});
        else
          toast.success(`${getCurrentUserFirstName()}'s notes loaded successfully!`);

      let newCase = [caseAnalysisId, tmpVariantData, []]; // ? maybe add date as the last element?        , new Date()
      if(currentCaseIndex >= 0 && reloadCaseData){
        setActiveCaseIndexInOpenCases(currentCaseIndex);
        setOpenCases(prevOpenCases => prevOpenCases.map(indvCase => (indvCase[0] === caseAnalysisId ? newCase : indvCase)))
      } else {
        setActiveCaseIndexInOpenCases(openCases.length);
        setOpenCases([...openCases, newCase]);
      }
      
      if(loadExistingNotes){      
        // GetSignedURL('nch-igm-vanex',`cnv_case_notes/CASE_ID=${caseID}/&folder=true`) 
        GetSignedURL('nch-igm-vanex', basePathForAllNotes) 
        .then(response => downloadAllExistingCnvNotes(response, caseAnalysisId, analysisObj))
        .catch( e => {setIsLoadingNotes(false); toast.error(`Error in retrieving notes: ${e.toString()}`, {duration:8000}); })
        // .catch( e => {setIsLoadingNotes(false); setErrorLog([`Error in retrieving notes: ${e}`, ''])});
      }
      showAnalysisPanel(caseID, analysisObj.ANALYSIS_ID);
    })
    .catch( e => setErrorLog([`No data for ${caseAnalysisId} found. (${e})`, '']));
  }


  function loadSNVdata(caseID, analysisObj, userName, currentCaseIndex){
    const caseAnalysisId = `${caseID}::${analysisObj.ANALYSIS_ID}`;
    const caseAnalysisName = `${caseID}::${analysisObj.ANALYSIS_NAME}`;
    // let userName = props.userName.replaceAll(' ','_');                        // * did not use .toUpperCase();
    let tmpVariantData = [];
    let userNotes;
    let reviewRecords;
    let RNAseqExpression
    let RNAseqExpressionRAW
    let RNAseqExpressionLOG
    let denovoAssessments;
    let mrPheneData;
    let ClinGenDisease;
    const gzipedJsonFile = (!!analysisObj.JSON_URI ? true : false);
    let bucket = 'nch-igm-vanex';
    let uriToLoad = `${props.project}/cases/CASE_ID=${caseID}/${analysisObj.ANALYSIS_ID}.json`;
    if(gzipedJsonFile){
      bucket =analysisObj.JSON_URI.match(/s3:\/\/([^/]*)\//,'')[1]
      uriToLoad= analysisObj.JSON_URI.replace(/s3:\/\/[^/]*\//,'')
    }
    let basePathForAllNotes = `case_notes/CASE_ID=${caseID}/ANALYSIS_ID=${analysisObj.ANALYSIS_ID}/&folder=true`;
    if (isNoteScopeAllAnalysis) basePathForAllNotes = `case_notes/CASE_ID=${caseID}/&folder=true`;

    new Promise(function (resolve, reject) {
      // if(DEVMODE){
      //   console.log("loading data in dev mode!");
      //   readTextFile(myData);
      //   resolve(JSONLText);
      // } else {
        resolve(
          // GetSignedURL('nch-igm-vanex',`${props.project}/cases/CASE_ID=${caseID}/${caseID}.json`)
          // GetSignedURL('nch-igm-research-epilepsy', 'ANALYSES/2021/IGMJLE0065/varhouse/2021-11-16T02-13-33/json/IGMJLE0065_germline.json.gz', true)
          // GetSignedURL('nch-igm-research-rare-disease', '2021/RD200116/churchill/2021-09-23/varhouse/2021-11-12T19-48-02/json/RD200116_churchill_RDG.json.gz', true)
          GetSignedURL(bucket ,uriToLoad, gzipedJsonFile)
          .then(response => {
            return(downloadCaseData(response, caseAnalysisName ));
          })
        );
      // }
    })
    .then( caseTextData => {
      // if (gzipedJsonFile)
      //   tmpVariantData = JSON.parse(caseTextData)['rows']; // ! Varhouse output is under "rows", but cannot be used since properties with null value are discarded
      // else
        tmpVariantData = parse_JSONL(caseTextData);
        // console.log("caseTextData", caseTextData);
        // console.log("tmpVariantData", tmpVariantData);
        // console.log('process Data')
      // * sort data by CHROMOSOME and POSITION
      // tmpVariantData = tmpVariantData.sort((a, b) => (a.CHROMOSOME.localeCompare(b.CHROMOSOME) || a.POSITION - b.POSITION) ); 
      tmpVariantData = tmpVariantData.sort((a, b) => {
        if (a.CHROMOSOME === b.CHROMOSOME){ 
          return(a.POSITION - b.POSITION);
        } else { 
          if(isNaN(a.CHROMOSOME) && isNaN(b.CHROMOSOME)){
            return(a.CHROMOSOME==='X' ? -1 : 1);
          } else if(isNaN(a.CHROMOSOME) || isNaN(b.CHROMOSOME)){
            return(isNaN(a.CHROMOSOME) ? 1 : -1);
          } else {
            return(Number(a.CHROMOSOME) - Number(b.CHROMOSOME));
          }
        }
      });
      if(analysisObj.ANALYSIS_TYPE === 'GermlineSNV' || analysisObj.ANALYSIS_TYPE === 'SomaticSNV'){
        Object.keys(tmpVariantData).forEach( tmpIndex => {
          if(props.projectBaseURL==='ep'){
            let searchRes=EpilepsyGeneList[tmpVariantData[tmpIndex]['GENE']];
            tmpVariantData[tmpIndex]['EPILEPSY_GENE_LIST'] = searchRes || null;
          }
          if(analysisObj.ANALYSIS_TYPE === 'SomaticSNV'){
            let maxAD=0;
            
            // Object.keys(tmpVariantData[tmpIndex].SAMPLES).forEach( sampleName => {
            // * it is better to use the samples in the DB just in case we want to ignore a sample and exclude it from our analysis
            analysisObj.SAMPLES.filter(k => !k.SAMPLE_TYPE.toLowerCase().includes('normal')).map(t =>t.SAMPLE_ID).forEach(sampleName => {
              let tmpAD = Number(tmpVariantData[tmpIndex].SAMPLES[sampleName]['AD']) || 0;
              maxAD = (tmpAD > maxAD ? tmpAD : maxAD);
            });

            tmpVariantData[tmpIndex]['MAX_AD'] = maxAD;

          }
          // Object.keys(tmpVariantData[tmpIndex]['SAMPLES']).forEach( sampleId => {
          //   tmpVariantData[tmpIndex]['SAMPLES'][`x_${sampleId}`] = tmpVariantData[tmpIndex]['SAMPLES'][sampleId];
          //   delete tmpVariantData[tmpIndex]['SAMPLES'][sampleId];
          // });
          tmpVariantData[tmpIndex]['OHIO_NBS_GENE_LIST'] = OhioNBSGeneList[tmpVariantData[tmpIndex]['ENTREZ_ID']] || null;
          // tmpVariantData[tmpIndex]['CFM_GENE_LIST'] = cfmGenes[tmpVariantData[tmpIndex]['ENTREZ_ID']] || null;
          // tmpVariantData[tmpIndex]['NM_GENE_LIST'] = nmGenes[tmpVariantData[tmpIndex]['ENTREZ_ID']] || null;
          tmpVariantData[tmpIndex]['GENOMIC_COORDS'] = 'chr'+tmpVariantData[tmpIndex]["CHROMOSOME"] + ":"+tmpVariantData[tmpIndex]["POSITION"]+ tmpVariantData[tmpIndex]["REF"]+">"+tmpVariantData[tmpIndex]["ALT"] || null;
        });
      } else if (analysisObj.ANALYSIS_TYPE === 'SNV') {
        Object.keys(tmpVariantData).forEach( tmpIndex => {
          // if(props.projectBaseURL==='genomic_services'){}
          tmpVariantData[tmpIndex]['OHIO_NBS_GENE_LIST'] = OhioNBSGeneList[tmpVariantData[tmpIndex]['ENTREZ_ID']] || null;
          // tmpVariantData[tmpIndex]['CFM_GENE_LIST'] = cfmGenes[tmpVariantData[tmpIndex]['ENTREZ_ID']] || null;
          // tmpVariantData[tmpIndex]['NM_GENE_LIST'] = nmGenes[tmpVariantData[tmpIndex]['ENTREZ_ID']] || null;
          tmpVariantData[tmpIndex]['GENOMIC_COORDS'] = 'chr'+tmpVariantData[tmpIndex]["CHROMOSOME"] + ":"+tmpVariantData[tmpIndex]["POSITION"]+ tmpVariantData[tmpIndex]["REF"]+">"+tmpVariantData[tmpIndex]["ALT"] || null;
        });
        
      }
      Object.keys(tmpVariantData).forEach( tmpIndex => {
        // if(props.projectBaseURL==='genomic_services'){}
        // tmpVariantData[tmpIndex]['OHIO_NBS_GENE_LIST'] = OhioNBSGeneList[tmpVariantData[tmpIndex]['ENTREZ_ID']] || null;
        tmpVariantData[tmpIndex]['CFM_GENE_LIST'] = cfmGenes[tmpVariantData[tmpIndex]['ENTREZ_ID']] || null;
        tmpVariantData[tmpIndex]['NM_GENE_LIST'] = nmGenes[tmpVariantData[tmpIndex]['ENTREZ_ID']] || null;
        // tmpVariantData[tmpIndex]['GENOMIC_COORDS'] = 'chr'+tmpVariantData[tmpIndex]["CHROMOSOME"] + ":"+tmpVariantData[tmpIndex]["POSITION"]+ tmpVariantData[tmpIndex]["REF"]+">"+tmpVariantData[tmpIndex]["ALT"] || null;
      });
      console.log('LOADING NOTES')
      if(loadMyNotes){
        updateCaseLoadingProgressBar(`Loading notes for ${caseAnalysisName}...`, 88);
        return(
          // GetSignedURL('nch-igm-vanex',`case_notes/CASE_ID=${caseID}/USERNAME=${userName}/${userName}.json`)
          GetSignedURL('nch-igm-vanex',`case_notes/CASE_ID=${caseID}/ANALYSIS_ID=${analysisObj.ANALYSIS_ID}/USERNAME=${userName}/${userName}.json`)
          .then(response => downloadIndividualNote(response))
          .catch( e => { toast(`${getCurrentUserFirstName()}'s notes not found.\n(${e.toString()})`, {duration:6000}); return("") })
          // .catch( e => toast.error(`Notes not found (${e.toString()})`, {duration:6000}))
        );
      }
      else{
        return("");
      }
    })
    .then( userNotesResponse => {
      userNotes = parse_JSONL(userNotesResponse).map( myNote => {
        return(
          {
            ...myNote,
            VANEX_TAGS: (myNote['VANEX_TAGS']===true ? 1 : (myNote['VANEX_TAGS']===false ? 0 : myNote['VANEX_TAGS']))
          }
        );
      });
      updateCaseLoadingProgressBar(`Loading RNAseqExpression for ${caseAnalysisName}...`, 90);
      return(
        GetSignedURL('nch-igm-vanex',`resources/RNAseq_GeneExpression/Normalized-log2transformed_TPM.txt.gz`, true)
        .then(response => downloadIndividualNote(response))
        .catch(e => console.error(`Error in retrieving RNAseqExpression Info: ${e}`))
      );
    })
    .then( RNAseqExpressionResponse => {
      RNAseqExpression = tsvToArray(RNAseqExpressionResponse);
      // console.log('RNAseqExpression',RNAseqExpression);
      return(
        GetSignedURL('nch-igm-vanex',`resources/RNAseq_GeneExpression/TPM_blood.txt.gz`, true)
        .then(response => downloadIndividualNote(response))
        .catch(e => console.error(`Error in retrieving RNAseqExpression Info: ${e}`))
      );
    })
    .then( RNAseqExpressionRAWResponse => {
      RNAseqExpressionRAW = tsvToArray(RNAseqExpressionRAWResponse);
      // console.log('RNAseqExpression',RNAseqExpression);
      return(
        GetSignedURL('nch-igm-vanex',`resources/RNAseq_GeneExpression/log2transformed_TPM-04.07.25.txt.gz`, true)
        .then(response => downloadIndividualNote(response))
        .catch(e => console.error(`Error in retrieving RNAseqExpression Info: ${e}`))
      );
    })
    .then( RNAseqExpressionLOGResponse => {
      RNAseqExpressionLOG = tsvToArray(RNAseqExpressionLOGResponse);
      // console.log('RNAseqExpression',RNAseqExpression);

      updateCaseLoadingProgressBar(`Loading reviews for ${caseAnalysisName}...`, 92);
      return(
        // * this is a gzip file request!
        GetSignedURL('nch-igm-vanex',`case_notes/CASE_ID=${caseID}/ANALYSIS_ID=${analysisObj.ANALYSIS_ID}/USERNAME=REVIEWS/${caseID}_${analysisObj.ANALYSIS_ID}_REVIEWS.json.gz`, true)
        .then(response => downloadReviewRecordsOrDenovoAssessments(response, "review records"))
        .catch( e => console.error(`Error in retrieving review records: ${e}`))
      );
    })
    .then( reviewsResponse => {
      reviewRecords = reviewsResponse;
  
      updateCaseLoadingProgressBar(`Loading De Novo Assessments for ${caseAnalysisName}...`, 94);
      return(
        // * this is a gzip file request!
        GetSignedURL('nch-igm-vanex',`denovo_assessments/${caseID}.json.gz`, true)
        .then(response => downloadReviewRecordsOrDenovoAssessments(response, "de novo assessments"))
        .catch( e => console.error(`Error in retrieving de novo assessments: ${e}`))
      );
    })
    .then( denovoAssessmentsResponse => {
      denovoAssessments = denovoAssessmentsResponse;
      // console.log('denovoAssessmentsResponse:'); // ! comment it out 
      // console.log(denovoAssessments); // ! comment it out 
      updateCaseLoadingProgressBar(`Loading Clin Gen Disease Info for ${caseAnalysisName}...`, 95);
      return(
        // * this is a gzip file request!
        GetSignedURL('nch-igm-vanex','ClinGenGeneDisease/Clingen-Gene-Disease-Summary-2024-07-22.tsv')
        .then(response => downloadIndividualNote(response))
        .catch( e => console.error(`Error in retrieving Clin Gene Disease Info: ${e}`))
      );
    })
    .then (ClinGenDiseaseResponse => {
      ClinGenDisease = tsvToArray(ClinGenDiseaseResponse);
      // console.log("ClinGenDisease",ClinGenDisease);


      if(loadMrPheneSubjectData && !!activeCaseInfo && activeCaseInfo['MRPHENE_SUBJECT_ID']!==null && activeCaseInfo['MRPHENE_SUBJECT_ID']!==undefined ){
        updateCaseLoadingProgressBar(`Loading Mr Phene data for ${caseAnalysisName}...`, 96);
        
        return new Promise(function (resolve, reject) {
          Auth.currentSession().then(data => {
            let endpoint = `${MRPHENE_ENDPOINT_BASE}subject/${activeCaseInfo['MRPHENE_SUBJECT_ID']}`
            // let endpoint = `${MRPHENE_ENDPOINT_BASE}gene_list/${activeItemId}`
            console.log(endpoint);
            var id_token = data.getIdToken().getJwtToken();
            fetch(endpoint, {
              mode: 'cors',
              headers: {
                'Authorization': id_token                
              }
            })
            .then(result => result.json())
            .then(result => {
              // console.log(result);
              if(!!result && !!result.genes && Object.values(result.genes).length >0){
                resolve(result);
              }
              else
                throw Error(`Found no genes in the Mr. Phene profile.`);
            }).catch(e => {
              reject("Failed to load subject id list. " + String(e));
            })
          });
        });
      }
      
      return null;

    })
    .then( (mrPheneSubjectDataResponse) => {
      mrPheneData = mrPheneSubjectDataResponse;
      // console.log(mrPheneData);
      // setActiveCaseInfo({...activeCaseInfo, MRPHENE_SUBJECT_ID: activeCaseInfo['MRPHENE_SUBJECT_ID'], MRPHENE_SUBJECT_DATA:mrPheneSubjectDataResponse})

      updateCaseLoadingProgressBar(`Processing data for ${caseAnalysisName}...`, 98);
      return new Promise(resolve => {
        setTimeout(() => resolve('resolved'), 10);
      });
      
    })
    .then( () => {
      if(props.project==="paradigm"){
        return(
          GetSignedURL('nch-igm-vanex',`paradigm/top_candidates/CASE_ID=${caseID}/${caseID}_top_candidates.json`, false)
          .then(response => downloadReviewRecordsOrDenovoAssessments(response))
          .catch( e => {toast.error(`Paradigm data not found (${e.toString()})`, {duration:6000}); return(null);})
        );
      } else {return(null);}
    })
    .then( (paradigmDf) => {
      ////!!!!!  if(!!paradigmDf && paradigmDf.length>0) steParadigmData(paradigmDf);
      
      tmpVariantData = flattenCaseData(tmpVariantData, userNotes, reviewRecords, denovoAssessments, mrPheneData, paradigmDf, ClinGenDisease, RNAseqExpression, RNAseqExpressionRAW, RNAseqExpressionLOG);

      //TODO: get column names from db for mother and father
      console.log(tmpVariantData);

      let newCase = [caseAnalysisId, tmpVariantData, []]; // ? maybe add date as the last element?        , new Date()
      if(currentCaseIndex >= 0 && reloadCaseData){
        setActiveCaseIndexInOpenCases(currentCaseIndex);
        setOpenCases(prevOpenCases => prevOpenCases.map(indvCase => (indvCase[0] === caseAnalysisId ? newCase : indvCase)))
      } else {
        setActiveCaseIndexInOpenCases(openCases.length);
        setOpenCases([...openCases, newCase]);
      }
      
      if(loadExistingNotes){      
        // GetSignedURL('nch-igm-vanex',`case_notes/CASE_ID=${caseID}/&folder=true`) 
        console.log("basePathForAllNotes", basePathForAllNotes)
        GetSignedURL('nch-igm-vanex', basePathForAllNotes) 
        .then(response => { 
          console.log("response", response)
          downloadAllExistingNotes(response, caseAnalysisId, analysisObj)})
        // .then(response => downloadAllExistingNotes(response, caseAnalysisId, analysisObj))
        .catch( e => {setIsLoadingNotes(false); toast.error(`Error in retrieving notes: ${e.toString()}`, {duration:8000}); })
        // .catch( e => {setIsLoadingNotes(false); setErrorLog([`Error in retrieving notes: ${e}`, ''])});
      }
      showAnalysisPanel(caseID, analysisObj.ANALYSIS_ID);
    })
    .catch( e => setErrorLog([`No data for ${caseAnalysisId} found. (${e})`, '']));
  }

  function flattenCaseData(tmpVariantData, userNotes, reviewRecords, denovoAssessments, mrPheneData, paradigmDf, ClinGenDisease, RNAseqExpression, RNAseqExpressionRAW, RNAseqExpressionLOG){
    console.log('FLATTENING')

    function buildExpressionMap(rnaArray, genes_to_ids) {
      const map = {};
      for (const rna of rnaArray) {
        const entrez = genes_to_ids.ENTREZ_ID[rna["GENE"]];
        if (entrez) {
          map[entrez.toString()] = rna;
        }
      }
      return map;
    }
    
    const RNAseqMap = buildExpressionMap(RNAseqExpression, genes_to_ids);
    const RNAseqMapRAW = buildExpressionMap(RNAseqExpressionRAW, genes_to_ids);
    const RNAseqMapLOG = buildExpressionMap(RNAseqExpressionLOG, genes_to_ids);
    
    let missingVariants;
    if(!!userNotes && userNotes.length > 0){
      missingVariants = 0;
      // * Warn user if there is a note for a variant which is not in this dataset
      Object.keys(userNotes).forEach( nId => {
        if(Object.values(tmpVariantData).filter( t => t['CHROMOSOME']===userNotes[nId]['CHROMOSOME']
          &&  t['POSITION']===userNotes[nId]['POSITION']
          &&  t['REF']===userNotes[nId]['REF']
          &&  t['ALT']===userNotes[nId]['ALT'] ).length < 1) {
            missingVariants+=1;
            console.log(userNotes[nId]); // ! keep this in console??????
        }
      });
    }
    const sampleNames = new Set();
    Object.keys(tmpVariantData).forEach( varIndex => {
      Object.keys(tmpVariantData[varIndex].SAMPLES).forEach( sampleName => {
        sampleNames.add(sampleName);
      })
    });
    // console.log(sampleNames);

    let paradigmTopCandidates;
    if(!!paradigmDf && Object.keys(paradigmDf).length>0){
      Object.keys(paradigmDf).forEach(elKey => {
        paradigmDf[elKey]['variants'].forEach( (variantData, varIndex) => {
          paradigmDf[elKey]['variants'][varIndex]={...paradigmDf[elKey]['variants'][varIndex], FULL_RECORD:paradigmDf[elKey]};  // FULL_RECORD:{...paradigmDf[elKey], variants:null}
        });
        ////!!!!!  paradigmDf[elKey]['variants']={...paradigmDf[elKey]['variants'], FULL_RECORD:paradigmDf[elKey]};
      });
      paradigmTopCandidates = Object.values(paradigmDf).flatMap(cnd => cnd['variants']).map(vr => {delete vr['FULL_RECORD']['variants']; return(vr);} );//.flatMap();     // cnd => ({...cnd['variants'], FULL_RECORD:cnd})
      ////!!!!!  console.log("paradigmDf", paradigmDf);
      ////!!!!!  console.log("paradigmTopCandidates", paradigmTopCandidates);
    }

    // tmpVariantData.forEach((variant, varIndex) => {
    Object.keys(tmpVariantData).forEach( varIndex => {
      tmpVariantData[varIndex]['ROW_INDEX'] = varIndex;
      tmpVariantData[varIndex]['MR_PHENE_PHENOTYPE_TERMS'] = null;
      tmpVariantData[varIndex]['PARADIGM'] = null;


      const rawPhenotypes = tmpVariantData[varIndex]['OMIM_PHENOTYPES'];
      const sorted = sortOmimPhenotypes(rawPhenotypes);
      if (sorted !== null) {
        tmpVariantData[varIndex]['OMIM_PHENOTYPES'] = sorted;
      }


      if(!!mrPheneData){
        let entrezId = tmpVariantData[varIndex]['ENTREZ_ID'];
        let inMrPheneRecord = mrPheneData['genes'][entrezId];
        if (inMrPheneRecord!==null && inMrPheneRecord !==undefined){
          let terms=Object.keys(mrPheneData['terms']).filter(t=> {
            if(mrPheneData['terms'][t].genes!==null && mrPheneData['terms'][t].genes!==undefined)
              return(mrPheneData['terms'][t].genes.includes(entrezId));
            else
              return false;
          }).map(k => `${mrPheneData['terms'][k].label} (${k})`)
          // let terms=Object.keys(mrPheneData['terms']).filter(t=> mrPheneData['terms'][t].genes.includes(entrezId))
          // let terms=Object.values(mrPheneData['terms']).filter(t=> t.genes.includes(entrezId)).map(k => `${k.label} (${k.type})`)
          tmpVariantData[varIndex]['MR_PHENE_PHENOTYPE_TERMS'] = `[${terms.length}] ${terms.join(', ')}`;
          // debugger;
        }
      }

      tmpVariantData[varIndex]['VANEX_TAGS'] = 0;
      tmpVariantData[varIndex]['VANEX_NOTES'] = {CURRENT_USER_NOTE:'', UPDATED_AT:'', ALL_USERS_NOTES:[]}; //, DENOVO_ASSESSMENT:-1
      tmpVariantData[varIndex]['VANEX_REVIEWS'] = {REVIEW_VALUE:null, DENOVO_ASSESSMENT:null, UPDATED_AT:null};
      
      // * add user notes for this variant
      if(!!userNotes){
        let foundNotes = Object.values(userNotes)
          .filter( t => t['CHROMOSOME']===tmpVariantData[varIndex]['CHROMOSOME']
                    &&  t['POSITION']===tmpVariantData[varIndex]['POSITION']
                    &&  t['REF']===tmpVariantData[varIndex]['REF']
                    &&  t['ALT']===tmpVariantData[varIndex]['ALT'] );
        if(Object.keys(foundNotes).length > 0){
          tmpVariantData[varIndex]['VANEX_TAGS'] = (foundNotes[0]['VANEX_TAGS']===true ? 1 : foundNotes[0]['VANEX_TAGS']===false ? 0 : foundNotes[0]['VANEX_TAGS']);
          tmpVariantData[varIndex]['VANEX_NOTES'] = {CURRENT_USER_NOTE:foundNotes[0]['VANEX_NOTES'], UPDATED_AT:foundNotes[0]['UPDATED_AT'] || '', ALL_USERS_NOTES:[]}; //, DENOVO_ASSESSMENT:-1
        }
      }
      
      // * add review for this variant
      if(!!reviewRecords){
        let foundReviews = Object.values(reviewRecords)
          .filter( t => t['CHROMOSOME']===tmpVariantData[varIndex]['CHROMOSOME']
                    &&  t['POSITION']===tmpVariantData[varIndex]['POSITION']
                    &&  t['REF']===tmpVariantData[varIndex]['REF']
                    &&  t['ALT']===tmpVariantData[varIndex]['ALT'] );
        if(Object.keys(foundReviews).length > 0){
          tmpVariantData[varIndex]['VANEX_REVIEWS'] = {...tmpVariantData[varIndex]['VANEX_REVIEWS'], REVIEW_VALUE:foundReviews[0]['REVIEW_VALUE'], UPDATED_AT:(foundReviews[0]['UPDATED_AT'] || null)};
          // console.log(tmpVariantData[varIndex]['VANEX_REVIEWS']);
        }
      }

      // * add Paradigm Top Candidates for this variant
      if(!!paradigmTopCandidates){
        let foundParadigmTopCandidates = paradigmTopCandidates
          .filter( t => t['CHROMOSOME']===tmpVariantData[varIndex]['CHROMOSOME']
                    &&  t['POSITION']===tmpVariantData[varIndex]['POSITION'].toString()
                    &&  t['REF']===tmpVariantData[varIndex]['REF']
                    &&  t['ALT']===tmpVariantData[varIndex]['ALT'] );
        if(foundParadigmTopCandidates.length > 0){
          tmpVariantData[varIndex]['PARADIGM'] = foundParadigmTopCandidates[0];
          ////!!!!!  console.log(tmpVariantData[varIndex]['VANEX_REVIEWS']);
        }
      }

      // * add denovo assessments for this variant
      if(!!denovoAssessments){
        let foundAssessments = Object.values(denovoAssessments)
          .filter( t => t['CHROMOSOME']===tmpVariantData[varIndex]['CHROMOSOME']
                    &&  t['POSITION']===tmpVariantData[varIndex]['POSITION']
                    &&  t['REF']===tmpVariantData[varIndex]['REF']
                    &&  t['ALT']===tmpVariantData[varIndex]['ALT'] );
        if(Object.keys(foundAssessments).length > 0){
          tmpVariantData[varIndex]['VANEX_REVIEWS'] = {...tmpVariantData[varIndex]['VANEX_REVIEWS'], DENOVO_ASSESSMENT:foundAssessments[0]['DENOVO_ASSESSMENT']};
          // console.log(tmpVariantData[varIndex]['VANEX_REVIEWS']);
        }
      }

      // console.log("CLINGEN GENE",ClinGenDisease["GENE SYMBOL"])
      if(!!ClinGenDisease){
        tmpVariantData[varIndex]['CLINGEN_DISEASE_LABEL'] = "";
        tmpVariantData[varIndex]['CLINGEN_DISEASE_MOI'] = "";
        tmpVariantData[varIndex]['CLINGEN_DISEASE_GCEP'] = "";
        tmpVariantData[varIndex]['CLINGEN_DISEASE_ONLINEREPORT'] = "";
        tmpVariantData[varIndex]['CLINGEN_DISEASE_CLASSIFICATION_DATE'] = "";
        tmpVariantData[varIndex]['CLINGEN_DISEASE_SOP'] = "";
        tmpVariantData[varIndex]['CLINGEN_DISEASE_CLASSIFICATION'] = "";
        tmpVariantData[varIndex]['CLINGEN_DISEASE_ID'] = '';
        tmpVariantData[varIndex]['CLINGEN_DISEASE_HIGHEST_CLASSIFICATION'] = '';
        tmpVariantData[varIndex]['CLINGEN_DISEASE_COUNT'] = 0;
        const classificationPriority = {
          "Definitive": 1,
          "Strong": 2,
          "Moderate": 3,
          "Limited": 4,
          "Disputed": 5,
          "Refuted": 6,
          "No Known Disease Relationship": 7
        };
        let foundClinGenDisease = Object.values(ClinGenDisease)
          // .filter( t => t['GENE SYMBOL']===tmpVariantData[varIndex]['GENE']);
          .filter(t => tmpVariantData[varIndex]['GENE']?.split(";").includes(t['GENE SYMBOL']));
        if(Object.keys(foundClinGenDisease).length > 0){
          // console.log('foundClinGen',foundClinGenDisease)
          foundClinGenDisease.sort((a, b) => {
            const priorityA = classificationPriority[a["CLASSIFICATION"]] || 8;
            const priorityB = classificationPriority[b["CLASSIFICATION"]] || 8;
            return priorityA - priorityB;
          });
        
          tmpVariantData[varIndex]['CLINGEN_DISEASE_LABEL'] = foundClinGenDisease.map(row => row["DISEASE LABEL"]).join(';');
          tmpVariantData[varIndex]['CLINGEN_DISEASE_MOI'] = foundClinGenDisease.map(row => row["MOI"]).join(';');
          tmpVariantData[varIndex]['CLINGEN_DISEASE_GCEP'] = foundClinGenDisease.map(row => row["GCEP"]).join(';');
          tmpVariantData[varIndex]['CLINGEN_DISEASE_ONLINEREPORT'] = foundClinGenDisease.map(row => row["ONLINE REPORT"]).join(';');
          tmpVariantData[varIndex]['CLINGEN_DISEASE_CLASSIFICATION_DATE'] = foundClinGenDisease.map(row => row["CLASSIFICATION DATE"].split("T")[0]).join(';');
          tmpVariantData[varIndex]['CLINGEN_DISEASE_CLASSIFICATION'] = foundClinGenDisease.map(row => row["CLASSIFICATION"]).join(';');
          tmpVariantData[varIndex]['CLINGEN_DISEASE_HIGHEST_CLASSIFICATION'] = foundClinGenDisease.map(row => row["CLASSIFICATION"]).reduce((highest, current) => 
            classificationPriority[current] < classificationPriority[highest] ? current : highest
          );
          tmpVariantData[varIndex]['CLINGEN_DISEASE_SOP'] = foundClinGenDisease.map(row => row["SOP"]).join(';');
          tmpVariantData[varIndex]['CLINGEN_DISEASE_ID'] = foundClinGenDisease.map(row => row["DISEASE ID (MONDO)"]).join(';');
          tmpVariantData[varIndex]['CLINGEN_DISEASE_COUNT'] = foundClinGenDisease.length;
          // console.log("ClinGenDISEASE",tmpVariantData[varIndex]['CLINGEN_DISEASE']);
        }

      }

      let entrezId = tmpVariantData[varIndex]?.['ENTREZ_ID']?.toString().trim();

      if (!entrezId) {
        tmpVariantData[varIndex]["RNASEQ_GENEEXPRESSION"] = null;
        tmpVariantData[varIndex]["RNASEQ_GENEEXPRESSION_RAW"] = null;
        tmpVariantData[varIndex]["RNASEQ_GENEEXPRESSION_LOG"] = null;
      } else {
        tmpVariantData[varIndex]["RNASEQ_GENEEXPRESSION"] = RNAseqMap[entrezId] || null;
        tmpVariantData[varIndex]["RNASEQ_GENEEXPRESSION_RAW"] = RNAseqMapRAW[entrezId] || null;
        tmpVariantData[varIndex]["RNASEQ_GENEEXPRESSION_LOG"] = RNAseqMapLOG[entrezId] || null;
      }

      sampleNames.forEach( sampleName => {
        if(!!tmpVariantData[varIndex].SAMPLES && !tmpVariantData[varIndex]['SAMPLES'][sampleName]){
          tmpVariantData[varIndex]['SAMPLES'][sampleName]={"TD":null,"GT_RAW":null,"RD":null,"AD":null,"GQ":null,"PL":null,"DP":null,"GT":null}//{"TD":"","GT_RAW":"","RD":"","AD":"","GQ":"","PL":"","DP":"","GT":""}
        }
      })

      if (!!tmpVariantData[varIndex].SAMPLES){
        Object.keys(tmpVariantData[varIndex].SAMPLES).forEach( sampleName => {
          Object.keys(tmpVariantData[varIndex].SAMPLES[sampleName]).forEach((property) => {
            tmpVariantData[varIndex][sampleName + '_' + property] = tmpVariantData[varIndex].SAMPLES[sampleName][property];
            // if (property==='GT'){
            //   tmpVariantData[varIndex][sampleName + '_' + property] = tmpVariantData[varIndex].SAMPLES[sampleName][property];
            //   // tmpVariantData[varIndex][getSampleType(sampleName,true) + '_' + sampleName + '_' + property] = tmpVariantData[varIndex].SAMPLES[sampleName][property];
            //   // tmpVariantData[varIndex][getSampleType(sampleName,true) + '_' + property] = tmpVariantData[varIndex].SAMPLES[sampleName][property];
            // }
          });
          // if(props.projectBaseURL==='ep'){
          if(tmpVariantData[varIndex].SAMPLES[sampleName]['_Alt_Percent']===undefined || tmpVariantData[varIndex].SAMPLES[sampleName]['_Alt_Percent']===null){
            tmpVariantData[varIndex][sampleName + '_Alt_Percent'] = Math.round(100*100*Number(tmpVariantData[varIndex].SAMPLES[sampleName]['AD'])/Number(tmpVariantData[varIndex].SAMPLES[sampleName]['DP']))/100 || null;
          }
        });
      }
    });

    if(missingVariants!==undefined)
      if(missingVariants>0)
        toast.error(`Cannot find coresponding variants for ${missingVariants} notes`, {duration:6000});
      else
        toast.success(`${getCurrentUserFirstName()}'s notes loaded successfully!`);

    return(tmpVariantData);
  }

  function downloadCaseData(signedURL, caseAnalysisName="") {
    return new Promise(function (resolve, reject) {
      if (request) {
        request.abort();
      }
      let xhReq = new XMLHttpRequest();
      request = xhReq;

      xhReq.addEventListener("progress", (oEvent) => {
        // if(xhReq.responseText.length > 534845903) console.log("vvvvv", xhReq.responseText.length)
        // progress on transfers from the server to the client (downloads)
        let contentLength = 0;
        let uncompressedContentLength = 0;
        if (oEvent.lengthComputable) {
          contentLength = oEvent.total;
          uncompressedContentLength = contentLength;
        } else if (oEvent.target.getAllResponseHeaders().indexOf("content-length") >= 0) {
          // contentLength = parseInt(oEvent.target.getResponseHeader('content-length'), 10)*10; // there is no 'x-decompressed-content-length' in teh header
          contentLength = parseInt(oEvent.target.getResponseHeader('content-length'), 10); // there is no 'x-decompressed-content-length' in teh header
          uncompressedContentLength = contentLength * 10;
        }

        if (contentLength) {
          // console.log(75 * oEvent.loaded / uncompressedContentLength, uncompressedContentLength,75 * oEvent.loaded)
          let percentComplete = Math.round(75 * oEvent.loaded / uncompressedContentLength );
          // updateCaseLoadingProgressBar(`Downloading data for ${caseAnalysisName}... (${(oEvent.loaded/1000000).toFixed(1)} MB of ${(contentLength/1000000).toFixed(1)} MB)`, percentComplete);
          updateCaseLoadingProgressBar(`Downloading data for ${caseAnalysisName}... (${(contentLength/1000000).toFixed(1)} MB)`, percentComplete);
        } else {
          updateCaseLoadingProgressBar(`Downloading data for ${caseAnalysisName} (unknown size)`, 50);
          console.log('Unable to compute progress information since the total size is unknown');
        }
        // if (oEvent.lengthComputable) {
        //   let percentComplete = Math.round(oEvent.loaded / oEvent.total * 90);
        //   updateCaseLoadingProgressBar(`Downloading data for ${caseAnalysisName}... (${(oEvent.loaded/1000000).toFixed(1)} MB of ${(oEvent.total/1000000).toFixed(1)} MB)`, percentComplete);
        // }
      });

      // get a callback when the server responds
      xhReq.addEventListener("load", (oEvent) => {
        resolve(xhReq.responseText); // resolve(parse_JSONL(xhReq.responseText));
      });

      // TODO: handle error in these:
      xhReq.addEventListener("error", (e) => { console.error(e); reject(`An error occurred while transferring the file (${e})`); });
      xhReq.addEventListener("abort", () => { reject("Transfer has been canceled by the user"); });
      // xhReq.addEventListener("loadend",() => { console.error("Transfer finished (succeeded or not?!)");   });
      // xhReq.addEventListener("loadstart",() => { console.error("Transfer started!");   });
      xhReq.open('GET', signedURL);
      // xhReq.setRequestHeader("Content-Encoding", "gzip");
      // xhReq.onreadystatechange = function () { if (xhReq.readyState === 4) { console.log(xhReq.status); //console.log(xhReq.responseText); }};

      // send the request
      xhReq.send();
    });
  }

  function downloadAllExistingCnvNotes(allSignedUrls, caseAnalysisId, analysisObj) {
    const userNames = [];
    const promises = [];
    let allExistingNotesAggregated = [];
    setIsLoadingNotes(true);
    allSignedUrls.forEach( signedUrl => {
      // console.log(signedUrl);
      let fileUserName = signedUrl.match(/(\w*).json/)[1].replaceAll('_',' ') || "Unknown";
      if(isNoteScopeAllAnalysis){
        let thisNoteAnalysisId = signedUrl.match(/\/ANALYSIS_ID%3D(.*)\/USERNAME/)[1] // * `=` is replaced by `%3D`
        if (!!activeCaseInfo && !!activeCaseInfo.ANALYSES){
          let thisNoteAnalysisInfo = activeCaseInfo.ANALYSES.find(t => t.ANALYSIS_ID === thisNoteAnalysisId);
          if(!!thisNoteAnalysisInfo){
            if(analysisObj.ANALYSIS_ID !== thisNoteAnalysisId)
              fileUserName += ` ::[ ${thisNoteAnalysisInfo.ANALYSIS_NAME} (${thisNoteAnalysisInfo.ANALYSIS_TYPE}) ]`
          }
        }
        // fileUserName += signedUrl.match(/\/ANALYSIS_ID%3D(.*)\/USERNAME/)[1]
        // console.log(analysisObj.ANALYSIS_ID, '--', thisNoteAnalysisId);
        // if(!caseAnalysisId.includes(thisNoteAnalysisId))
        // if(analysisObj.ANALYSIS_ID !== thisNoteAnalysisId)
        // fileUserName += ` ::[ ${analysisObj.ANALYSIS_NAME} (${analysisObj.ANALYSIS_TYPE}) ]`
      }

      // * no need to do First letter uppercase as we did not use  .toUpperCase() to save so no need to process it here. 
      // fileUserName = fileUserName.toLowerCase().split(' ').map((s) => s.charAt(0).toUpperCase() + s.substring(1)).join(' ');
      // if(fileUserName!==props.userName){
        userNames.push(fileUserName);
        if(!signedUrl.includes("USERNAME=REVIEWS")) //* excluding the review.json file from this part.
          promises.push(downloadIndividualNote(signedUrl));
        // promises.push(downloadIndividualNote(signedUrl, fileUserName));
      // }
    });

    Promise.all(promises)
    .then((results) => {
      results.forEach( (setOfNote, index) => {
        let notes = parse_JSONL(setOfNote);
        notes.forEach( myNote => {
          const thisNoteTag = myNote['VANEX_TAGS']===true ? 1 : (myNote['VANEX_TAGS']===false ? 0 : myNote['VANEX_TAGS']);
          allExistingNotesAggregated.push(
            {
              ...myNote,
              USERNAME: userNames[index],
              IS_SET_BY_OTHERS: userNames[index]!==props.userName,
              VANEX_TAGS: thisNoteTag
            }
          );
        });
      });
      
      allExistingNotesAggregated.sort( (elA,elB) => (elA.UPDATED_AT > elB.UPDATED_AT) ? -1 : ((elB.UPDATED_AT > elA.UPDATED_AT) ? 1 : 0)); // * reverse sorting (descending)
      // console.log(allExistingNotesAggregated);
      // console.log(activeCaseInfo)
      // allExistingNotesAggregated.sort( (elA,elB) =>  elA.UPDATED_AT.localeCompare(elB.UPDATED_AT)); // * ascending
      // setOpenCases(prevOpenCases => prevOpenCases.map(indvCase => (indvCase[0] === caseAnalysisId ? [indvCase[0], [...indvCase[1]], allExistingNotesAggregated] : indvCase)));
      setOpenCases(prevOpenCases => prevOpenCases.map(indvCase => (indvCase[0] === caseAnalysisId ? 
        indvCase.map( (pieceOfCaseInfo, infoIndex) => (infoIndex === 1 ? 
          pieceOfCaseInfo.map( variantData => {
            let foundNotes = Object.values(allExistingNotesAggregated)
            .filter( t => t['CHROMOSOME']===variantData['CHROMOSOME']
                      &&  t['LOC_START']===variantData['LOC_START']
                      &&  t['LOC_END']===variantData['LOC_END']
                      &&  t['SEG_MEAN']===variantData['SEG_MEAN'] )
            .map( ({USERNAME, VANEX_TAGS, VANEX_NOTES, UPDATED_AT, IS_SET_BY_OTHERS}) => ({USERNAME, VANEX_TAGS, VANEX_NOTES, UPDATED_AT, IS_SET_BY_OTHERS}));
            return( (Object.keys(foundNotes).length > 0) ?
              {...variantData, VANEX_NOTES:  {...variantData['VANEX_NOTES'] , ALL_USERS_NOTES:foundNotes} }
            :
              variantData
            );
          })
          : pieceOfCaseInfo))
      : indvCase)))

      toast.success("All notes loaded successfully!");
      setIsLoadingNotes(false);
    })
    .catch((e) => {
      toast.error("Error: " + e);
      setIsLoadingNotes(false);
    });
  }

  function downloadMTData(signedURL, text) {
    return downloadReviewRecordsOrDenovoAssessments(signedURL, text);
  }

  function downloadCnvData(signedURL) {
    return downloadIndividualNote(signedURL);
  }

  function downloadReviewRecordsOrDenovoAssessments(signedURL, text) {  // , userName
    console.log("tmpVariantData FUS ", signedURL);
    console.log("tmpVariantData text ", text);
    return new Promise(function (resolve, reject) {
      fetch(signedURL, {
        method: 'GET',
        mode: 'cors'
      })
      .then(response => { 
        console.log('response', response)    
        if (!response.ok) { // if (status >= 200 && status < 300) {
          reject("HTTP error " + response.status);
        }
        resolve(response.json());
      })
      .catch(e => {
        console.error(`Failed to retrieve ${text}.`, e); //! fix the error message!
      });
    });
  }

  
  // function downloadDenovo_assessments(signedURL) {  // , userName
  //   return new Promise(function (resolve, reject) {
  //     fetch(signedURL, {
  //       method: 'GET',
  //       mode: 'cors'
  //     })
  //     .then(response => {     
  //       if (!response.ok) { // if (status >= 200 && status < 300) {
  //         reject("HTTP error " + response.status);
  //       }
  //       resolve(response.json());
  //     })
  //     .catch(e => {
  //       console.error("Failed to retrieve de novo assessments.", e); //! fix the error message!
  //     });
  //   });
  // }

  function downloadAllExistingNotes(allSignedUrls, caseAnalysisId, analysisObj) {
    const userNames = [];
    const promises = [];
    let allExistingNotesAggregated = [];
    setIsLoadingNotes(true);
    allSignedUrls.forEach( signedUrl => {
      // console.log(signedUrl);
      let fileUserName = signedUrl.match(/(\w*).json/)[1].replaceAll('_',' ') || "Unknown";
      if(isNoteScopeAllAnalysis){
        let thisNoteAnalysisId = signedUrl.match(/\/ANALYSIS_ID%3D(.*)\/USERNAME/)[1] // * `=` is replaced by `%3D`
        if (!!activeCaseInfo && !!activeCaseInfo.ANALYSES){
          let thisNoteAnalysisInfo = activeCaseInfo.ANALYSES.find(t => t.ANALYSIS_ID === thisNoteAnalysisId);
          if(!!thisNoteAnalysisInfo){
            if(analysisObj.ANALYSIS_ID !== thisNoteAnalysisId)
              fileUserName += ` ::[ ${thisNoteAnalysisInfo.ANALYSIS_NAME} (${thisNoteAnalysisInfo.ANALYSIS_TYPE}) ]`
          }
        }
        // fileUserName += signedUrl.match(/\/ANALYSIS_ID%3D(.*)\/USERNAME/)[1]
        // console.log(analysisObj.ANALYSIS_ID, '--', thisNoteAnalysisId);
        // if(!caseAnalysisId.includes(thisNoteAnalysisId))
        // if(analysisObj.ANALYSIS_ID !== thisNoteAnalysisId)
        // fileUserName += ` ::[ ${analysisObj.ANALYSIS_NAME} (${analysisObj.ANALYSIS_TYPE}) ]`
      }

      // * no need to do First letter uppercase as we did not use  .toUpperCase() to save so no need to process it here. 
      // fileUserName = fileUserName.toLowerCase().split(' ').map((s) => s.charAt(0).toUpperCase() + s.substring(1)).join(' ');
      // if(fileUserName!==props.userName){
        userNames.push(fileUserName);
        if(!signedUrl.includes("USERNAME=REVIEWS")) //* excluding the review.json file from this part.
          promises.push(downloadIndividualNote(signedUrl));
        // promises.push(downloadIndividualNote(signedUrl, fileUserName));
      // }
    });

    Promise.all(promises)
    .then((results) => {
      results.forEach( (setOfNote, index) => {
        let notes = parse_JSONL(setOfNote);
        notes.forEach( myNote => {
          const thisNoteTag = myNote['VANEX_TAGS']===true ? 1 : (myNote['VANEX_TAGS']===false ? 0 : myNote['VANEX_TAGS']);
          // console.log("myNote", myNote, " t = ", thisNoteTag)
          allExistingNotesAggregated.push(
            {
              ...myNote,
              USERNAME: userNames[index],
              IS_SET_BY_OTHERS: userNames[index]!==props.userName,
              VANEX_TAGS: thisNoteTag
            }
          );
        });
      });
      
      allExistingNotesAggregated.sort( (elA,elB) => (elA.UPDATED_AT > elB.UPDATED_AT) ? -1 : ((elB.UPDATED_AT > elA.UPDATED_AT) ? 1 : 0)); // * reverse sorting (descending)
      // console.log("allExistingNotesAggregated", allExistingNotesAggregated);
      // console.log(activeCaseInfo)
      // allExistingNotesAggregated.sort( (elA,elB) =>  elA.UPDATED_AT.localeCompare(elB.UPDATED_AT)); // * ascending
      // setOpenCases(prevOpenCases => prevOpenCases.map(indvCase => (indvCase[0] === caseAnalysisId ? [indvCase[0], [...indvCase[1]], allExistingNotesAggregated] : indvCase)));
      // console.log("allExistingNotesAggregated", allExistingNotesAggregated.map( vr => ({...vr, VANEX_TAGS: 3 }) ))
      setOpenCases(prevOpenCases => prevOpenCases.map(indvCase => (indvCase[0] === caseAnalysisId ? 
        indvCase.map( (pieceOfCaseInfo, infoIndex) => (infoIndex === 1 ? 
          pieceOfCaseInfo.map( variantData => {
            let foundNotes = Object.values(allExistingNotesAggregated)
            // .map( varData => ({...varData, VANEX_TAGS: (varData['VANEX_TAGS']===true ? 1 : (varData['VANEX_TAGS']===false ? 0 : varData['VANEX_TAGS']) ) }) )
            .filter( t => t['CHROMOSOME']===variantData['CHROMOSOME']
                      &&  t['POSITION']===variantData['POSITION']
                      &&  t['REF']===variantData['REF']
                      &&  t['ALT']===variantData['ALT'] )
            .map( ({USERNAME, VANEX_TAGS, VANEX_NOTES, UPDATED_AT, IS_SET_BY_OTHERS}) => ({USERNAME, VANEX_TAGS, VANEX_NOTES, UPDATED_AT, IS_SET_BY_OTHERS}));
            return( (Object.keys(foundNotes).length > 0) ?
              {...variantData, VANEX_NOTES:  {...variantData['VANEX_NOTES'] , ALL_USERS_NOTES:foundNotes} }
            :
              variantData
            );
          })
          : pieceOfCaseInfo))
      : indvCase)))

      toast.success("All notes loaded successfully!");
      setIsLoadingNotes(false);
    })
    .catch((e) => {
      toast.error("Error: " + e);
      setIsLoadingNotes(false);
    });
  }
  function downloadAllExistingSVNotes(allSignedUrls, caseAnalysisId, analysisObj) {
    const userNames = [];
    const promises = [];
    let allExistingNotesAggregated = [];
    setIsLoadingNotes(true);
    allSignedUrls.forEach( signedUrl => {
      // console.log(signedUrl);
      let fileUserName = signedUrl.match(/(\w*).json/)[1].replaceAll('_',' ') || "Unknown";
      if(isNoteScopeAllAnalysis){
        let thisNoteAnalysisId = signedUrl.match(/\/ANALYSIS_ID%3D(.*)\/USERNAME/)[1] // * `=` is replaced by `%3D`
        if (!!activeCaseInfo && !!activeCaseInfo.ANALYSES){
          let thisNoteAnalysisInfo = activeCaseInfo.ANALYSES.find(t => t.ANALYSIS_ID === thisNoteAnalysisId);
          if(!!thisNoteAnalysisInfo){
            if(analysisObj.ANALYSIS_ID !== thisNoteAnalysisId)
              fileUserName += ` ::[ ${thisNoteAnalysisInfo.ANALYSIS_NAME} (${thisNoteAnalysisInfo.ANALYSIS_TYPE}) ]`
          }
        }
        // fileUserName += signedUrl.match(/\/ANALYSIS_ID%3D(.*)\/USERNAME/)[1]
        // console.log(analysisObj.ANALYSIS_ID, '--', thisNoteAnalysisId);
        // if(!caseAnalysisId.includes(thisNoteAnalysisId))
        // if(analysisObj.ANALYSIS_ID !== thisNoteAnalysisId)
        // fileUserName += ` ::[ ${analysisObj.ANALYSIS_NAME} (${analysisObj.ANALYSIS_TYPE}) ]`
      }

      // * no need to do First letter uppercase as we did not use  .toUpperCase() to save so no need to process it here. 
      // fileUserName = fileUserName.toLowerCase().split(' ').map((s) => s.charAt(0).toUpperCase() + s.substring(1)).join(' ');
      // if(fileUserName!==props.userName){
        userNames.push(fileUserName);
        if(!signedUrl.includes("USERNAME=REVIEWS")) //* excluding the review.json file from this part.
          promises.push(downloadIndividualNote(signedUrl));
        // promises.push(downloadIndividualNote(signedUrl, fileUserName));
      // }
    });

    Promise.all(promises)
    .then((results) => {
      results.forEach( (setOfNote, index) => {
        let notes = parse_JSONL(setOfNote);
        notes.forEach( myNote => {
          const thisNoteTag = myNote['VANEX_TAGS']===true ? 1 : (myNote['VANEX_TAGS']===false ? 0 : myNote['VANEX_TAGS']);
          // console.log("myNote", myNote, " t = ", thisNoteTag)
          allExistingNotesAggregated.push(
            {
              ...myNote,
              USERNAME: userNames[index],
              IS_SET_BY_OTHERS: userNames[index]!==props.userName,
              VANEX_TAGS: thisNoteTag
            }
          );
        });
      });
      
      allExistingNotesAggregated.sort( (elA,elB) => (elA.UPDATED_AT > elB.UPDATED_AT) ? -1 : ((elB.UPDATED_AT > elA.UPDATED_AT) ? 1 : 0)); // * reverse sorting (descending)
      // console.log("allExistingNotesAggregated", allExistingNotesAggregated);
      // console.log(activeCaseInfo)
      // allExistingNotesAggregated.sort( (elA,elB) =>  elA.UPDATED_AT.localeCompare(elB.UPDATED_AT)); // * ascending
      // setOpenCases(prevOpenCases => prevOpenCases.map(indvCase => (indvCase[0] === caseAnalysisId ? [indvCase[0], [...indvCase[1]], allExistingNotesAggregated] : indvCase)));
      // console.log("allExistingNotesAggregated", allExistingNotesAggregated.map( vr => ({...vr, VANEX_TAGS: 3 }) ))
      setOpenCases(prevOpenCases => prevOpenCases.map(indvCase => (indvCase[0] === caseAnalysisId ? 
        indvCase.map( (pieceOfCaseInfo, infoIndex) => (infoIndex === 1 ? 
          pieceOfCaseInfo.map( variantData => {
            let foundNotes = Object.values(allExistingNotesAggregated)
            // .map( varData => ({...varData, VANEX_TAGS: (varData['VANEX_TAGS']===true ? 1 : (varData['VANEX_TAGS']===false ? 0 : varData['VANEX_TAGS']) ) }) )
            .filter( t => t['CHROMOSOME']===variantData['CHROMOSOME']
                      &&  t['LOC_START']===variantData['LOC_START']
                      &&  t['LOC_END']===variantData['LOC_END'] )
            .map( ({USERNAME, VANEX_TAGS, VANEX_NOTES, UPDATED_AT, IS_SET_BY_OTHERS}) => ({USERNAME, VANEX_TAGS, VANEX_NOTES, UPDATED_AT, IS_SET_BY_OTHERS}));
            return( (Object.keys(foundNotes).length > 0) ?
              {...variantData, VANEX_NOTES:  {...variantData['VANEX_NOTES'] , ALL_USERS_NOTES:foundNotes} }
            :
              variantData
            );
          })
          : pieceOfCaseInfo))
      : indvCase)))

      toast.success("All notes loaded successfully!");
      setIsLoadingNotes(false);
    })
    .catch((e) => {
      toast.error("Error: " + e);
      setIsLoadingNotes(false);
    });
  }

  
  //? --------------------------------------------- setSate ----------------------------------


  function showDbOverview(){
    setActiveCaseId('');
    setActiveCaseInfo({});
    setShowSearchPanel(false);
    setViewAnalysis(false);
    history.push(`/${props.projectBaseURL}`);
  }


  function showSearchResult(){
    setActiveCaseId('');
    setActiveCaseInfo({});
    setShowSearchPanel(true);
    setViewAnalysis(false);
  }


  function showActiveCaseCardInfo(caseID, showEditView=false){
    // console.log('showActiveCaseCardInfo('+caseID);
    setActiveCaseId(caseID);
    setActiveCaseInfo(Object.values(projectDb).find(t => t.CASE_ID===caseID));

    setShowSearchPanel(false);
    setViewAnalysis(false);
    if(showEditView)
      history.push(`/${props.projectBaseURL}/${caseID}/edit`);
    else
      history.push(`/${props.projectBaseURL}/${caseID}`);
  }


  function showAnalysisPanel(caseID, analysisID){
    setActiveCaseId(caseID);
    setActiveCaseInfo(Object.values(projectDb).find(t => t.CASE_ID===caseID));
    setShowSearchPanel(false);
    
    setViewAnalysis(true);
    setIsLoadingCaseData(false);
    setCaseLoadingMessage('');
    setCaseLoadingProgress(0);
    history.push(`/${props.projectBaseURL}/${caseID}/analysis/${analysisID}`); 
  }


  function showAddNewCase(){
    setActiveCaseId('');
    setActiveCaseInfo({});
    setShowSearchPanel(false);
    setViewAnalysis(false);
    history.push(`/${props.projectBaseURL}/add`); 
  }
 

  function updateCaseLoadingProgressBar(message='Loading...', progress){
    // console.log(progress)
    setIsLoadingCaseData(true);
    // caseLoadingMessage:`<h3>${message}</h3>`
    setCaseLoadingMessage(<h3>{message}</h3>);
    setCaseLoadingProgress(progress);
  }


  function setSearchError(message='Error...'){
    setIsLoadingSearchResult(false);
    setClinVarPlotSrc('');
    setSearchErrorMessage(message);
    setIsSearchResultReady(false);
    // console.log(message);
  }

  //? --------------------------------------------- Renders ----------------------------------


  //? --------------------------------------------- Render Case Forms ----------------------------------


  // ! make sure to add code to check for existing caseID. cannot have duplicated caseIDs
  function RenderAddEditCaseInformation(renderCaseInfoProps){
    const [isSubmitEnable, setIsSubmitEnable] = useState(true);
    let params = useParams();

    function handleAddEditNewCaseForm(fields){
      // console.log('fields',fields)
      // ? sample Object
      // {
      //   "CASE_ID": "CD200123",
      //   "PROTOCOL": "RD",
      //   "ALT_ID": "",
      //   "PRIMARY_PHENOTYPE": "Micro",
      //   "CASE_STATUS": "Pre-QC",
      //   "STUDY_TYPE": "Trio",
      //   "CASE_NOTE": "",
      //   "CASE_OUTCOME": "",
      //   "N_INDIVIDUALS": 3,
      //   "INDIVIDUALS": [
      //       {
      //           "INDIVIDUAL_TYPE": "Proband",
      //           "SEX": "",
      //           "AGE": "",
      //           "AFFECTED": true,
      //           "PHENOTYPE": ""
      //       },
      //       {
      //           "INDIVIDUAL_TYPE": "Mother",
      //           "SEX": "Female",
      //           "AGE": "",
      //           "AFFECTED": false,
      //           "PHENOTYPE": ""
      //       },
      //       {
      //           "INDIVIDUAL_TYPE": "Father",
      //           "SEX": "Male",
      //           "AGE": "",
      //           "AFFECTED": false,
      //           "PHENOTYPE": ""
      //       }
      //   ],
      //   "ANALYSES": [],
      //   "updateSamplesFromParquet": false
      // }

      if(!(props.isPowerUser || props.isAdmin)){
        toast.error('Permission Denied.');
        return;
      }

      setIsSubmitEnable(false);

      fields['updateSamplesFromParquet'] = false;
      // ! console.log(fields); return// alert('SUCCESS!! :-)\n\n' + JSON.stringify(fields, null, 4));

      Auth.currentSession().then(data => {
        let id_token = data.getIdToken().getJwtToken();
        // const url_to_fetch = ENDPOINT_BASE+`add_new_case?caseid=${caseID.toUpperCase()}&s3path=xxxx${s3path}`;
        // const url_to_fetch = ENDPOINT_BASE+`add_new_case?caseid=CD200123&s3path=s3://nch-igm-research-rare-disease/2021/CD200123/churchill/2021-02-01/varhouse/2021-02-03T14-00-21/parquet/CD200123.parquet`;
        // console.log(url_to_fetch);
        const url_to_send_to = `${ENDPOINT_BASE}add_new_case?project=${props.project}`


        toast.promise(
          sendCaseInformation(url_to_send_to, fields, id_token),
          {
            loading: 'Saving...',
            success: (data) => <>Successfully saved<br/>{data}</>,
            //  success: <b>Settings saved!</b>,
            error: (err) => `Error: ${err}`,
            //  error: <b>Could not save.</b>,
          },{
            success: {
              duration: 5000,
            },
          }
        );

      })
      .catch( e => setErrorLog([`Error in saving: ${e}`, '']));
    }


    function sendCaseInformation(url_to_send_to, fields, id_token) {
      return new Promise(function (resolve, reject) {
        if (request) {
          request.abort();
        }
        let xhReq = new XMLHttpRequest();
        request = xhReq;
  
        // xhReq.addEventListener("progress", (oEvent) => {
        //   // progress on transfers from the server to the client (downloads)
        //   if (oEvent.lengthComputable) {
        //     let percentComplete = Math.round(oEvent.loaded / oEvent.total * 90);
        //     updateCaseLoadingProgressBar(`Downloading data for ${caseAnalysisName}... (${(oEvent.loaded/1000000).toFixed(1)} MB of ${(oEvent.total/1000000).toFixed(1)} MB)`, percentComplete);
        //   } else {
        //     updateCaseLoadingProgressBar(`Downloading data for ${caseAnalysisName} (unknown size)`, 50);
        //     toast.error('Unable to compute progress information since the total size is unknown');
        //   }
        // });

        // get a callback when the server responds
        xhReq.addEventListener("load", (oEvent) => {
          if (xhReq.status===200) {
            // console.log(xhReq.responseText);
            // toast.success(xhReq.responseText);
            // showAlert(xhReq.responseText, 0, true, 'Success!');
            // showDbOverview();
            loadVaNexDb();
            history.push(`/${props.projectBaseURL}/${fields['CASE_ID']}`);
            resolve(xhReq.responseText);
          }
          else {
            setErrorLog([xhReq.responseText,'']);
            reject();
          }
        });

        // TODO: handle error in these:
        xhReq.addEventListener("error", () => {  reject("An error occurred while transferring the file"); });
        xhReq.addEventListener("abort", () => { reject("Transfer has been canceled by the user"); });
        // xhReq.addEventListener("error", () => {  setErrorLog(['An error occurred while transferring the data','']);  });
        // xhReq.addEventListener("abort", () => { setErrorLog(['Transfer has been canceled by the user', '']);   });
        // xhReq.addEventListener("loadend",() => { setErrorLog(['Transfer finished (succeeded or not?!)'], '');   });
        // xhReq.addEventListener("loadstart",() => { console.error('Transfer started!');   });
        
        xhReq.open("POST", url_to_send_to, true);
        // xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded; charset=UTF-8");
        xhReq.setRequestHeader('Content-Type', 'application/json');
        xhReq.setRequestHeader('Accept', 'application/json');
        xhReq.setRequestHeader('Authorization','Bearer ' + id_token);

        // console.log('----');
        // console.log(fields);
        xhReq.send(JSON.stringify(fields));
      });
    }

    function onNumOfIndividualsChange(e, field, values, setValues) {
      // update dynamic form
      let INDIVIDUALS = [...values.INDIVIDUALS];
      const numOfSamples = e.target.value || 0;
      const previousNumber = parseInt(field.value || '0');
      // console.log(e.target.value, '-', field.value,'-',previousNumber, '-',numOfSamples);
      if (previousNumber < numOfSamples) {
        for (let i = previousNumber; i < numOfSamples; i++) {
          INDIVIDUALS.push({ INDIVIDUAL_TYPE: '', SEX: '', AGE: '', AFFECTED: false, PHENOTYPE: '' });
        }
      } else {
        for (let i = previousNumber; i >= numOfSamples; i--) {
          INDIVIDUALS.splice(i, 1);
        }
      }
      setValues({ ...values, INDIVIDUALS });

      // call formik onChange method
      field.onChange(e);
    }
    
    function caseForm(errors, values, touched, setValues, title='Add a New Case/Family', editMode = false){
      let EnrolmentOptions = ['Enrolled','Withdrawn','Declined','Pending','Rejected','Declined, Enrolled','Referred','In Progress','On Hold','Unknown'].map(t => ({value: t, label:t}));
      let StatusOptions = CaseStatusOptions.map(t => ({value: t, label:t}));
      let TagOptions = ['Red','Green','Blue','Yellow','Gray','Pink','Purple','Dark Green','Dark Blue','Dark Gray'].map(t => ({value: t, label:t}));
      
      if(!!projectDb && projectDb.length>0){
        EnrolmentOptions = [...new Set(projectDb.map(t => t.ENROLLMENT).concat(EnrolmentOptions.map(m => m.label)).filter(z => !!z && z.trim()!==""))].map(t => ({value: t, label:t}));
        StatusOptions = [...new Set(projectDb.map(t => t.CASE_STATUS).concat(StatusOptions.map(m => m.label)).filter(z =>  !!z && z.trim()!=="") )].map(t => ({value: t, label:t}));
        TagOptions = [...new Set(projectDb.map(t => t.TAGS).flat().concat(TagOptions.map(m => m.label)).filter(z =>  !!z && z.trim()!=="") )].map(t => ({value: t, label:t}));
      }
      // console.log('values',values)
      return(
        <Form>
          <div className="card m-3 fs-6" style={{minWidth:'1200px'}}>
            <div className="card-header bg-lightsteel-blue py-1 d-flex align-items-center ">
              <div className=" text-center flex-grow-1 fs-4">{title}</div>
              {(editMode) ?
                <button type="button" className="btn-close" aria-label="Close" onClick={() => history.push(`/${props.projectBaseURL}/${params.caseId}`)}></button>
              :
                <button type="button" className="btn-close" aria-label="Close" onClick={showDbOverview}></button>
              }
            </div>
            <div className="card-body border-bottom">
              <div className="row">
                <div className="form-group col-1">
                  <label className="ms-1">Protocol</label>
                  <Field name="PROTOCOL" className="form-control" type="text" placeholder="CD, RD, etc." aria-label="Protocol"/>
                  <ErrorMessage name="PROTOCOL" component="div" className="text-danger" />
                </div>
                <div className="form-group col-2">
                  <label className="mx-2">Case ID</label>
                  <Field name="CASE_ID" className="form-control" type="text" placeholder="" aria-label="Case ID" disabled={editMode}
                    onBlur={(e) => setValues({ ...values, CASE_ID: e.target.value })} />
                    {/* onBlur={(e) => setValues({ ...values, CASE_ID: e.target.value.toUpperCase() })} /> */}
                  <ErrorMessage name="CASE_ID" component="div" className="text-danger" />
                </div>
                <div className="form-group col-2">
                  <label className="ms-1">Alt.ID</label>
                  <Field name="ALT_ID" className="form-control" type="text" placeholder="" aria-label="Alt.ID"/>
                  <ErrorMessage name="ALT_ID" component="div" className="text-danger" />
                </div>
                <div className="form-group col-5">
                  <label className="mx-2">Primary Phenotype</label>
                  <Field name="PRIMARY_PHENOTYPE" className="form-control" type="text" placeholder="Multiple terms separated by ; " aria-label="Primary Phenotype"/>
                  <ErrorMessage name="PRIMARY_PHENOTYPE" component="div" className="text-danger" />
                </div>
                <div className="form-group col-2">
                  <label className="mx-2">Study Type</label>
                  <Field name="STUDY_TYPE" className="form-control" type="text" placeholder="Trio WGS, Singleton WES " aria-label="Study Type"/>
                  <ErrorMessage name="STUDY_TYPE" component="div" className="text-danger" />
                </div>
                
              </div>
  
              <div className="row mt-2">
                <div className="form-group col-3">
                  <label className="mx-2">Enrollment</label>
                  <Field name="ENROLLMENT">
                    {({ field }) => (
                      <CreatableSelect
                        className="w-100"
                        defaultValue={EnrolmentOptions.find(t => t['value']===values.ENROLLMENT)}
                        onChange={ selectedOption => setValues({ ...values, ENROLLMENT: selectedOption.value})}
                        options={EnrolmentOptions}
                        placeholder='Select Enrollment'
                      />
                    )}
                  </Field>
                  <ErrorMessage name="ENROLLMENT" component="div" className="text-danger" />
                </div>
                <div className="form-group col-3">
                  <label className="mx-2">Status</label>
                  <Field name="CASE_STATUS">
                    {({ field }) => (
                      <CreatableSelect
                        className="w-100"
                        defaultValue={StatusOptions.find(t => t['value']===values.CASE_STATUS)}
                        onChange={ selectedOption => setValues({ ...values, CASE_STATUS: selectedOption.value})}
                        options={StatusOptions}
                        placeholder='Select Status'
                      />
                    )}
                  </Field>
                  <ErrorMessage name="CASE_STATUS" component="div" className="text-danger" />
                </div>
                <div className="form-group col-3">
                  <label className="mx-2">Outcome</label>
                  <Field name="CASE_OUTCOME" className="form-control" type="text" placeholder="" aria-label="CASE_OUTCOME" />
                </div>
                <div className="form-group col-3">
                  <label className="mx-2">Notified On</label>
                  <Field name="NOTIFIED" className="form-control" type="text" placeholder="" aria-label="NOTIFIED" disabled/>
                </div>
              </div>
              <div className="row mt-2">
                <div className="form-group col-12">
                  <label className="mx-2">Note</label>
                  <Field component="textarea" name="CASE_NOTE" className="form-control" rows="4" placeholder="..."/>
                </div>
                {/* <div className="form-group col-6">
                  <label className="mx-2">Outcome</label>
                  <Field component="textarea" name="CASE_OUTCOME" className="form-control" rows="4" placeholder="..."/>
                </div> */}
              </div>

              <div className="row mt-2">
                <div className="form-group col-6">
                  <label className="mx-2">GeneMatcher</label>
                  <Field component="textarea" name="GENEMATCHER" className="form-control" rows="2" placeholder="..."/>
                </div>
                <div className="form-group col-6">
                  <label className="mx-2">Publication</label>
                  <Field component="textarea" name="PUBLICATION" className="form-control" rows="2" placeholder="..."/>
                </div>
              </div>

              <div className="row">
                <div className="form-group col-6">
                  <label className="ms-1">Candidates</label>
                  <Field name="CANDIDATES" className="form-control" type="text" placeholder="" aria-label="Candidates" disabled/>
                </div>
                <div className="form-group col-6">
                  <label className="ms-1">Tags</label>
                  <Field name="TAGS">
                    {({ field }) => (
                      <CreatableSelect
                        isMulti
                        closeMenuOnSelect={false}
                        className="w-100"
                        defaultValue={values.TAGS.map(tagVal => TagOptions.find(t => t['value']===tagVal))}
                        onChange={ selectedOption => setValues({ ...values, TAGS: selectedOption.map(m => m.value)})}
                        // onChange={ selectedOption => console.log(selectedOption.map(m => m.value))}
                        options={TagOptions}
                        placeholder='Select Tags'
                      />
                    )}
                  </Field>
                </div>                
              </div>

              <div className="row">
                <div className="form-group col-6">
                  <label className="mx-2">Confluence</label>
                  <Field name="LINK_CONFLUENCE" className="form-control" type="text" placeholder="" aria-label="LINK_CONFLUENCE"/>
                </div>
                <div className="form-group col-6">
                  <label className="mx-2">Jira</label>
                  <Field name="LINK_JIRA" className="form-control" type="text" placeholder="" aria-label="LINK_JIRA"/>
                </div>
              </div>

              <div className="row d-flex flex-column align-items-center mt-3">
                <div className="input-group" style={{maxWidth:'16rem'}}>
                  <span className="input-group-text">Number of Individuals</span>
                  <Field name="N_INDIVIDUALS">
                    {({ field }) => (
                      <input {...field} className="form-control" type="number" min="0" step="1"
                      onChange={e => onNumOfIndividualsChange(e, field, values, setValues)} />
                    )}
                  </Field>
                  <ErrorMessage name="N_INDIVIDUALS" component="div" className="invalid-feedback" />
                </div>
              </div>
              <FieldArray name="INDIVIDUALS">
              {() => (values.INDIVIDUALS.map((sample, i) => {
                // const sampleErrors = errors.samples?.length && errors.samples[i] || {};
                // const sampleTouched = touched.samples?.length && touched.samples[i] || {};
                return (
                  <div className="row py-2 px-1" key={i} >
                    <div className="list-group list-group-flush border border-secondary border-1 pb-2">
                      <div className="list-group-item">
                        <h5 className="card-title">Sample {i + 1}</h5>
                        <div className="row">
                          <div className="form-group col-5">
                            <label className="mx-2">Individual Label (Proband, Mother, etc.)</label>
                            <Field name={`INDIVIDUALS.${i}.INDIVIDUAL_TYPE`} className="form-control" type="text" placeholder="Proband, Mother, Father, etc." aria-label=""/>
                            <ErrorMessage name={`INDIVIDUALS.${i}.INDIVIDUAL_TYPE`} component="div" className="text-danger" />
                          </div>
                          <div className="form-group col-4">
                            <label className="mx-2">Sex</label>
                            <Field name={`INDIVIDUALS.${i}.SEX`} className="form-control" type="text" placeholder="Male/Female" aria-label=""/>
                            <ErrorMessage name={`INDIVIDUALS.${i}.SEX`} component="div" className="text-danger" />
                          </div>
                          <div className="form-group col-3">
                            <label className="mx-2">Age</label>
                            <Field name={`INDIVIDUALS.${i}.AGE`} className="form-control" type="text" placeholder="" aria-label=""/>
                            <ErrorMessage name={`INDIVIDUALS.${i}.AGE`} component="div" className="text-danger" />
                          </div>
                        </div>
                        <div className="row mt-2">
                          <div className="form-group col-2 d-flex flex-row align-items-center ">
                            <div className="form-check form-switch">
                              <label className="form-check-label">
                                <Field name={`INDIVIDUALS.${i}.AFFECTED`} className="form-check-input" type="checkbox" />
                                Affected</label>
                            </div>
                          </div>
                          <div className="form-group col-10">
                            <label className="mx-2">Phenotype</label>
                            <Field name={`INDIVIDUALS.${i}.PHENOTYPE`} className="form-control" type="text" placeholder="Multiple terms separated by ; " aria-label=""/>
                            <ErrorMessage name={`INDIVIDUALS.${i}.PHENOTYPE`} component="div" className="text-danger" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              }))}
              </FieldArray>
            </div>
            <div className="card-footer text-center border-top-0">
              <button className="btn btn-md btn-primary m-2 px-4 py-2" type="submit" disabled={!isSubmitEnable}><i className="fas fa-user-plus me-2"></i>Save</button>
              <button className="btn btn-secondary mr-1" type="reset">Reset</button>
            </div>
          </div>
        </Form>
      );
    }

    const addNewCaseFormFields = {
      CASE_ID: '',
      ALT_ID: '',
      PROTOCOL: '',
      PRIMARY_PHENOTYPE: '',
      CASE_STATUS: 'Pre-QC',
      STUDY_TYPE: '',
      CASE_NOTE: '',
      CASE_OUTCOME: '',
      N_INDIVIDUALS: 3,
      INDIVIDUALS: [
        {
          INDIVIDUAL_TYPE: 'Proband',
          SEX: '',
          AGE: '',
          AFFECTED: true,
          PHENOTYPE: ''
        },
        {
          INDIVIDUAL_TYPE: 'Mother',
          SEX: 'Female',
          AGE: '',
          AFFECTED: false,
          PHENOTYPE: ''
        },
        {
          INDIVIDUAL_TYPE: 'Father',
          SEX: 'Male',
          AGE: '',
          AFFECTED: false,
          PHENOTYPE: ''
        }
      ],
      ANALYSES: [],
      MRPHENE_SUBJECT_ID: null,
      STAR: 0,
      PRIORITY: 0,
      CANDIDATES: [],
      TAGS: [],
      ENROLLMENT: "Enrolled",
      LINK_JIRA: '',
      LINK_CONFLUENCE: '',
      NOTIFIED: '',
      GENEMATCHER: '',
      PUBLICATION: ''
    }

    const addNewCaseFormSchema = useMemo(() => 
      Yup.object().shape({
        CASE_ID: Yup.mixed().notOneOf(Object.values(projectDb).map(k => k.CASE_ID), 'Duplicate case IDs are not allowed!').required('Required!'),
        ENROLLMENT: Yup.string().min(2, 'Too Short!').required('Required'), //.max(50, 'Too Long!')
        CASE_STATUS: Yup.string().min(2, 'Too Short!')//.required('Required'), //.max(50, 'Too Long!')
        // email: Yup.string().email('Invalid email').required('Required'),
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }),[projectDb]);

    const editCaseFormSchema = useMemo(() => 
      Yup.object().shape({
        ENROLLMENT: Yup.string().min(2, 'Too Short!').required('Required'),
        CASE_STATUS: Yup.string().min(2, 'Too Short!')//.required('Required'),
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }),[projectDb]);

    // console.log(renderCaseInfoProps.mode);
    if(renderCaseInfoProps.mode === 'add'){
      return(
        <div className="bg-grey-lightest show-overflow absolute-panel d-flex flex-column align-items-center mt-5" >
          <Formik initialValues={addNewCaseFormFields} validationSchema={addNewCaseFormSchema} onSubmit={handleAddEditNewCaseForm}>
            {({ errors, values, touched, setValues }) => caseForm(errors, values, touched, setValues, 'Add a New Case/Family', false)}
          </Formik>
        </div>
      );
    } else {
      
      if(isLoadingCaseList){
        return(
          <div className="bg-grey-lightest show-overflow absolute-panel d-flex flex-column align-items-center pt-5">
            <div className="my-5">
              <span className="mx-3 spinner-border" role="status" aria-hidden="true"></span>
              <span className="fs-3">Loading...</span>
            </div>
          </div>
        );
      }

      let currentCasesearch = Object.values(projectDb).find( t => t.CASE_ID===params.caseId);
      if(currentCasesearch !== undefined){
        // let currentCase = JSON.parse(JSON.stringify(currentCasesearch));
        let currentCase = structuredClone(currentCasesearch);
        // if(currentCase['INDIVIDUALS'] && currentCase['INDIVIDUALS'].length > 0){
          currentCase['N_INDIVIDUALS'] = currentCase['INDIVIDUALS'] ? currentCase['INDIVIDUALS'].length : 0;
          // console.log('currentCase',currentCase);
          return(
            <div className="bg-grey-lightest show-overflow absolute-panel d-flex flex-column align-items-center mt-5">
              <Formik initialValues={currentCase} validationSchema={editCaseFormSchema} onSubmit={handleAddEditNewCaseForm}>
                {({ errors, values, touched, setValues }) => caseForm(errors, values, touched, setValues, `Edit ${params.caseId}`, true)}
              </Formik>
            </div>
          );
        // } else{
        //   return(
        //     <div className="bg-grey-lightest show-overflow absolute-panel d-flex flex-column align-items-center mt-5">
        //       <h2 className="my-4">"{params.caseId}" record is corrupted. Please let the admin know!</h2>
        //     </div>
        //   );
        // }
      } else {
        return(
          <div className="bg-grey-lightest show-overflow absolute-panel d-flex flex-column align-items-center mt-5">
            <h2 className="my-4">"{params.caseId}" Not Found</h2>
          </div>
        );
      }
    }
  }

  






  //? --------------------------------------------- Render Analysis Forms ----------------------------------

  
  function RenderAddEditAnalysisInformation(renderAnalysisProps){
    const [updatingNewAnalysisSamples, setUpdatingNewAnalysisSamples] = useState(false);
    const [isSubmitEnable, setIsSubmitEnable] = useState(true);
    
    let params = useParams();

    function handleAddEditNewAnalysisForm(fields){

      // ? sample Object
      //   {
      //     "CASE_ID": "JLE0059",
      //     "ANALYSIS_ID": "SNV_2021-10-26T20-33-25",
      //     "ANALYSIS_NAME": "SNV_2021-10-26",
      //     "ANALYSIS_NAME_SUFFIX": "2021-10-26T20-33-25",
      //     "ANALYSIS_TYPE": "",
      //     "ANALYSIS_NOTE": "s",
      //     "SOURCE_FILE_STATUS": 0,
      //     "PARQUET_URI": "s3://nch-igm-research-rare-disease/2021/CD200123/churchill/2021-02-01/varhouse/2021-02-03T14-00-21/parquet/CD200123.parquet",
      //     "V_REF": "GRCh38",
      //     "N_PARQUET_VARIANTS": 0,
      //     "N_VARIANTS": 0,
      //     "N_GENES": 0,
      //     "N_SAMPLES": 2,
      //     "SAMPLES": [
      //         {
      //             "SAMPLE_ID": "CD200123_A415_P_01D",
      //             "SAMPLE_TYPE": "Proband",
      //             "FILE_URI": ""
      //         },
      //         {
      //             "SAMPLE_ID": "CD200123_A416_M_01D",
      //             "SAMPLE_TYPE": "Mother",
      //             "FILE_URI": ""
      //         }
      //     ],
      //     "updateSamplesFromParquet": false
      // }
      
      // console.log('AddEditNewAnalysisFormFields', fields);

      if(!(props.isPowerUser || props.isAdmin)){
        toast.error('Permission Denied.');
        return;
      }
      
      if(fields['JSON_URI'].length === 0 && fields['PARQUET_URI'].length === 0){
        toast.error('Please enter the source file URI.');
        return 1;
      }

      setIsSubmitEnable(false);
      // let xx = toast.loading("Updating...")
      // delete fields['updateSamplesFromParquet'];
      // xx.close();
      //! * it is best to sort before sending to the DB, but this is not fully functional yet! 
      // fields.SAMPLES.sort( (elA,elB) => (GetSampleRank(elB.SAMPLE_TYPE) - GetSampleRank(elA.SAMPLE_TYPE)) );
      // fields.SAMPLES.sort( (elA,elB) => (GetSampleRank(elB.SAMPLE_TYPE, false, fields.ANALYSIS_TYPE) - GetSampleRank(elA.SAMPLE_TYPE, false, fields.ANALYSIS_TYPE)) );
      // console.log(fields);// alert('SUCCESS!! :-)\n\n' + JSON.stringify(fields, null, 4));
      
      if(fields['JSON_URI'].length > 0) fields['SOURCE_FILE_STATUS'] = 1;

      Auth.currentSession().then(data => {
        let id_token = data.getIdToken().getJwtToken();
        // const url_to_fetch = ENDPOINT_BASE+`add_edit_analysis?caseid=${caseID.toUpperCase()}&s3path=xxxx${s3path}`;
        // const url_to_fetch = ENDPOINT_BASE+`add_edit_analysis?caseid=CD200123&s3path=s3://nch-igm-research-rare-disease/2021/CD200123/churchill/2021-02-01/varhouse/2021-02-03T14-00-21/parquet/CD200123.parquet`;
        // console.log(url_to_fetch);
        const url_to_send_to = `${ENDPOINT_BASE}add_edit_analysis?project=${props.project}`;
      
        toast.promise(
          sendAnalysisData(url_to_send_to, fields, id_token),
          {
            loading: 'Saving...',
            success: (data) => <>Successfully saved<br/>{data}</>,
            //  success: <b>Settings saved!</b>,
            error: (err) => `Error: ${err}`,
            //  error: <b>Could not save.</b>,
          },{
            success: {
              duration: 5000,
            },
          }
        );
      })
      .catch( e => setErrorLog([`Error in saving analysis: ${e}`, '']));
    }

    function sendAnalysisData(url_to_send_to, fields, id_token) {
      return new Promise(function (resolve, reject) {
        if (request) {
          request.abort();
        }
        let xhReq = new XMLHttpRequest();
        request = xhReq;
  
        // xhReq.addEventListener("progress", (oEvent) => {
        //   // progress on transfers from the server to the client (downloads)
        //   if (oEvent.lengthComputable) {
        //     let percentComplete = Math.round(oEvent.loaded / oEvent.total * 90);
        //     updateCaseLoadingProgressBar(`Downloading data for ${caseAnalysisName}... (${(oEvent.loaded/1000000).toFixed(1)} MB of ${(oEvent.total/1000000).toFixed(1)} MB)`, percentComplete);
        //   } else {
        //     updateCaseLoadingProgressBar(`Downloading data for ${caseAnalysisName} (unknown size)`, 50);
        //     toast.error('Unable to compute progress information since the total size is unknown');
        //   }
        // });

        // get a callback when the server responds
        xhReq.addEventListener("load", (oEvent) => {
          if (xhReq.status===200) {
            // console.log(xhReq.responseText);
            // toast.success(xhReq.responseText);
            // showAlert(xhReq.responseText, 0, true, 'Success!');
            // showDbOverview();
            loadVaNexDb();
            history.push(`/${props.projectBaseURL}/${params.caseId}`);
            resolve(xhReq.responseText);
          }
          else {
            setErrorLog([xhReq.responseText,'']);
            reject();
          }
        });

        // TODO: handle error in these:
        xhReq.addEventListener("error", () => {  reject("An error occurred while transferring the file"); });
        xhReq.addEventListener("abort", () => { reject("Transfer has been canceled by the user"); });
        // xhReq.addEventListener("error", () => {  setErrorLog(['An error occurred while transferring the data','']);  });
        // xhReq.addEventListener("abort", () => { setErrorLog(['Transfer has been canceled by the user', '']);   });
        // xhReq.addEventListener("loadend",() => { setErrorLog(['Transfer finished (succeeded or not?!)'], '');   });
        // xhReq.addEventListener("loadstart",() => { console.error('Transfer started!');   });
        
        xhReq.open("POST", url_to_send_to, true);
        // xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded; charset=UTF-8");
        xhReq.setRequestHeader('Content-Type', 'application/json');
        xhReq.setRequestHeader('Accept', 'application/json');
        xhReq.setRequestHeader('Authorization','Bearer ' + id_token);

        // console.log('----');
        // console.log(fields);
        xhReq.send(JSON.stringify(fields));
  
      });
    }

    function onNumOfSamplesChange(e, field, values, setValues) {
      // update dynamic form
      const SAMPLES = [...values.SAMPLES];
      const numOfSamples = e.target.value || 0;
      const previousNumber = parseInt(field.value || '0');
      // console.log(e.target.value, '-', field.value,'-',previousNumber, '-',numOfSamples);
      if (previousNumber < numOfSamples) {
        for (let i = previousNumber; i < numOfSamples; i++) {
          SAMPLES.push({ SAMPLE_ID: '', SAMPLE_TYPE: '', FILE_URI: '' });
          // SAMPLES.push({ SAMPLE_ID: '', SAMPLE_TYPE: '', SEX: '', AGE: '', AFFECTED: false, PHENOTYPE: '', CNV_URI: '', SV_URI: '', RNASEQ_URI: '' });
        }
      } else {
        for (let i = previousNumber; i >= numOfSamples; i--) {
          SAMPLES.splice(i, 1);
        }
      }
      setValues({ ...values, SAMPLES });

      // call formik onChange method
      field.onChange(e);
    }
    
    function updateSampleFromParquet( fieldValues, setValues) {
    
      // ? Using fetch
      // Auth.currentSession().then(data => {
      //   let id_token = data.getIdToken().getJwtToken();
      //   fetch(ENDPOINT_BASE+`add_new_case`, {
      //     method: 'GET',
      //     mode: 'cors',
      //     headers: {
      //       'Authorization': id_token
      //     }
      //   })
      //   .then(result => result.json())
      //   .then(result_json => {
      //     console.log((result_json));        
      //   }).catch(e => setErrorLog(["Failed to fetch data.", e]));
      // });
  
      
      // console.log(fieldValues); // .PARQUET_URI
      fieldValues['updateSamplesFromParquet'] = true;
      setUpdatingNewAnalysisSamples(true);
  
      Auth.currentSession().then(data => {
        let id_token = data.getIdToken().getJwtToken();
        const url_to_send_to = `${ENDPOINT_BASE}add_new_case?project=${props.project}`
  
        let xhReq = new XMLHttpRequest();
        // get a callback when the server responds
        xhReq.addEventListener("load", (oEvent) => {
          setUpdatingNewAnalysisSamples(false);
          // console.log(xhReq.responseText);
          let fetchedSamplesData = parse_JSONL(xhReq.responseText);
          // console.log(fetchedSamplesData);
          // console.log(typeof fetchedSamplesData[0]);
          if(!!fetchedSamplesData && !!fetchedSamplesData[0] && typeof(fetchedSamplesData[0])==='object'){
            // * since we don't know the analysis type yet (user can change it) there is no need to sort // fetchedSamplesData[0].sort( (elA,elB) => (GetSampleRank(elB.SAMPLE_TYPE, false, elB.ANALYSIS_TYPE) - GetSampleRank(elA.SAMPLE_TYPE, false, elA.ANALYSIS_TYPE)) );
            fetchedSamplesData[0].sort( (elA,elB) => (GetSampleRank(elB.SAMPLE_TYPE, false) - GetSampleRank(elA.SAMPLE_TYPE, false)) );
          }
          // if (request.readyState === 4) {  // ! ----------
          //   alert(request.responseText);
          // }
          // console.log(xhReq.status);
          if (xhReq.status===200) {
            let SAMPLES = [];
            // for (let i = 0; i < 2; i++) {}
            fetchedSamplesData[0].forEach(element => {
              // SAMPLES.push({ sampleId: element['COLUMN_ID'], sampleType: element['TYPE'], affected: false, sex: '', age: '', phenotype: '', cnvUri: '', svUri: '', rnaSeqUri: '' });
              // SAMPLES.push({ SAMPLE_ID: element['SAMPLE_ID'], SAMPLE_TYPE: element['SAMPLE_TYPE'], SEX: undefined, AGE: '', AFFECTED: false, PHENOTYPE: '', CNV_URI: '', SV_URI: '', RNASEQ_URI: '' });
              SAMPLES.push({ SAMPLE_ID: element['SAMPLE_ID'] || '', SAMPLE_TYPE: element['SAMPLE_TYPE'] || '', FILE_URI: element['FILE_URI'] || ''});
            });
            let N_SAMPLES = SAMPLES.length;
            // let tmpFieldValues = { ...fieldValues, N_SAMPLES, SAMPLES }
            // delete tmpFieldValues['updateSamplesFromParquet'];
            // setValues(tmpFieldValues);
            setValues({ ...fieldValues, N_SAMPLES, SAMPLES }); // setValues({ ...fieldValues, N_SAMPLES:N_SAMPLES, SAMPLES:SAMPLES }); 
            toast.success("Samples are updated!");
            // showAlert("Samples are updated!", 0, true, 'Success!');
          }
          else {
            setErrorLog([xhReq.responseText,'']);
          }
        });
  
        // TODO: handle error in these:
        xhReq.addEventListener("error", () => { setUpdatingNewAnalysisSamples(false); setErrorLog(['An error occurred while transferring the data','']);  });
        // xhReq.addEventListener("abort", () => { setUpdatingNewAnalysisSamples(false); setErrorLog(['Transfer has been canceled by the user', '']);   });
        // xhReq.addEventListener("error", () => { setUpdatingNewAnalysisSamples(false); console.error(['An error occurred while transferring the data','']);  });
        xhReq.addEventListener("abort", () => { setUpdatingNewAnalysisSamples(false); console.error(['Transfer has been canceled by the user', '']);   });
        // xhReq.addEventListener("loadstart",() => { setUpdatingNewAnalysisSamples(true);  });
        // xhReq.addEventListener("loadend",() => { setUpdatingNewAnalysisSamples(false); setErrorLog(['Transfer finished (succeeded or not?!)'], '');   });
  
        xhReq.open("POST", url_to_send_to, true);
        // xhReq.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
        // xhReq.setRequestHeader('x-access-token', id_token);
        // xhReq.withCredentials = true;
        xhReq.setRequestHeader('Content-Type', 'application/json');
        xhReq.setRequestHeader('Accept', 'application/json');
        xhReq.setRequestHeader('Authorization','Bearer ' + id_token);
  
        // console.log(fieldValues);
        xhReq.send(JSON.stringify(fieldValues));
      });
    }

    function analysisDetailsForm(errors, values, touched, setValues, title='Add a New Analysis'){ //selectedAnalysisType
      
      return(
        <Form>
          <div className="card m-3 fs-6" style={{minWidth:'50rem'}}>
            <div className="card-header bg-lightsteel-blue py-1 d-flex align-items-center ">
              <div className=" text-center flex-grow-1 fs-4">{title}</div>
              <button type="button" className="btn-close" aria-label="Close" onClick={() => history.push(`/${props.projectBaseURL}/${params.caseId}`)}></button>
            </div>
            <div className="card-body border-bottom">
              <div className="row">
                <div className="form-group col-5">
                  <label className="mx-2">Analysis Name</label>
                  <Field name="ANALYSIS_NAME" className="form-control" type="text" placeholder="Enter a name" aria-label="Analysis Name"/>
                  <ErrorMessage name="ANALYSIS_NAME" component="div" className="text-danger" />
                </div>

                <div className="form-group col-5">
                  <label className="mx-2">Analysis Type</label>
                  <Field name="ANALYSIS_TYPE">
                    {({ field }) => (
                      <Select className="w-100"
                        // TODO: check the next line if we need it
                        defaultValue={AnalysisTypeOptions.find(t => t['value']===values.ANALYSIS_TYPE)}
                        onChange={ selectedOption => {
                          if(renderAnalysisProps.mode === 'add'){
                            if(selectedOption.value==='CNV')
                              setValues({ ...values, ANALYSIS_ID: `${values.ANALYSIS_NAME_SUFFIX}_${selectedOption.value}`, ANALYSIS_NAME:`${values.ANALYSIS_NAME_SUFFIX.split('T')[0]}`, ANALYSIS_TYPE: selectedOption.value});
                              // setValues({ ...values, SOURCE_FILE_STATUS: 1, ANALYSIS_ID: `${values.ANALYSIS_NAME_SUFFIX}_${selectedOption.value}`, ANALYSIS_NAME:`${values.ANALYSIS_NAME_SUFFIX.split('T')[0]}`, ANALYSIS_TYPE: selectedOption.value});
                              // TODO
                              //! fix this: it seems that we need to use this line instead: setValues({ ...values, SOURCE_FILE_STATUS: 1, ANALYSIS_TYPE: selectedOption.value});
                            else
                              setValues({ ...values, ANALYSIS_ID: `${values.ANALYSIS_NAME_SUFFIX}_${selectedOption.value}`, ANALYSIS_NAME:`${values.ANALYSIS_NAME_SUFFIX.split('T')[0]}`, ANALYSIS_TYPE: selectedOption.value});
                              // TODO
                              //! fix this: it seems that we need to use this line instead: setValues({ ...values, ANALYSIS_TYPE: selectedOption.value});
                          } else {
                            setValues({ ...values, ANALYSIS_TYPE: selectedOption.value});
                          }
                        }}
                        options={AnalysisTypeOptions}
                        placeholder='Select Analysis'
                      />
                    )}
                  </Field>
                  
                </div>
               
                {(!devOptions)?
                  <div className="form-group col-2">
                    <label className="">Reference</label>
                    <Field name="V_REF" className="form-control-plaintext" type="text" placeholder="Reference" aria-label="Reference" value="GRCh38" readOnly />
                  </div>
                :
                  <div className="form-group col-2">
                    <label className="">Status</label>
                    <Field name="SOURCE_FILE_STATUS" className="form-control" type="number" placeholder="Status" aria-label="Status" />
                  </div>
                }
                {/* <div className="col-2 d-flex flex-row">
                  <div className="form-group">
                    <label className="">Reference</label>
                    <Field name="V_REF" className="form-control-plaintext" type="text" placeholder="Reference" aria-label="Reference" defaultValue="GRCh38" readOnly />
                  </div>
                  {(devOptions)?
                    <div className="form-group ms-2" style={{minWidth:'4rem'}}>
                      <label className="">Status</label>
                      <Field name="SOURCE_FILE_STATUS" className="form-control" type="number" placeholder="Status" aria-label="Status" />
                    </div>
                  : null }
                </div> */}

              </div>
              {(devOptions)?
                <div className="row">
                  <div className="form-group my-3">
                    <label className="mx-2">JSON Data S3 URI</label>
                    <Field name="JSON_URI" className="form-control" type="text"
                      onBlur={() => setValues({ ...values, JSON_URI: values.JSON_URI.trim().replace(/\/$/,"") }) } //* trim spaces and remove the last '/'
                      placeholder="e.g. s3://nch-igm-xx/xx/churchill/xx/varhouse/xx/parquet/xxxx.json.gz" aria-label="Parquet URI"/>
                  </div>
                </div>
              : <></>}
              <div className="row">
                {/* <div className="form-floating my-3"> */}
                <div className="form-group mb-3">
                  <label className="mx-2">Parquet Data S3 URI</label>
                  <Field name="PARQUET_URI" className="form-control" type="text"
                    onBlur={() => setValues({ ...values, PARQUET_URI: values.PARQUET_URI.trim().replace(/\/$/,"") }) } //* trim spaces and remove the last '/'
                    placeholder="e.g. s3://nch-igm-xx/xx/churchill/xx/varhouse/xx/parquet/xxxx.parquet" aria-label="Parquet URI"/>
                  {/* <label className="mx-2">Parquet Data S3 URI (e.g. s3://nch-igm-xx/xx/churchill/xx/varhouse/xx/parquet/xxxx.parquet)</label> */}
                </div>
              </div>
  
              <div className="row d-flex flex-column align-items-center">
                <div className="input-group" style={{maxWidth:'27rem', zIndex:'0'}}>
                {/* <div className="input-group" style={{maxWidth:'37rem', zIndex:'0'}}> */}
                  <button className="btn btn-success mx-3 fw-bold" disabled={updatingNewAnalysisSamples} onClick={() => updateSampleFromParquet(values, setValues)}>
                    {(updatingNewAnalysisSamples) ? <span className="mx-5 my-0 spinner-border spinner-border-sm" role="status" aria-hidden="true"> </span> : "Update Samples"}
                  </button>
                  <span className="input-group-text">Number of Samples</span>
                  <Field name="N_SAMPLES">
                    {({ field }) => (
                      <input {...field} className="form-control" type="number" min="0" step="1"
                      onChange={e => onNumOfSamplesChange(e, field, values, setValues)} />
                    )}
                  </Field>
                  {/* <button className="btn btn-secondary mx-3 fw-bold"
                    disabled={values.SAMPLES.length < 2} 
                    onClick={() => values.SAMPLES.sort( (elA,elB) => (GetSampleRank(elB.SAMPLE_TYPE, false, values.ANALYSIS_TYPE) - GetSampleRank(elA.SAMPLE_TYPE, false, values.ANALYSIS_TYPE)) )}>
                    Sort Samples by Label
                  </button> */}
                  <ErrorMessage name="N_SAMPLES" component="div" className="invalid-feedback" />
                </div>
              </div>
              <FieldArray name="SAMPLES">
              {() => (values.SAMPLES.map((sample, i) => {
                // const sampleErrors = errors.samples?.length && errors.samples[i] || {};
                // const sampleTouched = touched.samples?.length && touched.samples[i] || {};

                let fileUriPlaceholder = "e.g. s3://nch-igm-xx/xx/churchill/xx/alignment/BAMs/xxxx.bam";
                let fileUriLabel = "Bam File URI"
                // if(values.ANALYSIS_TYPE==='CNV'){
                //   fileUriLabel = "Source Folder URI"
                //   fileUriPlaceholder = "e.g. s3://nch-igm-xx/xx/churchill/xx/cnvloh/RDxxx_P_xxx";
                // }
                // if(values.ANALYSIS_TYPE==='SV'){
                //   fileUriPlaceholder = "e.g. s3://nch-igm-xx/xx/churchill/xx/sv/xx.Manta.vcf";
                //   fileUriLabel = "Source File URI"
                // }

                return (
                  <div className="row py-2 px-1" key={i} >
                    <div className="list-group list-group-flush border border-secondary border-1 pb-2">
                      <div className="list-group-item">
                        <h5 className="card-title">Sample {i + 1}</h5>
                        <div className="row">
                          <div className="form-group col-6">
                            <label className="mx-2">Sample ID</label>
                            <Field name={`SAMPLES.${i}.SAMPLE_ID`} className="form-control" type="text" placeholder="" aria-label=""/>
                            <ErrorMessage name={`SAMPLES.${i}.SAMPLE_ID`} component="div" className="text-danger" />
                          </div>
                          <div className="form-group col-6">
                            <label className="mx-2">Label (Proband, Mother, etc.)</label>
                            <Field name={`SAMPLES.${i}.SAMPLE_TYPE`} className="form-control" type="text" placeholder="Proband, Mother, Father, etc." aria-label=""/>
                            <ErrorMessage name={`SAMPLES.${i}.SAMPLE_TYPE`} component="div" className="text-danger" />
                          </div>
                        </div>
                        <div className="row mt-2">
                          <div className="form-group">
                            <label className="mx-2">{fileUriLabel}</label>
                            <Field name={`SAMPLES.${i}.FILE_URI`} className="form-control" type="text" 
                              onBlur={() => setValues({...values, SAMPLES: values.SAMPLES.map( (smp, ind) => (  (ind===i) ? {...smp, FILE_URI: smp.FILE_URI.trim().replace(/\/$/,"") } : smp ) )}) } //* trim spaces and remove the last '/'
                              placeholder={fileUriPlaceholder} aria-label="" />
                            <ErrorMessage name={`SAMPLES.${i}.FILE_URI`} component="div" className="text-danger" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              }))}
              </FieldArray>
              <div className="row my-2">
                <div className="form-group">
                  <label className="mx-2">Note</label>
                  <Field component="textarea" name="ANALYSIS_NOTE" className="form-control" rows="4" placeholder="..."/>
                </div>
              </div>
            </div>
            <div className="card-footer text-center border-top-0">
              <button className="btn btn-md btn-primary m-2 px-4 py-2" type="submit" disabled={!isSubmitEnable}><i className="fas fa-user-plus me-2"></i>Save</button>
              <button className="btn btn-secondary mr-1" type="reset">Reset</button>
            </div>
          </div>
        </Form>
      );
    }
    
    if(renderAnalysisProps.mode === 'add'){
      let currentCase = Object.values(projectDb).find( t => t.CASE_ID===params.caseId);
      let currentAnalysis;
      let initialAnalysisValues;
      if(!!currentCase && !!currentCase.ANALYSES ) 
        currentAnalysis = Object.values(currentCase.ANALYSES).find( t => t.ANALYSIS_TYPE==='SNV');
        console.log('currentAnalysis',currentAnalysis)
      if(currentAnalysis !== undefined){
        initialAnalysisValues = {...structuredClone(currentAnalysis), CASE_ID:params.caseId };
      }
      let addNewAnalysisFormFields = {
        CASE_ID: '',
        ANALYSIS_ID: (new Date().toISOString().split('.')[0]).replaceAll(':','-'),
        ANALYSIS_NAME: (new Date().toISOString().split('T')[0]),
        ANALYSIS_NAME_SUFFIX: (new Date().toISOString().split('.')[0]).replaceAll(':','-'),
        ANALYSIS_TYPE: 'SNV',
        ANALYSIS_NOTE: '',
        SOURCE_FILE_STATUS: 0,
        JSON_URI: '',
        PARQUET_URI: initialAnalysisValues?.PARQUET_URI || [],
        V_REF: 'GRCh38',
        N_PARQUET_VARIANTS: 0,
        N_VARIANTS: 0,
        N_GENES: 0,
        N_SAMPLES: initialAnalysisValues?.N_SAMPLES || [],
        SAMPLES: initialAnalysisValues?.SAMPLES || []
        // samples: [{SAMPLE_ID: '', SAMPLE_TYPE: '', BAM_URI: '', CNV_URI: '', SV_URI: ''}]
      }
      return(
        <div className="bg-grey-lightest show-overflow absolute-panel d-flex flex-column align-items-center mt-5">
          <Formik initialValues={ {...addNewAnalysisFormFields, CASE_ID: `${params.caseId}`} }  onSubmit={handleAddEditNewAnalysisForm}>
            {({ errors, values, touched, setValues }) => analysisDetailsForm(errors, values, touched, setValues, `New Analysis of ${params.caseId}`)}
          </Formik>
        </div>
      );
    } else {
      
      if(isLoadingCaseList){
        return(
          <div className="bg-grey-lightest show-overflow absolute-panel d-flex flex-column align-items-center pt-5">
            <div className="my-5">
              <span className="mx-3 spinner-border" role="status" aria-hidden="true"></span>
              <span className="fs-3">Loading...</span>
            </div>
          </div>
        );
      }

      let currentCase = Object.values(projectDb).find( t => t.CASE_ID===params.caseId);
      let currentAnalysis;
      if(!!currentCase && !!currentCase.ANALYSES ) 
        currentAnalysis = Object.values(currentCase.ANALYSES).find( t => t.ANALYSIS_ID===params.analysisId);
      if(currentAnalysis !== undefined){
        // console.log(currentAnalysis);
        // const initialValues = {...JSON.parse(JSON.stringify(currentAnalysis)), CASE_ID:params.caseId };
        const initialAnalysisValues = {...structuredClone(currentAnalysis), CASE_ID:params.caseId };
        console.log(initialAnalysisValues)
        return(
          <div className="bg-grey-lightest show-overflow absolute-panel d-flex flex-column align-items-center mt-5">
            <Formik initialValues={initialAnalysisValues } onSubmit={handleAddEditNewAnalysisForm}>
              {({ errors, values, touched, setValues }) => analysisDetailsForm(errors, values, touched, setValues, `Edit ${params.caseId}::${params.analysisId}`)}
            </Formik>
          </div>
        );
      } else {
        return(
          <div className="bg-grey-lightest show-overflow absolute-panel d-flex flex-column align-items-center mt-5">
            <h2 className="my-4">"{params.caseId}::{params.analysisId}" Not Found</h2>
          </div>
        );
      }
    }
  }




  //? --------------------------------------------- Search Result Renders ----------------------------------
  

  function RenderSearchResult(){
    // ! fix this, setSortBy , initialSortBy, setHiddenColumnsIds and more should only change search data!
    return(
      <div className="bg-grey-lightest show-overflow absolute-panel d-flex flex-column">
        {(!!searchResultToShowAsTable.data && searchResultToShowAsTable.data.length > 0)
          ?
          <>
            <div className="flex-grow-1 m-0 mt-2 fs-5 text-center">{(searchResultToShowAsTable.numberOfResults===0) ? ` No records found for '${searchResultToShowAsTable.query}'.` : null} &nbsp;</div>
            <div className="search-result-variant-panel m-4">
              {/* <div className="search-result-variant-panel extra-margin"> */}
              {/* <h5 className="mb-2">{"Search Results for '"+searchResultToShowAsTable.query+"'"}</h5> */}
              <VariantViewer
                onlyShowOneTab={true}
                oneTabTitle={`Search Results for '${searchResultToShowAsTable.query}' (${searchResultToShowAsTable.numberOfResults} ${(searchResultToShowAsTable.numberOfResults> 1) ? " records" : " record"} found)`}
                defaultFilterSet={0}
                initialSortBy={initialSortBy}
                setSortBy={() => console.log('setSortBy!')}
                // * add if we want to be able to edit search results: updateVariantTableData={() => console.log('updateVariantTableData!')}
                searchBoxValue={searchBoxValue}
                devOptions={devOptions}
                caseData={searchResultToShowAsTable.data}
              />
              {/* </div> */}
            </div>
            </>
          :
            <div className="text-center mx-2 my-4 d-flex flex-column align-items-center justify-content-center">
              {(isLoadingSearchResult)
              ?
                <>
                <h4  className="mb-2">Searching {selectedSearchType} for "{searchTermUsed}"</h4>
                <span>
                  {(selectedSearchType ==='ClinVar Plots') ?  <i className="far fa-image px-3 fs-1"></i> : <i className="far fa-list-alt px-3 fs-1"></i>}
                  <span className="mx-2 mt-3 spinner-border" role="status" aria-hidden="true"> </span>
                </span>
                </>
              :
                (searchErrorMessage.length > 0)
                ?
                  <div className="container-fluid mb-2 mt-4" > <h4>{searchErrorMessage}</h4> </div>
                :

                (clinVarPlotSrc)
                ?
                  <>
                  <h4  className="mb-2">Result for "{searchTermUsed}"</h4>
                  <div id="img-holder mb-2 mt-4">
                    {/* <span id="clinvarMask" tabIndex="1"></span> */}
                    {/* <img id="clinvarPic" tabIndex="2" className="clinvarplot" src={variant.ClinVarPlot} alt="ClinVar Plot" /> */}
                    {/* <img tabIndex="2" className="clinvarplot" src={variant.ClinVarPlot} alt="ClinVar Plot" /> */}
                    <img tabIndex="2" className="clinvarplot" src={clinVarPlotSrc} alt="ClinVar Plot" />
                  </div>
                  </>
                : null }
            </div>
        }
      </div>
    );
  }

  // const [caseIdSearchValue, setCaseIdSearchValue] = useState('');
  // const [filteredCaseIdList, setFilteredCaseIdList] = useState([]);
  // useEffect(() => {
  //   if(!!caseIdSearchValue){
  //     setFilteredCaseIdList( Object.values(projectDb).filter(z => {
  //       if(caseIdSearchValue!==undefined && caseIdSearchValue!==null && caseIdSearchValue.trim() !== ''){ //(caseIdSearchValue.length>0){
  //         return(String(z.CASE_ID).toLowerCase().includes(caseIdSearchValue.toLowerCase()));
  //       } else { 
  //         return(true)
  //       }
  //     }));
  //   }
  //   else {
  //     setFilteredCaseIdList(Object.values(projectDb))
  //   }
  // }, [caseIdSearchValue])
  
  function RenderCaseList(){
    return(
      <div className="collapse show" id="cases-collapse">
        <ul className="btn-toggle-nav list-unstyled fw-normal pb-1 cases-list">
        {
        (isLoadingCaseList)
        ?
          <li>
            <div className="mx-3 mt-3">
              <span className="mx-2 spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              Loading...
            </div>
          </li>
        :
          <>
            { 
              // filteredCaseIdList.map((element, index) => {
              Object.values(projectDb).map((element, index) => {
              let caseId = element.CASE_ID
              let AnalysisDateState = getAnalysisDate(element)
              // console.log(AnalysisDateState)
              let iconClassName = "";
              // if (analysisDateAge <= 100) {
                //     AnalysisDateState = 2; // Equivalent to "green-mid" (most recent)
                //   } else if (analysisDateAge <= 180) {
                //     AnalysisDateState = 3; // Equivalent to "dark-orange" 
                //   } else if (analysisDateAge <= 195) {
                //     AnalysisDateState = 4; // Equivalent to "mid-red" (warning threshold)
                //   } else {
                //     AnalysisDateState = 1; // Equivalent to "text-dblue" (move to Glacier)
                //   }
                // } else {
                //   AnalysisDateState = 0; // No analyses or invalid date, equivalent to "ps-4"
                // }
              if (AnalysisDateState === null) {
                iconClassName = "grey-lighter"; // No analyses or invalid date, equivalent to "ps-4"
              } else if (AnalysisDateState <= 100) {
                iconClassName = "green-mid"; // Equivalent to "green-mid" (most recent)
              } else if (AnalysisDateState <= 180) {
                iconClassName = "darker-orange"; // Equivalent to "dark-orange" 
              } else if (AnalysisDateState <=195) {
                iconClassName = "red-dark"; // Equivalent to "mid-red" (warning threshold)
              } else if (AnalysisDateState >195){
                iconClassName = "blue-light"; // Equivalent to "text-dblue" (move to Glacier)
              } 

              return (
                <li key={index} className={"p-1 ps-2 m-2 "+ ((caseId === activeCaseId) && " active-case" )}
                  onClick={ () => {if (true) {showActiveCaseCardInfo(caseId)}}}>
                  {(caseId === activeCaseId) ? <span ref={markedActiveCaseRef}/> : null}
                  {( element.STAR === 1 ? <i className="fas fa-star text-primary pe-2"></i> :  ( element.STAR=== 2 ? <i className="fas fa-star green-light pe-2"></i> : (element.STAR=== 5 ? <i className="fas fa-star red-mid pe-2"></i> : <span className="ps-4"></span>)) )}
                  {<i className={`fas fa-snowflake ${iconClassName}`} style={{transform: "translateX(-9px) translateY(-7px)",fontSize: "11px"}} ></i>}
                  {caseId}
                  {(openCases.find(t => t[0].split('::')[0]===caseId) !== undefined ? <span className="badge case-badge loaded-case"> <i className="fas fa-users-cog fs-6 pe-2 text-dark"></i></span>  : null)}
                </li>
              )
            })
            }
          </>
        }
      </ul>
    </div>
    );
  }

  function showPreviousSearchResultOf(searchHistoryIndex){    
    setIsLoadingSearchResult(false);
    setSearchErrorMessage('');
    setSearchResultToShowAsTable(searchHistory[searchHistoryIndex]);
    setIsSearchResultReady(true);
    showSearchResult();
  }

  function RenderSearchHistory(){
    if(searchHistory.length >0 ){
      return(
        <div className="collapse show" id="analysis-collapse">
          <ul className="btn-toggle-nav list-unstyled fw-normal pb-1 small cases-list">
            {Object.values(searchHistory).map((element, index) => {
              return (
                <li key={index} className="p-1 me-2 cursor-pointer"
                onClick={ () => showPreviousSearchResultOf(index)}
                >{element.query}: ({element.numberOfResults}) [{element.name}]</li>
              );
              })}
          </ul>
        </div> 
      );
    }
  }

  // function updateCaseTableDataFunction(prevRowValues, columnId, newValue) {
  //   if(!!props.updateVariantTableData){ 
  //     setShouldBlockNavigation(true);
  //     props.updateVariantTableData(variantIndex, columnId, value);
  //   } else {toast.error('Cannot update this value!')}
  //   if(isAutoSavingNotes && (autoSaveNotesCounter < autoSaveNotesInterval) ){
  //     setAutoSaveNotesCounter(autoSaveNotesCounter + 1);
  //   }
  // }

  function updateCaseTableDataFunction(prevRowValues, columnId, newValue) {

    setProjectDb(prevProjectDb =>  
      prevProjectDb.map( caseData => (caseData.ID === prevRowValues.ID ? {...caseData, [columnId]:newValue} : caseData)))

    function revertChanges(){
      setProjectDb(prevProjectDb =>  
        prevProjectDb.map( caseData => (caseData.ID === prevRowValues.ID ? {...caseData, [columnId]:initialValue} : caseData)))
    }

    if(!(props.isPowerUser || props.isAdmin)){
      revertChanges();
      toast.error('Permission Denied.');
      return;
    }
    
    // debugger;
    // let updated_row Object.values(projectDb).filter(t => t.ID===rowID));
    // console.log(rowID, columnId, value)
    // console.log(projectDb[rowID-1]["CASE_ID"]);
    // console.log(projectDb[rowID-1][columnId]);
    const initialValue = prevRowValues[columnId];
    prevRowValues[columnId]=newValue;
    prevRowValues['updateSamplesFromParquet'] = false;
    // delete prevRowValues['MRPHENE_SUBJECT_ID']
    // console.log(initialValue);
    // console.log(newValue);
    // console.log(prevRowValues);
    // console.log(fields);// alert('SUCCESS!! :-)\n\n' + JSON.stringify(fields, null, 4));

    setCaseTableSaveMessage("Updating "+ prevRowValues.CASE_ID + "...");

    //! we are sending the whole row in each update.
    //! this method needs to get redone in the right way. this is not the best way, it is just a quick way to get things done!

    Auth.currentSession().then(data => {
      let id_token = data.getIdToken().getJwtToken();
      // const url_to_fetch = ENDPOINT_BASE+`add_new_case?caseid=${caseID.toUpperCase()}&s3path=xxxx${s3path}`;
      // const url_to_fetch = ENDPOINT_BASE+`add_new_case?caseid=CD200123&s3path=s3://nch-igm-research-rare-disease/2021/CD200123/churchill/2021-02-01/varhouse/2021-02-03T14-00-21/parquet/CD200123.parquet`;
      // console.log(url_to_fetch);
      const url_to_send_to = `${ENDPOINT_BASE}add_new_case?project=${props.project}`


      // toast.promise(
      //   sendCaseInformation(url_to_send_to, prevRowValues, id_token),
      //   {
      //     loading: 'Saving...',
      //     success: (data) => <>Successfully saved<br/>{data}</>,
      //     //  success: <b>Settings saved!</b>,
      //     error: (err) => `Error: ${err}`,
      //     //  error: <b>Could not save.</b>,
      //   },{
      //     success: {
      //       duration: 5000,
      //     },
      //   }
      // );

      // if (request) {
      //   request.abort();
      // }
      let xhReq = new XMLHttpRequest();
      // request = xhReq;

      // xhReq.addEventListener("progress", (oEvent) => {
      //   // progress on transfers from the server to the client (downloads)
      //   if (oEvent.lengthComputable) {
      //     let percentComplete = Math.round(oEvent.loaded / oEvent.total * 90);
      //     updateCaseLoadingProgressBar(`Downloading data for ${caseAnalysisName}... (${(oEvent.loaded/1000000).toFixed(1)} MB of ${(oEvent.total/1000000).toFixed(1)} MB)`, percentComplete);
      //   } else {
      //     updateCaseLoadingProgressBar(`Downloading data for ${caseAnalysisName} (unknown size)`, 50);
      //     toast.error('Unable to compute progress information since the total size is unknown');
      //   }
      // });

      // get a callback when the server responds
      xhReq.addEventListener("load", (oEvent) => {
        if (xhReq.status===200) {
          // console.log(xhReq.responseText);
          // toast.success(xhReq.responseText);
          // showAlert(xhReq.responseText, 0, true, 'Success!');
          // showDbOverview();
          // loadVaNexDb();
          // history.push(`/${props.projectBaseURL}/${prevRowValues['CASE_ID']}`);

          // setCaseTableSaveMessage("Saved! ("+xhReq.responseText+")");
          setCaseTableSaveMessage(prevRowValues.CASE_ID + " updated (" + columnId + ")");
          // toast.success(xhReq.responseText);
        }
        else {
          revertChanges()
          toast.error(xhReq.responseText);
        }
      });

      // TODO: handle error in these:
      xhReq.addEventListener("error", () => { revertChanges(); toast.error("An error occurred while transferring the file"); });
      xhReq.addEventListener("abort", () => { toast.error("Transfer has been canceled by the user"); });
      // xhReq.addEventListener("error", () => {  setErrorLog(['An error occurred while transferring the data','']);  });
      // xhReq.addEventListener("abort", () => { setErrorLog(['Transfer has been canceled by the user', '']);   });
      // xhReq.addEventListener("loadend",() => { setErrorLog(['Transfer finished (succeeded or not?!)'], '');   });
      // xhReq.addEventListener("loadstart",() => { console.error('Transfer started!');   });
      
      xhReq.open("POST", url_to_send_to, true);
      // xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded; charset=UTF-8");
      xhReq.setRequestHeader('Content-Type', 'application/json');
      xhReq.setRequestHeader('Accept', 'application/json');
      xhReq.setRequestHeader('Authorization','Bearer ' + id_token);

      // console.log('----');
      // console.log(prevRowValues);
      xhReq.send(JSON.stringify(prevRowValues));
    })
    .catch( e => {
      revertChanges();
      setErrorLog([`Error in saving: ${e}`, ''])
    });


    // function sendCaseInformation(url_to_send_to, fields, id_token) {
    //   return new Promise(function (resolve, reject) {
    //     if (request) {
    //       request.abort();
    //     }
    //     let xhReq = new XMLHttpRequest();
    //     request = xhReq;
  
    //     // xhReq.addEventListener("progress", (oEvent) => {
    //     //   // progress on transfers from the server to the client (downloads)
    //     //   if (oEvent.lengthComputable) {
    //     //     let percentComplete = Math.round(oEvent.loaded / oEvent.total * 90);
    //     //     updateCaseLoadingProgressBar(`Downloading data for ${caseAnalysisName}... (${(oEvent.loaded/1000000).toFixed(1)} MB of ${(oEvent.total/1000000).toFixed(1)} MB)`, percentComplete);
    //     //   } else {
    //     //     updateCaseLoadingProgressBar(`Downloading data for ${caseAnalysisName} (unknown size)`, 50);
    //     //     toast.error('Unable to compute progress information since the total size is unknown');
    //     //   }
    //     // });

    //     // get a callback when the server responds
    //     xhReq.addEventListener("load", (oEvent) => {
    //       if (xhReq.status===200) {
    //         // console.log(xhReq.responseText);
    //         // toast.success(xhReq.responseText);
    //         // showAlert(xhReq.responseText, 0, true, 'Success!');
    //         // showDbOverview();
    //         // loadVaNexDb();
    //         // history.push(`/${props.projectBaseURL}/${fields['CASE_ID']}`);

    //         setProjectDb(prevProjectDb =>  
    //           prevProjectDb.map( caseData => (caseData.ID === prevRowValues.ID ? {...caseData, [columnId]:newValue} : caseData)))

              
    //         resolve(xhReq.responseText);
    //       }
    //       else {
    //         setErrorLog([xhReq.responseText,'']);
    //         reject();
    //       }
    //     });

    //     // TODO: handle error in these:
    //     xhReq.addEventListener("error", () => {  reject("An error occurred while transferring the file"); });
    //     xhReq.addEventListener("abort", () => { reject("Transfer has been canceled by the user"); });
    //     // xhReq.addEventListener("error", () => {  setErrorLog(['An error occurred while transferring the data','']);  });
    //     // xhReq.addEventListener("abort", () => { setErrorLog(['Transfer has been canceled by the user', '']);   });
    //     // xhReq.addEventListener("loadend",() => { setErrorLog(['Transfer finished (succeeded or not?!)'], '');   });
    //     // xhReq.addEventListener("loadstart",() => { console.error('Transfer started!');   });
        
    //     xhReq.open("POST", url_to_send_to, true);
    //     // xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded; charset=UTF-8");
    //     xhReq.setRequestHeader('Content-Type', 'application/json');
    //     xhReq.setRequestHeader('Accept', 'application/json');
    //     xhReq.setRequestHeader('Authorization','Bearer ' + id_token);

    //     // console.log('----');
    //     // console.log(fields);
    //     xhReq.send(JSON.stringify(fields));
    //   });
    // }

    

    // let currentCase = Object.values(projectDb).find( t => t.CASE_ID===params.caseId);
    // if(currentCase !== undefined){
    //   currentCase = JSON.parse(JSON.stringify(currentCase));
    //   currentCase['N_INDIVIDUALS'] = currentCase['INDIVIDUALS'].length || null;
    //   // console.log(currentCase);
    //   return(
    //     <div className="bg-grey-lightest show-overflow absolute-panel d-flex flex-column align-items-center mt-5">
    //       <Formik initialValues={currentCase} validationSchema={editCaseFormSchema} onSubmit={handleAddEditNewCaseForm}>
    //         {({ errors, values, touched, setValues }) => caseForm(errors, values, touched, setValues, `Edit ${params.caseId}`, true)}
    //       </Formik>
    //     </div>
    //   );
    // }
    // setActiveCaseInfo(Object.values(projectDb).find( t => t.CASE_ID===params.caseId ));

    // // console.log(variantIndex, columnId, value);
    // setOpenCases(prevOpenCases => prevOpenCases.map( (indvCase, index) => (index === activeCaseIndexInOpenCases ? 
    //   indvCase.map( (pieceOfCaseInfo, infoIndex) => (infoIndex === 1 ? 
    //     pieceOfCaseInfo.map( variantData => (variantData.ROW_INDEX === variantIndex ? {...variantData, [columnId]:value} : variantData))
    //     : pieceOfCaseInfo))
    // : indvCase)))
    // // setActiveCaseVariantData(prevActiveCaseVariantData => prevActiveCaseVariantData.map(currentVariant => (currentVariant.ROW_INDEX === variantIndex ? {...currentVariant, [columnId]:value} : currentVariant)))

  }

  // ? this was an attempt to preserve TagFilters but did not go as wanted it, so let's keep it disabled for now.
  // const [caseTableTagFilter, setCaseTableTagFilter] = useState([]);
  
  const RenderCaseInfo = (props) => {
    // const [caseTableTagFilter, setCaseTableTagFilter] = useState([]);
    // useEffect(() => {
    //   props.setCaseTableTagFilter(caseTableTagFilter);
    // }, [caseTableTagFilter])
    
    return(
      <div className="bg-grey-lightest show-overflow  d-flex flex-row justify-content-center " style={{position:"relative", height:"100%"}}>
        {/* <div>ss<img src='https://nch-igm-vanex-client.s3.us-east-2.amazonaws.com/ClinVarPlots/GRCH38-Varhouse/QARS1.ALL.png'/></div> */}
          { //? Show spinner when loading
          (isLoadingCaseList) ?
          <div className="m-5 p-4">
            <span className="mx-3 spinner-border spinner-border-lg" role="status" aria-hidden="true"></span><span className="fs-2">Loading...</span>
          </div>
          : 
            (Object.keys(projectDb).length===0)
            ?
              <div className="m-5 p-4"><h1>No Data</h1></div>
            : <>
              <div className="d-flex flex-column text-center absolute-panel px-3 mx-2">
                {/* <div className="container initial-view-width-lim p-4 mx-auto mb-3 mt-5 text-center text-light"> */}
                {/* <h1 className="display-4 fw-normal">Variant Ne<img src={logo} className="vanex-logo" alt="logo" />us<span className="initial-view-version">v {process.env.REACT_APP_VERSION}</span></h1> */}
                {/* <h1 className="display-4 fw-normal">Variant Nexus<span className="initial-view-version">v {process.env.REACT_APP_VERSION}</span></h1> */}

                <div className="m-0">&nbsp;{caseTableSaveMessage}</div>
                {/* //? Render RdDb As a Table */}
                <div className="shadow-lg mb-3">
                  <CaseTable className="case-table " 
                    // inputData={projectDb.filter(t => t.STAR).sort(t => t.STAR)} //Object.values(projectDb.filter
                    inputData={projectDb}
                    currentCaseId=""
                    caseClickAction={(e, showEditView) => showActiveCaseCardInfo(e.CASE_ID, showEditView)}
                    updateCaseTableData = {updateCaseTableDataFunction}
                    // updateCaseTableData = {(rowID, columnId, value) => { 
                    //   setProjectDb(prevProjectDb =>  
                    //     prevProjectDb.map( caseData => (caseData.ID === rowID ? {...caseData, [columnId]:value} : caseData)))
                    // }}
                    // caseTableTagFilter={props.caseTableTagFilter}
                    // setCaseTableTagFilter={e => props.setCaseTableTagFilter(e)}
                  />
                </div>

                {/* //? leaving some space below the content for the add_new_case button */}
                <div className="p-5"> </div>
              </div>
            </>}
            {/* //? Render add_new_case button */}
            {/* <div className="add-new-case flex-center" onClick={() => showAddNewCase()}><i className="fas fa-plus fa-2x"></i></div> */}
            {(props.isPowerUser || props.isAdmin) ? <div className="add-new-case flex-center" onClick={() => showAddNewCase()}><i className="fas fa-plus fa-2x"></i></div> : null}
            {/* <Link to="/rd/addNew" className="add-new-case flex-center" ><i className="fas fa-plus fa-2x"></i></Link> */}
        </div>
    );
  }


  function RenderCaseCard(){

    let params = useParams();
    // if(activeCaseId==='') setActiveCaseId(params.caseId); //! fix this in all of them, need to get the active caseID form the URL (useParams)
    // let caseInformation = Object.values(projectDb).find( t => t.CASE_ID===params.caseId );
    
    useEffect(() => {
      setActiveCaseId(params.caseId);
      // if(!!caseInformation && !activeCaseInfo) setActiveCaseInfo(caseInformation);
      // if(!activeCaseInfo || params.caseId !== activeCaseInfo['CASE_ID']){
      //   setActiveCaseInfo(Object.values(projectDb).find( t => t.CASE_ID===params.caseId ));
      // }

      setActiveCaseInfo(Object.values(projectDb).find( t => t.CASE_ID===params.caseId ));

      const node = markedActiveCaseRef.current;
      node && node.scrollIntoView({block: 'center', inline: 'center'});
      // node && node.scrollIntoView(false);
      // node && node.scrollIntoView({block: 'nearest', inline: "nearest"});
      // node && node.scrollIntoView({block: "start", behavior: 'smooth'});
    },[params.caseId]);

    return(
      <div className="bg-grey-lightest show-overflow absolute-panel d-flex flex-row justify-content-center">
        {/* <div>ss<img src='https://nch-igm-vanex-client.s3.us-east-2.amazonaws.com/ClinVarPlots/GRCH38-Varhouse/QARS1.ALL.png'/></div> */}
          {(isLoadingCaseData)
            ? 
            <div className="data-loading-panel justify-content-center">
              {/* <div className="flex-grow-1"></div> */}
              <div className="loading-message">
                {caseLoadingMessage}
                <div className="progress">
                  <div className="progress-bar progress-bar-striped" role="progressbar" style={{width:`${caseLoadingProgress}%`}} aria-valuenow={caseLoadingProgress} aria-valuemin="0" aria-valuemax="100">{caseLoadingProgress}%</div>
                </div>
              </div>
            </div>
            : ""
          }
          {
          (isLoadingCaseList)
          ?
            <div className="mx-3 my-5">
              <span className="mx-3 spinner-border" role="status" aria-hidden="true"></span>
              <span className="fs-3">Loading...</span>
            </div>
          :
            (!!activeCaseInfo && activeCaseInfo['CASE_ID']!==null && activeCaseInfo['CASE_ID']!==undefined)
            ? 
              <CaseInfoCard
                switchToAnalysis={switchToAnalysis}
                loadVaNexDb={loadVaNexDb}
                refreshAnalysisStatus={loadVaNexDb}
                project={props.project}
                projectBaseURL={props.projectBaseURL}
                isAdmin={props.isAdmin}
                devOptions={devOptions}
                caseInfo={ activeCaseInfo}
                caseID={params.caseId}
                loadMyNotes={loadMyNotes}
                loadExistingNotes={loadExistingNotes}
                isNoteScopeAllAnalysis={isNoteScopeAllAnalysis}
                reloadCaseData={reloadCaseData}
                steLoadMyNotes={steLoadMyNotes}
                setLoadExistingNotes={setLoadExistingNotes}
                setIsNoteScopeAllAnalysis={setIsNoteScopeAllAnalysis}
                setReloadCaseData={setReloadCaseData}
                hasMrPheneProfile={ (activeCaseInfo['MRPHENE_SUBJECT_ID'] !==undefined && activeCaseInfo['MRPHENE_SUBJECT_ID'] !== null) }
                callbackLoadingMrPheneSubjectData={callbackLoadingMrPheneSubjectData}
                // loadMrPheneSubjectData={(loadMrPheneSubjectData === null || loadMrPheneSubjectData === undefined) ? (activeCaseInfo['MRPHENE_SUBJECT_ID'] !==undefined && activeCaseInfo['MRPHENE_SUBJECT_ID'] !== null) : loadMrPheneSubjectData}
                loadMrPheneSubjectData={loadMrPheneSubjectData}
                setLoadMrPheneSubjectData={setLoadMrPheneSubjectData}
                openCases={openCases}
              />
            :
              <h3 className="m-4">{`No information found for '${params.caseId}'`}</h3>
          }
        </div>
    );
  }


  function getProbandPhenotypeList(){
    return(
      <>
        {(!!activeCaseInfo && !!activeCaseInfo.INDIVIDUALS)
        ? 
          Object.values(activeCaseInfo.INDIVIDUALS).filter(t => t.INDIVIDUAL_TYPE==='Proband').map((element, index) => 
            <div className="container d-flex flex-row flex-wrap ps-4 pb-2 pt-1 " key={index} >
            {/* <div className="container d-flex flex-row flex-wrap ps-4 text-dark show-overflow align-items-center" style={{maxHeight:'2rem'}}> */}
              <div className="me-1 fw-bold cursor-pointer" onClick={e => (pehnoSectionHeight<=2 ? setPehnoSectionHeight(5) : setPehnoSectionHeight(2))}>Proband ({element.SEX}) phenotype: </div>
              {element.PHENOTYPE.split(';').map((pheno, ind) => <div key={ind} className="mx-2 my-0 p-0"><i className="m-1 fas fa-caret-right"></i>{pheno}</div>)}
            </div>
          )
        : ''}
      </>
    );
  }

  function RenderAnalysisTabs(){

    let currentAnalysis;

    function renderSnvViewers() {
      return(
        <div className="search-result-variant-panel extra-margin">
          <VariantViewer
            onlyShowOneTab={false}
            project={props.projectBaseURL} // only used for gnomAD in RD
            userName={props.userName}
            // defaultFilterSet={projectFilterSet}
            // setPMFPrefix={projectSetPMFPrefix}
            initialSortBy={initialSortBy}
            setSortBy={(sortBy)=> setInitialSortBy(sortBy)}
            // selectedVariantTab={'TAB_CLINVAR'}
            // hiddenColumnsIds={analysisHiddenColumnsIds}
            // setHiddenColumnsIds={(hiddenColumnsIds)=> setAnalysisHiddenColumnsIds(hiddenColumnsIds)}
            // updateVariantTableData={(variantIndex, columnId, value) => setActiveCaseVariantData(prevActiveCaseVariantData => prevActiveCaseVariantData.map(currentVariant => (currentVariant.ROW_INDEX === variantIndex ? {...currentVariant, [columnId]:value} : currentVariant)))}
            // updateVariantTableData={(variantIndex, columnId, value) => {
            //   console.log(variantIndex, columnId, value);
            //   setActiveCaseVariantData(prevActiveCaseVariantData => prevActiveCaseVariantData.map(currentVariant => (currentVariant.ROW_INDEX === variantIndex ? {...currentVariant, [columnId]:value} : currentVariant)))
            // }}
            updateVariantTableData={(variantIndex, columnId, value) => {
              // console.log(variantIndex, columnId, value);
              setOpenCases(prevOpenCases => prevOpenCases.map( (indvCase, index) => (index === activeCaseIndexInOpenCases ? 
                indvCase.map( (pieceOfCaseInfo, infoIndex) => (infoIndex === 1 ? 
                  pieceOfCaseInfo.map( variantData => (variantData.ROW_INDEX === variantIndex ? {...variantData, [columnId]:value} : variantData))
                  : pieceOfCaseInfo))
              : indvCase)))
              // setActiveCaseVariantData(prevActiveCaseVariantData => prevActiveCaseVariantData.map(currentVariant => (currentVariant.ROW_INDEX === variantIndex ? {...currentVariant, [columnId]:value} : currentVariant)))
            }}
            setShouldBlockNavigation={e => setShouldBlockNavigation(e)}
            searchBoxValue={searchBoxValue}
            devOptions={devOptions}
            ////!!!!!  paradigmData={paradigmData}
            currentCaseInformation={activeCaseInfo}
            currentAnalysisInfo={activeAnalysis}
            // currentCaseNotes={activeCaseNotes}
            currentCaseNotes={openCases[activeCaseIndexInOpenCases][2] || []}
            // analysisStartedAt={openCases[activeCaseIndexInOpenCases][3] || new Date()}
            isLoadingNotes={isLoadingNotes}
            caseData={openCases[activeCaseIndexInOpenCases][1] || []}
          />
        </div>
      );
    }


    function renderMTViewers(){
      return(
        <div className="bottom-tab-panel mb-3 ">
          <MTViewer
            project={props.projectBaseURL} // only used for gnomAD in RD
            userName={props.userName}
            // defaultFilterSet={projectFilterSet}
            // setPMFPrefix={projectSetPMFPrefix}
            //!!! initialSortBy={initialSortBy}
            //!!! setSortBy={(sortBy)=> setInitialSortBy(sortBy)}
            // selectedVariantTab={'TAB_CLINVAR'}
            // hiddenColumnsIds={analysisHiddenColumnsIds}
            // setHiddenColumnsIds={(hiddenColumnsIds)=> setAnalysisHiddenColumnsIds(hiddenColumnsIds)}
            // updateVariantTableData={(variantIndex, columnId, value) => setActiveCaseVariantData(prevActiveCaseVariantData => prevActiveCaseVariantData.map(currentVariant => (currentVariant.ROW_INDEX === variantIndex ? {...currentVariant, [columnId]:value} : currentVariant)))}
            // updateVariantTableData={(variantIndex, columnId, value) => {
            //   console.log(variantIndex, columnId, value);
            //   setActiveCaseVariantData(prevActiveCaseVariantData => prevActiveCaseVariantData.map(currentVariant => (currentVariant.ROW_INDEX === variantIndex ? {...currentVariant, [columnId]:value} : currentVariant)))
            // }}
            updateVariantTableData={(variantIndex, columnId, value) => {
              // console.log(variantIndex, columnId, value);
              setOpenCases(prevOpenCases => prevOpenCases.map( (indvCase, index) => (index === activeCaseIndexInOpenCases ? 
                indvCase.map( (pieceOfCaseInfo, infoIndex) => (infoIndex === 1 ? 
                  pieceOfCaseInfo.map( variantData => (variantData.ROW_INDEX === variantIndex ? {...variantData, [columnId]:value} : variantData))
                  : pieceOfCaseInfo))
              : indvCase)))
              // setActiveCaseVariantData(prevActiveCaseVariantData => prevActiveCaseVariantData.map(currentVariant => (currentVariant.ROW_INDEX === variantIndex ? {...currentVariant, [columnId]:value} : currentVariant)))
            }}
            setShouldBlockNavigation={e => setShouldBlockNavigation(e)}
            searchBoxValue={searchBoxValue}
            devOptions={devOptions}
            currentCaseInformation={activeCaseInfo}
            currentAnalysisInfo={activeAnalysis}
            // currentCaseNotes={activeCaseNotes}
            currentCaseNotes={openCases[activeCaseIndexInOpenCases][2] || []}
            // analysisStartedAt={openCases[activeCaseIndexInOpenCases][3] || new Date()}
            isLoadingNotes={isLoadingNotes}
            caseData={openCases[activeCaseIndexInOpenCases][1] || []} //mergedCnvData
          />
          {/* <Tabs>
            <TabList>
              { Object.values(currentAnalysis.SAMPLES).map((element, index) => 
                <Tab key={index}><span>{element.SAMPLE_TYPE}</span></Tab> )}
            </TabList>
            { Object.values(currentAnalysis.SAMPLES).map((element, index) => 
              <TabPanel key={index}><CnvViewer cnv_plot_uri={element.FILE_URI}/></TabPanel> )}
          </Tabs> */}
        </div>
      );
    }

    function renderFusViewers(){
      return(
        <div className="bottom-tab-panel mb-3 ">
          <FusViewer
            project={props.projectBaseURL} // only used for gnomAD in RD
            userName={props.userName}
            // defaultFilterSet={projectFilterSet}
            // setPMFPrefix={projectSetPMFPrefix}
            //!!! initialSortBy={initialSortBy}
            //!!! setSortBy={(sortBy)=> setInitialSortBy(sortBy)}
            // selectedVariantTab={'TAB_CLINVAR'}
            // hiddenColumnsIds={analysisHiddenColumnsIds}
            // setHiddenColumnsIds={(hiddenColumnsIds)=> setAnalysisHiddenColumnsIds(hiddenColumnsIds)}
            // updateVariantTableData={(variantIndex, columnId, value) => setActiveCaseVariantData(prevActiveCaseVariantData => prevActiveCaseVariantData.map(currentVariant => (currentVariant.ROW_INDEX === variantIndex ? {...currentVariant, [columnId]:value} : currentVariant)))}
            // updateVariantTableData={(variantIndex, columnId, value) => {
            //   console.log(variantIndex, columnId, value);
            //   setActiveCaseVariantData(prevActiveCaseVariantData => prevActiveCaseVariantData.map(currentVariant => (currentVariant.ROW_INDEX === variantIndex ? {...currentVariant, [columnId]:value} : currentVariant)))
            // }}
            updateVariantTableData={(variantIndex, columnId, value) => {
              // console.log(variantIndex, columnId, value);
              setOpenCases(prevOpenCases => prevOpenCases.map( (indvCase, index) => (index === activeCaseIndexInOpenCases ? 
                indvCase.map( (pieceOfCaseInfo, infoIndex) => (infoIndex === 1 ? 
                  pieceOfCaseInfo.map( variantData => (variantData.ROW_INDEX === variantIndex ? {...variantData, [columnId]:value} : variantData))
                  : pieceOfCaseInfo))
              : indvCase)))
              // setActiveCaseVariantData(prevActiveCaseVariantData => prevActiveCaseVariantData.map(currentVariant => (currentVariant.ROW_INDEX === variantIndex ? {...currentVariant, [columnId]:value} : currentVariant)))
            }}
            setShouldBlockNavigation={e => setShouldBlockNavigation(e)}
            searchBoxValue={searchBoxValue}
            devOptions={devOptions}
            currentCaseInformation={activeCaseInfo}
            currentAnalysisInfo={activeAnalysis}
            // currentCaseNotes={activeCaseNotes}
            currentCaseNotes={openCases[activeCaseIndexInOpenCases][2] || []}
            // analysisStartedAt={openCases[activeCaseIndexInOpenCases][3] || new Date()}
            isLoadingNotes={isLoadingNotes}
            caseData={openCases[activeCaseIndexInOpenCases][1] || []} //mergedCnvData
          />
          {/* <Tabs>
            <TabList>
              { Object.values(currentAnalysis.SAMPLES).map((element, index) => 
                <Tab key={index}><span>{element.SAMPLE_TYPE}</span></Tab> )}
            </TabList>
            { Object.values(currentAnalysis.SAMPLES).map((element, index) => 
              <TabPanel key={index}><CnvViewer cnv_plot_uri={element.FILE_URI}/></TabPanel> )}
          </Tabs> */}
        </div>
      );
    }

    function renderCnvViewers(){
      // console.log('openCases: ', openCases);
      return(
        <div className="bottom-tab-panel mb-3 ">
          <CnvViewer
            project={props.projectBaseURL} // only used for gnomAD in RD
            userName={props.userName}
            // defaultFilterSet={projectFilterSet}
            // setPMFPrefix={projectSetPMFPrefix}
            //!!! initialSortBy={initialSortBy}
            //!!! setSortBy={(sortBy)=> setInitialSortBy(sortBy)}
            // selectedVariantTab={'TAB_CLINVAR'}
            // hiddenColumnsIds={analysisHiddenColumnsIds}
            // setHiddenColumnsIds={(hiddenColumnsIds)=> setAnalysisHiddenColumnsIds(hiddenColumnsIds)}
            // updateVariantTableData={(variantIndex, columnId, value) => setActiveCaseVariantData(prevActiveCaseVariantData => prevActiveCaseVariantData.map(currentVariant => (currentVariant.ROW_INDEX === variantIndex ? {...currentVariant, [columnId]:value} : currentVariant)))}
            // updateVariantTableData={(variantIndex, columnId, value) => {
            //   console.log(variantIndex, columnId, value);
            //   setActiveCaseVariantData(prevActiveCaseVariantData => prevActiveCaseVariantData.map(currentVariant => (currentVariant.ROW_INDEX === variantIndex ? {...currentVariant, [columnId]:value} : currentVariant)))
            // }}
            updateVariantTableData={(variantIndex, columnId, value) => {
              // console.log(variantIndex, columnId, value);
              setOpenCases(prevOpenCases => prevOpenCases.map( (indvCase, index) => (index === activeCaseIndexInOpenCases ? 
                indvCase.map( (pieceOfCaseInfo, infoIndex) => (infoIndex === 1 ? 
                  pieceOfCaseInfo.map( variantData => (variantData.ROW_INDEX === variantIndex ? {...variantData, [columnId]:value} : variantData))
                  : pieceOfCaseInfo))
              : indvCase)))
              // setActiveCaseVariantData(prevActiveCaseVariantData => prevActiveCaseVariantData.map(currentVariant => (currentVariant.ROW_INDEX === variantIndex ? {...currentVariant, [columnId]:value} : currentVariant)))
            }}
            setShouldBlockNavigation={e => setShouldBlockNavigation(e)}
            searchBoxValue={searchBoxValue}
            devOptions={devOptions}
            currentCaseInformation={activeCaseInfo}
            currentAnalysisInfo={activeAnalysis}
            // currentCaseNotes={activeCaseNotes}
            currentCaseNotes={openCases[activeCaseIndexInOpenCases][2] || []}
            // analysisStartedAt={openCases[activeCaseIndexInOpenCases][3] || new Date()}
            isLoadingNotes={isLoadingNotes}
            caseData={openCases[activeCaseIndexInOpenCases][1] || []} //mergedCnvData
          />
          {/* <Tabs>
            <TabList>
              { Object.values(currentAnalysis.SAMPLES).map((element, index) => 
                <Tab key={index}><span>{element.SAMPLE_TYPE}</span></Tab> )}
            </TabList>
            { Object.values(currentAnalysis.SAMPLES).map((element, index) => 
              <TabPanel key={index}><CnvViewer cnv_plot_uri={element.FILE_URI}/></TabPanel> )}
          </Tabs> */}
        </div>
      );
    }

    function renderSvViewers(pacbio){
      return(
        <div className="bottom-tab-panel mb-3 ">
          {/* {console.log('renderSV',openCases)} */}
          <SvViewer
            project={props.projectBaseURL} // only used for gnomAD in RD
            userName={props.userName}
            updateVariantTableData={(variantIndex, columnId, value) => {
              // console.log(variantIndex, columnId, value);
              setOpenCases(prevOpenCases => prevOpenCases.map( (indvCase, index) => (index === activeCaseIndexInOpenCases ? 
                indvCase.map( (pieceOfCaseInfo, infoIndex) => (infoIndex === 1 ? 
                  pieceOfCaseInfo.map( variantData => (variantData.ROW_INDEX === variantIndex ? {...variantData, [columnId]:value} : variantData))
                  : pieceOfCaseInfo))
              : indvCase)))
              // setActiveCaseVariantData(prevActiveCaseVariantData => prevActiveCaseVariantData.map(currentVariant => (currentVariant.ROW_INDEX === variantIndex ? {...currentVariant, [columnId]:value} : currentVariant)))
            }}
            setShouldBlockNavigation={e => setShouldBlockNavigation(e)}
            searchBoxValue={searchBoxValue}
            devOptions={devOptions}
            currentCaseInformation={activeCaseInfo}
            currentAnalysisInfo={activeAnalysis}
            // currentCaseNotes={activeCaseNotes}
            currentCaseNotes={openCases[activeCaseIndexInOpenCases][2] || []}
            // analysisStartedAt={openCases[activeCaseIndexInOpenCases][3] || new Date()}
            isLoadingNotes={isLoadingNotes}
            caseData={openCases[activeCaseIndexInOpenCases][1] || []} //mergedCnvData
            usepacbio={pacbio}
          />
          
        </div>
      )
    }


    // const params = useParams(); // caseId, analysisId

    // useEffect(() => {
    //   if(activeCaseId!==params.caseId) {
    //     history.push(`/${props.projectBaseURL}/${params.caseId}`);
    //   }
    // }, []);

    // // ! use both caseId and analysisId from param to get the right analysis loaded
    // // let params = useParams(); // caseId, analysisId
    // if(activeCaseId!==params.caseId){
    // //   history.push(`/${props.projectBaseURL}/${params.caseId}`);
    //   return(<h1>no data</h1>);
    // }
    let currentCase = Object.values(projectDb).find( t => t.CASE_ID===activeCaseId);
    
    if(!!currentCase && !!currentCase.ANALYSES )
      currentAnalysis = Object.values(currentCase.ANALYSES).find( t => t.ANALYSIS_ID===activeAnalysis.ANALYSIS_ID);

    // if(!openCases || !openCases[activeCaseIndexInOpenCases]){
    if(!activeAnalysis){
      // history.push(`/${props.projectBaseURL}`);
      if(!!window.location.href && !!window.location.href.split('/') && !!window.location.href.split('/')[4])
        history.push(`/${props.projectBaseURL}/${window.location.href.split('/')[4]}`);
      return(<h1>no data</h1>);
    }

    let activeAnalysisTypeLabel = Object.values(AnalysisTypeOptions).find(t => t.value ===activeAnalysis.ANALYSIS_TYPE);
    if(!!activeAnalysisTypeLabel) activeAnalysisTypeLabel=activeAnalysisTypeLabel.label;

    let viewerPanel;

    if(activeAnalysis.ANALYSIS_TYPE==='MT_Variants'){
      if(currentAnalysis !== undefined ){ //! do we need this? so far no! && !!currentAnalysis.JSON_URI
        viewerPanel = renderMTViewers();
      } else { toast.error('No Analysis Found')}
    }
    else if(activeAnalysis.ANALYSIS_TYPE==='FUS'){
      if(currentAnalysis !== undefined ){ //! do we need this? so far no! && !!currentAnalysis.JSON_URI
        viewerPanel = renderFusViewers();
      } else { toast.error('No Analysis Found')}
    }
    else if((activeAnalysis.ANALYSIS_TYPE==='CNV') | (activeAnalysis.ANALYSIS_TYPE==='CNV_Somatic')){
      if(currentAnalysis !== undefined ){ //! do we need this? so far no! && !!currentAnalysis.JSON_URI
        viewerPanel = renderCnvViewers();
      } else { toast.error('No Analysis Found')}
    }
    else if((activeAnalysis.ANALYSIS_TYPE==='SV')){
      if(currentAnalysis !== undefined){
        viewerPanel = renderSvViewers(false);
      } else { toast.error('No Analysis Found')}
    }
    else if((activeAnalysis.ANALYSIS_TYPE==='PacBioSV')){
      if(currentAnalysis !== undefined){
        viewerPanel = renderSvViewers(true);
      } else { toast.error('No Analysis Found')}
    }
    else {
      viewerPanel = renderSnvViewers();
    }

    if (props.project === "fus") {
      return(
        <div className="main-content container-fluid ">
          <div className="absolute-panel d-flex flex-column bg-mid-blue">
            {viewerPanel}
          </div>
        </div>
        )
    } else {
      return(
        <div className="main-content container-fluid ">
          <div className="absolute-panel d-flex flex-column bg-mid-blue">
            <Tabs className=" flex-grow-1 ">
              <TabPanel>
                {viewerPanel}
              </TabPanel>
              <TabList className="bottom-tabs__tab-list 1height-2rem" style={{height:`${pehnoSectionHeight}rem`}}>
                <Tab className="react-tabs__tab bottom-tabs" selectedClassName="react-tabs__tab--selected bottom-tabs--selected"><span className="px-1">{activeAnalysisTypeLabel}</span></Tab>
                {/* <div className="rd-footer fixed-bottom mt-auto py-0 show-overflow"> */}
                <div className="show-overflow 1height-2rem flex-grow-1" >
                  {getProbandPhenotypeList()}
                </div>
              </TabList>
            </Tabs>
          </div>
        </div>
      );
    }
  }


  // //? --------------------------------------------- chooseMrPheneSubject ----------------------------------

  // const chooseMrPheneSubject = () => {
  function callbackLoadingMrPheneSubjectData(subject_id, subject_project, subject_data){
    // console.log(subject_id);
    // console.log(activeCaseInfo);
    // setActiveCaseInfo({...activeCaseInfo, MRPHENE_SUBJECT_ID: subject_id})
    // debugger;
    // Object.values(subjectData.genes).forEach((gene) => {
    //   console.log(gene);
    // });

    // Object.keys(result.genes).forEach((gene) => {
    //   console.log(gene);
    // });

    Auth.currentSession().then(data => {
      let id_token = data.getIdToken().getJwtToken();
      const url_to_send_to = `${ENDPOINT_BASE}add_new_case?project=${props.project}&mrphene_subject_id=${subject_id}`;
      toast.promise(
        sendMrPheneSubjectId(url_to_send_to, id_token),
        {
          loading: 'Saving...',
          success: (data) => <>Successfully saved<br/>{data}</>,
          //  success: <b>Settings saved!</b>,
          error: (err) => `Error: ${err}`,
          //  error: <b>Could not save.</b>,
        },{
          success: {
            duration: 5000,
          },
        }
      );

    })
    .catch( e => setErrorLog([`Error in saving: ${e}`, '']));
  }

  function sendMrPheneSubjectId(url_to_send_to, id_token) {
    return new Promise(function (resolve, reject) {
      if (request) {
        request.abort();
      }
      let xhReq = new XMLHttpRequest();
      request = xhReq;

      // get a callback when the server responds
      xhReq.addEventListener("load", (oEvent) => {
        if (xhReq.status===200) {
          // console.log(xhReq.responseText);
          // toast.success(xhReq.responseText);
          // showAlert(xhReq.responseText, 0, true, 'Success!');
          // showDbOverview();
          loadVaNexDb();
          history.push(`/${props.projectBaseURL}/${activeCaseId}`);
          resolve(xhReq.responseText);
        }
        else {
          setErrorLog([xhReq.responseText,'']);
          reject();
        }
      });

      // TODO: handle error in these:
      xhReq.addEventListener("error", () => {  reject("An error occurred while transferring the file"); });
      xhReq.addEventListener("abort", () => { reject("Transfer has been canceled by the user"); });
      // xhReq.addEventListener("error", () => {  setErrorLog(['An error occurred while transferring the data','']);  });
      // xhReq.addEventListener("abort", () => { setErrorLog(['Transfer has been canceled by the user', '']);   });
      // xhReq.addEventListener("loadend",() => { setErrorLog(['Transfer finished (succeeded or not?!)'], '');   });
      // xhReq.addEventListener("loadstart",() => { console.error('Transfer started!');   });
      
      xhReq.open("POST", url_to_send_to, true);
      // xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded; charset=UTF-8");
      xhReq.setRequestHeader('Content-Type', 'application/json');
      xhReq.setRequestHeader('Accept', 'application/json');
      xhReq.setRequestHeader('Authorization','Bearer ' + id_token);

      // console.log('----');
      // console.log(fields);
      xhReq.send(JSON.stringify({CASE_ID:activeCaseId}));
    });
  }

    
  //? --------------------------------------------- Main Renders ----------------------------------


  function OuterPanel(props){
    // console.log(props)
    return(
      <>
        <div className="main-content container-fluid">
          <SplitPane split="vertical" minSize={100} maxSize={-100} defaultSize={200}>
            <div className="sidebar-splitpane-panel">
              <Tabs>
                <TabList>
                <Tab><span onClick={showDbOverview}>Data</span></Tab>
                  {/* {props.project === 'rare_disease' ?<Tab><span> Glacier</span></Tab>: null} */}
                </TabList>
                <TabPanel>
                  {/* <input className="mb-1" type="text" placeholder="Enter Case ID" value={caseIdSearchValue} onChange={(e)=>setCaseIdSearchValue(e.target.value)}/> */}
                  {/* <div className="absolute-panel scroll-div" style={{marginTop:'2em'}}> */}
                  <div className="absolute-panel scroll-div">
                    <ul className="nav ms-2 d-flex flex-column">
                      <li className="nav-item">
                        <div className="d-flex flex-row">
                          <button className="btn btn-toggle align-items-center rounded collapsed" data-bs-toggle="collapse" data-bs-target="#cases-collapse" aria-expanded="true">
                            Cases
                          </button>
                          <div className="flex-grow-1 text-end">
                            {(dbSortedByCaseId)?
                              <div className="btn m-0 p-0 text-primary" onClick={() => loadVaNexDb(false) }><i className="fas fa-sort-amount-down fa-lg pt-2 pe-2"></i></div>
                            :
                              <div className="btn m-0 p-0 text-primary" onClick={() => loadVaNexDb(true) }><i className="fas fa-sort-alpha-down fa-lg pt-2 pe-2"></i></div>
                            }
                          </div>
                        </div>
                        {RenderCaseList()}
                      </li>
                      <li className="border-top my-3"></li>
                      <li className="nav-item">
                        <button className="btn btn-toggle align-items-center rounded collapsed" data-bs-toggle="collapse" data-bs-target="#analysis-collapse" aria-expanded="true">
                          Search History
                        </button>
                        {RenderSearchHistory()}
                      </li>
                    </ul>
                  </div>
                </TabPanel>
                {/* {props.project === 'rare_disease' ?
                  <TabPanel>
                    <div className="absolute-panel scroll-div">
                      <ul className="nav ms-2 d-flex flex-column">
                        <li className="nav-item">
                          <div className="d-flex flex-row">
                            <button className="btn btn-toggle align-items-center rounded collapsed" data-bs-toggle="collapse" data-bs-target="#cases-collapse" aria-expanded="true">
                              Glacier within 30 days
                            </button>
                            <div className="flex-grow-1 text-end">
                              {(dbSortedByCaseId)?
                                <div className="btn m-0 p-0 text-primary" onClick={() => loadVaNexDb(false) }><i className="fas fa-sort-amount-down fa-lg pt-2 pe-2"></i></div>
                              :
                                <div className="btn m-0 p-0 text-primary" onClick={() => loadVaNexDb(true) }><i className="fas fa-sort-alpha-down fa-lg pt-2 pe-2"></i></div>
                              }
                            </div>
                          </div>
                          {RenderCaseList(true)}
                        </li>
                      </ul>
                    </div>
                  </TabPanel>
                  :
                  null
                  } */}
              </Tabs>
            </div>
            {props.children}
          </SplitPane>
        </div>
      </>
    );
  }


  // console.log("Render APP..");
  if(accessDenied)
    return(
      <div className="text-center d-flex justify-content-center m-5 p-5">
        <h3>Access Denied</h3>
      </div>
    );

  if (!props.loggedIn){
    return(
      <div className="text-center d-flex justify-content-center m-5 p-5">
        <div className="card mb-4 rounded-3 shadow border-secondary">
          <div className="card-header py-3 text-white bg-secondary ">
          <span className="fw-semibold me-0 px-3 fs-5" >Variant Ne<img src={logo} className="vanex-navbar-logo" alt="VaNex"/>us</span>
          </div>
          <div className="card-body">
            <h4 className="card-title m-2 p-4 fw-normal">Login Required</h4>
            <UserPane onChange={props.handleAuthChange} loggedIn={props.loggedIn} urlToPush={`/${props.projectBaseURL}`} showMinimum />
          </div>
        </div>
      </div>
    );
  }
  else {
    return (
      <React.Fragment>
        <nav className="navbar navbar-expand navbar-dark sticky-top flex-md-nowrap p-0 no-shadow bg-dark-blue">
          <div className="container-fluid d-flex flex-row flex-grow-1">
            {/* <Link to="/" className="navbar-brand fw-semibold me-0 ps-1" >VaNe<img src={logo} className="vanex-navbar-logo" alt="logo" /></Link> */}
            {/* <span onClick={ () => history.push('/')} className="navbar-brand fw-semibold me-0 ps-1" >Variant Ne<img src={logo} className="vanex-navbar-logo" alt="logo" />us</span> */}
            <span onClick={ () => history.push('/')} className="navbar-brand fw-semibold me-0 ps-1" >VaNe<img src={logo} className="vanex-navbar-logo" alt="logo" />
              <span className="project-view-version">v {process.env.REACT_APP_VERSION}</span>
            </span>
            <span onClick={ () => {if(!shouldBlockNavigation){ showDbOverview()} else {toast.error("You have unsaved notes! ")} } } className="fw-bold fs-5 text-light d-flex flex-row align-items-center justify-content-center" >
              <i className="mx-2 fs-6 fas fa-chevron-right"></i><span className="cursor-pointer no-white-space-wrap">{props.projectTitle}</span>
            </span>
            <span className="fw-bold fs-5 text-light d-flex flex-row align-items-center justify-content-center">
              {(activeCaseId!=='') ? <><i className="mx-2 fs-6 fas fa-chevron-right"></i><span className="cursor-pointer no-white-space-wrap" onClick={ () => {setViewAnalysis(false); history.push(`/${props.projectBaseURL}/${activeCaseId}`)}} >{activeCaseId}</span></> : ''}
            </span>
            <span className="fs-5 text-light d-flex flex-row align-items-center justify-content-center ">
              {(!!viewAnalysis) ? <><i className="mx-2 fs-6 fas fa-chevron-right"></i><span className="text-small no-white-space-wrap" >{activeAnalysis.ANALYSIS_NAME}{`(${activeAnalysis.ANALYSIS_TYPE})`}</span></> : ''}
            </span>
            <form className="d-flex search-bar-form flex-row align-items-center justify-content-center" onSubmit={handleSearchForm}>
              {/* <div className="btn-group">
                <button className="search-type-btn btn btn-sm btn-light mx-1 dropdown-toggle" type="button" id="searchDropdown" data-bs-toggle="dropdown" data-bs-auto-close="true" aria-expanded="false">
                  {(selectedSearchType) ? 'Search '+ selectedSearchType : 'Search Type'}
                </button>
                <ul className="dropdown-menu" aria-labelledby="searchDropdown">
                  {searchTypes.map( (type, index) => <li key={index} className="dropdown-item" onClick={() => setSelectedSearchType(type)} >{type}</li>)}
                </ul>
              </div>
              <input className="px-2 search-bar flex-grow-1" type="text"
              value={searchBoxValue} name="VaNex-search-box"
              onChange={(event) => setSearchBoxValue(event.target.value)}
              placeholder="Enter search term..." aria-label="Search" />
              //////// <div className="d-flex flex-column mx-2">
                <label className="text-light"><input type="checkbox" defaultChecked={(searchForClinVarPlot)} onChange={(e) => {this.setState({searchForClinVarPlot: e.target.checked}) }} /> ClinVar Plot</label>
                <label className="text-light"><input type="checkbox" defaultChecked={(searchForGeneInDb)} onChange={(e) => {this.setState({searchForGeneInDb: e.target.checked}) }} /> RD database</label>
              </div> ///////
              <button className="btn btn-md btn-outline-light mx-2 px-2 py-1" type="submit">Search</button>
              {(isSearchResultReady && !showSearchPanel) ? <div className="btn btn-sm btn-outline-light mx-1 px-2 py-1" style={{minWidth: 'max-content'}} onClick={() => showSearchResult()}><i className="fas fa-reply me-1"></i>Revisit Search Results</div> : ''} */}
            </form>
            <UserPane onChange={props.handleAuthChange} loggedIn={props.loggedIn} userName={props.userName} devOptions={devOptions} toggleDevOptions={() => setDevOptions(prevState => !prevState)}/>
          </div>
        </nav>

        <Switch>
          {/* <Route path={`${props.match.url}`} > */}
          {/* <Route path={`/${props.projectBaseURL}`} > */}
          <Route exact path={routeMatch.path}>
            {/* <OuterPanel children={<RenderCaseInfo caseTableTagFilter={caseTableTagFilter} setCaseTableTagFilter={e => setCaseTableTagFilter(e)}/>} /> */}
            <OuterPanel children={<RenderCaseInfo 
              loggedIn={props.loggedIn}
              userName={props.userName}
              userEmailAddress={props.emailAddress}
              isPowerUser={props.isPowerUser}
              isAdmin={props.isAdmin}
            />}
             project={props.project}
          />
          {/* {OuterPanel({children:<RenderCaseInfo/>})} */}
          </Route>
          <Route exact path={`${routeMatch.path}/add`}><RenderAddEditCaseInformation mode='add'/></Route>
          <Route exact path={`${routeMatch.path}/:caseId/edit`}><RenderAddEditCaseInformation mode='edit'/></Route>

          <Route path={`${routeMatch.path}/search`}>
            <OuterPanel children={<RenderSearchResult/>} project={props.project} />
            {/* {OuterPanel({children:<RenderSearchResult/>})} */}
          </Route>
          <Route exact path={`${routeMatch.path}/:caseId`}>
            <OuterPanel children={<RenderCaseCard/>} project={props.project} />
            {/* {OuterPanel({children:<RenderCaseCard/>})} */}
          </Route>
          <Route exact path={`${routeMatch.path}/:caseId/analysis/add`}><RenderAddEditAnalysisInformation mode='add'/></Route>
          <Route exact path={`${routeMatch.path}/:caseId/analysis/:analysisId/edit`}><RenderAddEditAnalysisInformation mode='edit'/></Route>
          {/* <Route path={`${routeMatch.path}/:caseId/analysis/:analysisId`}><RenderAnalysisTabs/></Route> */}
          <Route path={`${routeMatch.path}/:caseId/analysis/:analysisId`} render={() => RenderAnalysisTabs()} />
          {/* //! <Route path={`${routeMatch.path}/:caseId/analysis`} render={() => RenderAnalysisTabs()} /> */}
            {/* <RenderAnalysisTabs/> */}
          {/* </Route> */}
        </Switch>
      </React.Fragment>
    );
  }

}

export default withRouter(ProjectSpecificApp);





// * activeCaseInfo is like: {ID: 6, PROTOCOL: 'CD', CASE_ID: 'CD200129', CASE_STATUS: 0, N_SAMPLES: 4, …}
// CASE_ID: "CD200129"
// PROTOCOL: "CD"
// CLONALITY: "s3://nch-igm-research-rare-disease/2021/CD200129/churchill/2021-04-20/clonality"
// ID: 6
// NOTE: ""
// N_GENES: 2257
// N_PARQUET_VARIANTS: 14251
// N_SAMPLES: 4
// N_VARIANTS: 2911
// PARQUET_URI: "s3://nch-igm-research-rare-disease/2021/CD200129/churchill/2021-04-20/varhouse/2021-04-29T11-18-47/parquet/CD200129.parquet"
// SAMPLES: Array(4)
// 0: {SAMPLE_ID: 'CD200129_A435_P_01D_S-2021-002804', SAMPLE_TYPE: 'Proband', SEX: 'Female', AGE: '', AFFECTED: false, …}
// 1: {SAMPLE_ID: 'CD200129_A436_M_01D_S-2020-008619', SAMPLE_TYPE: 'Mother', SEX: 'Female', AGE: '', AFFECTED: false, …}
// 2: {SAMPLE_ID: 'CD200129_A437_F_01D_S-2021-002816', SAMPLE_TYPE: 'Father', SEX: 'Male', AGE: '', AFFECTED: false, …}
// 3: {SAMPLE_ID: 'RD200129_A438_X_01D_S-2021-011324', SAMPLE_TYPE: 'Paternal aunt', SEX: 'Female', AGE: '', AFFECTED: false, …}
// length: 4
// [[Prototype]]: Array(0)
// CASE_STATUS: 0
// V_REF: "GRCh38"


// ? min analysisColumns
// setAnalysisColumns( Object.keys(tmpVariantData[0]).map( (key) => {
//   if(key==="VANEX_TAGS"){
//     return {
//       Header: "Tag",
//       accessor: key,
//       width: 10,
//       disableResizing: true,
//       Cell: VanexTagCell,
//       setColWidth: function(inWidth){ this.width = inWidth; }
//     }
//   }
//   if(key==="VANEX_NOTES"){
//     return {
//       Header: "Note",
//       accessor: key,
//       width: 200,
//       Cell: VanexNoteCell,
//       columnStyle: {textAlign: 'center',},
//       setColWidth: function(inWidth){ this.width = inWidth; }
//     }
//   }
//   return {
//     Header: key,
//     accessor: key,
//     width: 100,
//     setColWidth: function(inWidth){ this.width = inWidth; }
//   }
// }));